<template>
    <div class="container admin-table-page">

        <!-- ==================== TÍTULO ==================== -->
        <div class="param-title-wrap niif-header">
            <div class="d-flex align-items-center w-100">
                <div class="d-flex align-items-center">
                    <b-button
                        class="page-back-btn mr-2"
                        variant="link"
                        @click="goBack"
                    >
                        <font-awesome-icon
                            :icon="['fas', 'arrow-alt-circle-left']"
                            class="back-icon"
                        />
                    </b-button>

                    <h2 class="param-title">
                        {{ tituloConsolidado || labels.title }}
                    </h2>
                </div>
            </div>
        </div>

        <!-- ==================== FILTROS ==================== -->
        <div class="param-title-wrap niif-header">
            <div
                class="d-flex align-items-center w-100"
                style="flex-wrap: wrap; gap: 8px;"
            >

                <!-- Filtros principales -->
                <div
                    class="filters-container d-flex align-items-center"
                    style="flex-wrap: wrap; gap: 8px;"
                >

                    <!-- Reporte -->
                    <b-form-select
                        v-model="dialogReportes"
                        @change="onFiltroChange"
                        class="filter-select"
                    >
                        <b-form-select-option value="">
                            {{ labels.selectReport }}
                        </b-form-select-option>

                        <option
                            v-for="reporte in reportes"
                            :key="reporte.id"
                            :value="reporte.codigo"
                        >
                            {{ reporte?.nombre }}
                        </option>
                    </b-form-select>

                    <!-- Vigencia -->
                    <b-form-select
                        v-model="dialogFechas"
                        @change="onFiltroChange"
                        class="filter-select"
                    >
                        <b-form-select-option value="">
                            {{ labels.selectValidity }}
                        </b-form-select-option>

                        <option
                            v-for="fecha in fechas"
                            :key="fecha.fecha"
                            :value="fecha.fecha"
                        >
                            {{ fecha?.fecha }}
                        </option>
                    </b-form-select>

                    <!-- Grupo -->
                    <b-form-select
                        v-model="selectedGrupo"
                        @change="(value) => filtraCompaniasPorGrupo(value)"
                        class="filter-select"
                    >
                        <option value="todos">
                            {{ labels.allGroups }}
                        </option>

                        <option
                            v-for="grupo in grupos"
                            :key="'grupo-' + grupo.id"
                            :value="grupo.id"
                        >
                            {{ grupo?.nombre }}
                        </option>
                    </b-form-select>

                    <!-- Compañía -->
                    <b-form-select
                        v-model="dialogCompanias"
                        @change="seleccionaCompania()"
                        class="filter-select"
                    >
                        <b-form-select-option value="">
                            {{ labels.selectCompany }}
                        </b-form-select-option>

                        <option
                            v-for="compania in companiasFiltradas"
                            :key="compania.id"
                            :value="compania.id"
                        >
                            {{ compania?.acronym ? compania?.acronym + ' ' : '' }}
                            {{ compania?.nombre }}
                        </option>
                    </b-form-select>

                    <!-- Dropdown de selección única para vistas -->
                    <b-dropdown
                        variant="outline-secondary"
                        class="filter-dropdown"
                        toggle-class="filter-dropdown-btn"
                        :text="selectedViewOptionText"
                    >
                        <!-- Grupo Reportes -->
                        <b-dropdown-header>Reportes</b-dropdown-header>
                        <b-dropdown-item
                            v-for="option in viewOptions.filter(o => o.group === 'Reportes')"
                            :key="option.value"
                            @click="selectViewOption(option.value)"
                            :active="selectedViewOption === option.value"
                        >
                            {{ option.text }}
                        </b-dropdown-item>

                        <b-dropdown-divider></b-dropdown-divider>

                        <!-- Grupo Información -->
                        <b-dropdown-header>Información</b-dropdown-header>
                        <b-dropdown-item
                            v-for="option in viewOptions.filter(o => o.group === 'Información')"
                            :key="option.value"
                            @click="selectViewOption(option.value)"
                            :active="selectedViewOption === option.value"
                        >
                            {{ option.text }}
                        </b-dropdown-item>
                    </b-dropdown>

                </div>

                <!-- Botones -->
                <div class="filters-container d-flex align-items-center">

                    <!-- Generar -->
                    <b-button
                        class="consult-btn"
                        @click="generar"
                        :disabled="
                            !dialogFechas ||
                            !dialogReportes ||
                            !dialogCompanias ||
                            !selectedViewOption
                        "
                    >
                        <font-awesome-icon
                            :icon="['fas', 'search']"
                            class="mr-1"
                        />

                        {{ labels.generar }}
                    </b-button>

                </div>

            </div>
        </div>

        <!-- ==================== MODAL SELECCIÓN DE EMPRESAS PARA CONSOLIDADO ==================== -->
        <b-modal
            v-model="showEmpresasModal"
            :title="labels.selectCompanies"
            size="lg"
            @hidden="showEmpresasModal = false"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog create-ajuste-dialog"
            :no-close-on-backdrop="true"
            hide-footer
                        centered
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title" style="font-size: 16px; font-weight: 600; color: #2e507a;">
                        {{ labels.selectCompaniesTitle }}
                    </div>
                    <div class="password-policy-subtitle" style="font-size: 14px; color: #6c757d;">
                        {{ labels.selectCompaniesSubtitle }}
                    </div>
                </div>

                <!-- Lista de empresas -->
                <div class="accounts-section mt-2">
                    <div v-if="companiasFiltradas.length > 0" class="accounts-list mt-1">
                        <div class="select-all-container mb-2 d-flex align-items-center justify-content-between">
                            <b-button
                                size="sm"
                                style="background-color: #2e507a; border-color: #2e507a; font-size: 13px; padding: 4px 16px; border-radius: 4px; color: white;"
                                @click="toggleSelectAllCompaniesModal"
                            >
                                {{ selectAllCompaniesModal ? labels.deselectAll : labels.selectAll }}
                            </b-button>
                            <span style="font-size: 13px; color: #6c757d;">
                                {{ labels.selected }}: <strong>{{ EmpresasConsolida.length }}</strong> / {{ companiasFiltradas.length }}
                            </span>
                        </div>

                        <div class="custom-scroll-table" style="min-height: 200px; height: auto; max-height: 300px; overflow-y: auto;">
                            <table class="table table-sm table-hover" style="font-size: 13px; margin-bottom: 0;">
                                <thead style="position: sticky; top: 0; background: #f8f9fa; z-index: 1;">
                                    <tr>
                                        <th style="width: 100px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                            {{ labels.code }}
                                        </th>
                                        <th style="font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                            {{ labels.companyName }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="compania in companiasFiltradas"
                                        :key="compania.id"
                                        @click="toggleCompanySelectionModal(compania)"
                                        :class="{'table-active-blue': isCompanySelectedModal(compania)}"
                                        style="cursor: pointer; border-radius: 8px;"
                                    >
                                        <td style="padding: 5px 8px; border-radius: 8px 0 0 8px;">
                                            <strong>{{ compania?.acronym || compania?.codigo || '' }}</strong>
                                        </td>
                                        <td style="padding: 5px 8px; border-radius: 0 8px 8px 0;" :title="compania.nombre">
                                            {{ compania?.nombre }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div v-else class="text-center py-4" style="height: 200px; display: flex; align-items: center; justify-content: center;">
                        <span class="text-muted" style="font-size: 13px;">{{ labels.noCompaniesAvailable }}</span>
                    </div>
                </div>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button
                        class="mr-2 reset-btn-secondary"
                        @click="closeEmpresasModal"
                        :disabled="isSavingCompanies"
                        style="font-size: 14px; padding: 6px 24px;"
                    >
                        {{ labels.close }}
                    </b-button>
                    <b-button
                        class="reset-btn-primary"
                        @click="confirmEmpresasSelectionModal"
                        :disabled="isSavingCompanies || EmpresasConsolida.length === 0"
                        style="font-size: 14px; padding: 6px 24px;"
                    >
                        {{ labels.confirmSelection }}
                    </b-button>
                </div>
            </div>
        </b-modal>

        <!-- ========================================================= -->
        <!-- ==================== CONTENIDO PRINCIPAL ================= -->
        <!-- ========================================================= -->
        <div class="admin-table-block mt-4">

            <!-- ==================== BALANCE ==================== -->
            <div v-if="mostrarBalance">
                <CorporateDataTable
                    :items="balanceFiltrado"
                    :fields="balanceFields"
                    :labels="tableLabels"
                    :loading="isLoading"
                    :default-per-page="balanceFiltrado.length || 10"
                    :page-options="[balanceFiltrado.length || 10]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="true"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="balanceFilterDefs"
                    :show-pagination="false"
                    :show-rows-per-page="false"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right">
                            <select
                                v-if="mostrarSelectorMonedaBalanceTabla"
                                v-model="monedaBalanceSeleccion"
                                @change="onCambioMonedaBalance"
                                class="form-control form-control-sm"
                                style="min-width: 165px; max-width: 165px;"
                            >
                                <option
                                    v-for="option in monedaBalanceOptions"
                                    :key="option.value"
                                    :value="option.value"
                                >
                                    {{ option?.text }}
                                </option>
                            </select>
                            <b-button
                                v-if="fgl_excel && balanceFiltrado.length > 0"
                                @click="excel(1)"
                                class="table-toolbar-export-btn"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'file-excel']"
                                    class="mr-1"
                                />
                                {{ labels.exportExcel }}
                            </b-button>
                        </div>
                    </template>

                    <template #cell(accionDetalle)="data">
                        <b-button
                            style="background-color: #1f4f83; width: 30px; height: 30px;"
                            class="md-fab md-primary table-action-btn"
                            @click="f_muestra(data.item)"
                        >
                            <i><font-awesome-icon :icon="['fas', 'eye']" size="xs" style="color: white;"/></i>
                        </b-button>
                    </template>

                    <template #empty-state>
                        <div class="text-center py-5">
                            <font-awesome-icon
                                :icon="['fas', 'file-alt']"
                                size="4x"
                                class="text-muted mb-3"
                                style="opacity: 0.3;"
                            />
                            <p class="h4 text-muted">
                                {{ labels.empty }}
                            </p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>

            <!-- ==================== CONSOLIDADO ==================== -->
            <div v-if="mostrarConsolidado">
                <CorporateDataTable
                    :items="balanceFiltrado"
                    :fields="consolidadoFields"
                    :labels="tableLabels"
                    :loading="isLoading"
                    :default-per-page="balanceFiltrado.length || 10"
                    :page-options="[balanceFiltrado.length || 10]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="true"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="consolidadoFilterDefs"
                    :show-pagination="false"
                    :show-rows-per-page="false"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right d-flex align-items-center" style="gap: 8px; flex-wrap: wrap;">

							<!-- Selector de moneda -->
							<b-form-select
								v-if="mostrarSelectorMonedaConsolidado"
								v-model="monedaBalanceSeleccion"
								@change="onCambioMonedaConsolidado"
								class="form-control form-control-sm"
								style="min-width: 165px; max-width: 165px;"
							>
								<option
									v-for="option in monedaBalanceOptions"
									:key="'reporte-' + option.value"
									:value="option.value"
								>
									{{ option?.text }}
								</option>
							</b-form-select>

                            <!-- Switch Normal / Combinado -->
                            <div class="compact-toggle-container d-flex align-items-center" style="gap: 8px;">
                                <span style="font-size: 13px; color: #495057; font-weight: 500;">{{ vistaConsolidado === 'Normal' ? labels.normal : labels.combined }}</span>
                                <label class="compact-switch" style="margin: 0;">
                                    <input type="checkbox" v-model="vistaConsolidadoBool">
                                    <span class="compact-slider"></span>
                                </label>
                            </div>

                            <!-- Exportar Excel -->
                            <b-button
                                v-if="fgl_excel && balanceFiltrado.length > 0"
                                @click="excel(3)"
                                class="table-toolbar-export-btn"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'file-excel']"
                                    class="mr-1"
                                />
                                {{ labels.exportExcel }}
                            </b-button>

						<!-- Botón Detalle General -->
						<b-button
							v-if="balanceFiltrado.length > 0"
							@click="excelDetalleCompleto()"
							class="table-toolbar-export-btn"
							style="background-color: #FF924C !important; border-color: #FF924C !important;"
						>
							<font-awesome-icon
								:icon="['fas', 'file-alt']"
								class="mr-1"
							/>
							Detalle General
						</b-button>

                        </div>
                    </template>

                    <template #cell(accionDetalle)="data">
                        <b-button
                            style="background-color: #1f4f83; width: 30px; height: 30px;"
                            class="md-fab md-primary table-action-btn"
                            @click="f_muestra(data.item)"
                        >
                            <i><font-awesome-icon :icon="['fas', 'eye']" size="xs" style="color: white;"/></i>
                        </b-button>
                    </template>

                    <template #empty-state>
                        <div class="text-center py-5">
                            <font-awesome-icon
                                :icon="['fas', 'file-alt']"
                                size="4x"
                                class="text-muted mb-3"
                                style="opacity: 0.3;"
                            />
                            <p class="h4 text-muted">
                                {{ labels.empty }}
                            </p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>

            <!-- ==================== COMPARATIVO ==================== -->
            <div v-if="mostrarComparativo">
                <CorporateDataTable
                    :items="balanceFiltrado"
                    :fields="comparativoFields"
                    :labels="tableLabels"
                    :loading="isLoading"
                    :default-per-page="balanceFiltrado.length || 10"
                    :page-options="[balanceFiltrado.length || 10]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="true"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="comparativoFilterDefs"
                    :show-pagination="false"
                    :show-rows-per-page="false"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right">
                            <b-button
                                v-if="fgl_excel && balanceFiltrado.length > 0"
                                @click="excel(2)"
                                class="table-toolbar-export-btn"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'file-excel']"
                                    class="mr-1"
                                />
                                {{ labels.exportExcel }}
                            </b-button>
                        </div>
                    </template>

                    <template #cell(accionDetalle)="data">
                        <b-button
                            style="background-color: #1f4f83; width: 30px; height: 30px;"
                            class="md-fab md-primary table-action-btn"
                            @click="f_muestra(data.item)"
                        >
                            <i><font-awesome-icon :icon="['fas', 'eye']" size="xs" style="color: white;"/></i>
                        </b-button>
                    </template>

                    <template #empty-state>
                        <div class="text-center py-5">
                            <font-awesome-icon
                                :icon="['fas', 'file-alt']"
                                size="4x"
                                class="text-muted mb-3"
                                style="opacity: 0.3;"
                            />
                            <p class="h4 text-muted">
                                {{ labels.empty }}
                            </p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>

            <!-- ==================== NOTAS ==================== -->
            <div v-if="mostrarNotas">
                <CorporateDataTable
                    :items="notasEF"
                    :fields="notasFields"
                    :labels="tableLabels"
                    :loading="isLoading"
                    :default-per-page="notasEF.length || 10"
                    :page-options="[notasEF.length || 10]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="true"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="notasFilterDefs"
                    :show-pagination="false"
                    :show-rows-per-page="false"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right">
                            <b-button
                                variant="outline-primary"
                                @click="f_todas_notas"
                                class="table-toolbar-export-btn"
                                style="background-color: #28a745 !important; border-color: #28a745 !important;"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'file-word']"
                                    class="mr-1"
                                />
                                {{ labels.todas }}
                            </b-button>
                        </div>
                    </template>

                    <template #cell(accionEditar)="data">
                        <b-button
                            style="background-color: #FF924C; width: 30px; height: 30px;"
                            class="md-fab md-primary table-action-btn"
                            @click="f_modifica_nota(data.item)"
                        >
                            <i><font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs"/></i>
                        </b-button>
                    </template>

                    <template #cell(accionVer)="data">
                        <b-button
                            style="background-color: #1f4f83; width: 30px; height: 30px;"
                            class="md-fab md-primary table-action-btn"
                            @click="f_muestra_nota(data.item)"
                        >
                            <i><font-awesome-icon :icon="['fas', 'eye']" size="xs" style="color: white;"/></i>
                        </b-button>
                    </template>

                    <template #empty-state>
                        <div class="text-center py-5">
                            <font-awesome-icon
                                :icon="['fas', 'file-alt']"
                                size="4x"
                                class="text-muted mb-3"
                                style="opacity: 0.3;"
                            />
                            <p class="h4 text-muted">
                                {{ labels.empty }}
                            </p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>

            <!-- ==================== INFORMACIÓN (VALOR MANUAL) ==================== -->
            <div v-if="mostrarInformacion">
                <CorporateDataTable
                    :items="a_detalle"
                    :fields="informacionFields"
                    :labels="tableLabels"
                    :loading="isLoading"
                    :default-per-page="a_detalle.length || 10"
                    :page-options="[a_detalle.length || 10]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="true"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="informacionFilterDefs"
                    :show-pagination="false"
                    :show-rows-per-page="false"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right">
                            <b-button
                                v-if="fgl_excel"
                                @click="excel(4)"
                                class="table-toolbar-export-btn"
                            >
                                <font-awesome-icon
                                    :icon="['fas', 'file-excel']"
                                    class="mr-1"
                                />
                                {{ labels.exportExcel }}
                            </b-button>
                        </div>
                    </template>

                    <template #cell(accionEditar)="data">
                        <b-button
                            style="background-color: #FF924C; width: 30px; height: 30px;"
                            class="md-fab md-primary table-action-btn"
                            @click="f_actualiza_nota(data.item)"
                            :disabled="isVigenciaBloqueada"
                        >
                            <i><font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs"/></i>
                        </b-button>
                    </template>

                    <template #empty-state>
                        <div class="text-center py-5">
                            <font-awesome-icon
                                :icon="['fas', 'file-alt']"
                                size="4x"
                                class="text-muted mb-3"
                                style="opacity: 0.3;"
                            />
                            <p class="h4 text-muted">
                                {{ labels.empty }}
                            </p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>

            <!-- ========================================================= -->
            <!-- ==================== SIN SELECCIÓN ====================== -->
            <!-- ========================================================= -->
            <div
                v-if="
                    !mostrarBalance &&
                    !mostrarComparativo &&
                    !mostrarConsolidado &&
                    !mostrarNotas &&
                    !mostrarInformacion
                "
            >
                <CorporateDataTable
                    :items="[]"
                    :fields="[]"
                    :labels="tableLabels"
                    :loading="false"
                    :default-per-page="10"
                    :page-options="[10]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="false"
                    :allow-column-toggle="false"
                    :enable-sorting="false"
                    :show-pagination="false"
                    :show-rows-per-page="false"
                >
                    <template #empty-state>
                        <div class="text-center py-5">
                            <img
                                src="../../assets/imgs/file-2.svg"
                                alt="warning"
                                class="mb-3"
                                style="opacity: 0.3; width: 80px;"
                            />
                            <p class="h4 text-muted">
                                {{ labels.selectCriteria }}
                            </p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>

        </div>

        <!-- ==================== MODAL INFORMACIÓN (PARRAFO) ==================== -->
        <b-modal
            v-model="showDialog"
            :title="f1_titulo()"
            size="xl"
            @hidden="showDialog = false"
            header-class="modal-header-custom"
            footer-class="modal-footer-custom"
            scrollable
        >
            <!-- TÍTULO DEL PÁRRAFO -->
            <b-row>
                <b-col cols="4" class="text-left border">
                    <h4><b><i>{{ labels.parrafo }}</i></b></h4>
                </b-col>
                <b-col cols="8" class="text-left border">
                    <h4><b><i>{{ formParrafo?.parrafo }}</i></b></h4>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="4" class="text-left border">
                    <h4><b><i>{{ labels.tipo }}</i></b></h4>
                </b-col>
                <b-col cols="8" class="text-left border">
                    <h4><b><i>{{ formParrafo?.tipo }}</i></b></h4>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="4" class="text-left border">
                    <h4><b><i>{{ labels.parrafo_titulo }}</i></b></h4>
                </b-col>
                <b-col cols="8" class="text-left border">
                    <h4><b><i>{{ formParrafo?.titulo }}</i></b></h4>
                </b-col>
            </b-row>

            <!-- TABLA TBM (SOLO PARA TIPO TBM) -->
            <div v-if="formParrafo?.tipo === 'TBM'">
                <b-row class="mt-4">
                    <b-col cols="12">
                        <div class="tbm-table-container p-4 border rounded bg-light">
                            <label class="d-block fw-bold fs-5 mb-3 text-center">
                                <b>Tabla: {{ formParrafo?.titulo || 'Datos de Tabla' }}</b>
                            </label>
                            <div class="table-responsive"
                                v-if="tbmTableData.columns?.length > 0 && tbmTableData.rows.length > 0">
                                <table class="table table-bordered table-sm table-editable">
                                    <thead class="thead-light">
                                        <tr>
                                            <th style="min-width: 200px; background-color: #e9ecef; font-weight: bold; vertical-align: middle;">
                                                Descripción
                                            </th>
                                            <th v-for="col in tbmTableData.columns" :key="'col-' + col.columna"
                                                style="min-width: 150px; background-color: #e9ecef; font-weight: bold; text-align: center; vertical-align: middle;">
                                                {{ col?.descripcion }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="fila in tbmTableData.rows" :key="'fila-' + fila.fila"
                                            class="tbm-table-row">
                                            <td style="background-color: #f8f9fa; font-weight: bold; vertical-align: middle;">
                                                {{ fila?.descripcion }}
                                            </td>
                                            <td v-for="col in tbmTableData.columns"
                                                :key="'cell-' + fila.fila + '-' + col.columna"
                                                class="tbm-table-cell">
                                                <b-form-input
                                                    v-model="tbmTableData.values[`${fila.fila}-${col.columna}`]"
                                                    @input="onTbmCellChange(fila.fila, col.columna, $event)"
                                                    size="sm" class="text-right cell-input" placeholder="0"
                                                    :id="'tbm-cell-' + fila.fila + '-' + col.columna"
                                                    :disabled="isVigenciaBloqueada"
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-else class="text-center p-4">
                                <p class="text-muted">No se encontraron datos de tabla configurados.</p>
                            </div>
                            <div class="text-center mt-4">
                                <b-button class="md-primary md-raised" @click="guardarTablaTBM()" :disabled="isVigenciaBloqueada">
                                    <i>save</i> Guardar Tabla
                                </b-button>
                                <b-button class="md-accent" @click="showDialog = false; mostrarInformacion = true">
                                    <i>close</i> Cerrar
                                </b-button>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>

            <!-- FORMULARIO PARA TIPOS DE TEXTO -->
            <div v-else>
                <!-- Texto HTML con editor -->
                <b-row v-if="formParrafo?.texto">
                    <b-col cols="4" class="text-left border">
                        <h4><b><i>{{ labels.parrafo_texto }}</i></b></h4>
                    </b-col>
                    <b-col cols="8" class="border">
                        <RichTextEditor ref="textEditor" v-model="formParrafo.texto_html" :height="400"
                            placeholder="Edite el texto aquí..." @input="f_cambia_texto_html"
                            @change="f_cambia_texto_html" />
                        <input type="hidden" v-model="formParrafo.texto" />
                    </b-col>
                </b-row>

				<!-- Campos variables -->
				<template v-for="i in 10">
					<b-row v-if="formParrafo[`campo${i-1}`]" :key="'campo-' + i">
						<b-col cols="4" class="text-left border">
							<h4><b><i>{{ i-1 }}) {{ formParrafo[`campo${i-1}`] }}</i></b></h4>
						</b-col>
						<b-col cols="8" class="border">
							<h4><input v-model="formParrafo[`valor_campo${i-1}`]" type="text" :disabled="isVigenciaBloqueada"></h4>
						</b-col>
					</b-row>
				</template>

                <!-- Campos TBLM -->
                <span v-for="(celda, idx) in formParrafo.TBLM" :key="'tblm-' + idx">
                    <b-row>
                        <b-col cols="4" class="text-left border">
                            <h4><b><i>{{ celda?.descripcion }}</i></b></h4>
                        </b-col>
                        <b-col cols="8" class="border">
                            <h4><input v-model="celda.valor" type="text" :disabled="isVigenciaBloqueada"></h4>
                        </b-col>
                    </b-row>
                </span>

                <div class="mt-4">
                    <b-button v-if="formParrafo?.texto || formParrafo.TBLM" class="md-primary md-raised"
                        @click="grabeNotaParrafo()" :disabled="isVigenciaBloqueada">
                        <i>save</i> Guardar
                    </b-button>
                    <b-button class="md-accent" @click="showDialog = false; mostrarInformacion = true">
                        <i>close</i> Cerrar
                    </b-button>
                </div>
            </div>
        </b-modal>

        <!-- ==================== MODAL CUENTAS ==================== -->
        <b-modal
            v-model="showDialogCuenta"
            size="xl"
            @hidden="showDialogCuenta = false"
            header-class="modal-header-custom"
            footer-class="modal-footer-custom"
            scrollable
        >
            <template #modal-title>
                <div class="text-center">
                    <h3><b><i>{{ f2_titulo() }}</i></b></h3>
                </div>
            </template>

            <CorporateDataTable
                :items="cuentas"
                :fields="cuentasFields"
                :labels="tableLabels"
                :loading="false"
                :default-per-page="cuentas.length || 10"
                :page-options="[cuentas.length || 10]"
                :narrow="false"
                :table-min-height="300"
                :table-max-height="500"
                :show-search="true"
                :allow-column-toggle="true"
                :enable-sorting="true"
                :show-pagination="false"
                :show-rows-per-page="false"
            />

            <template #footer>
                <b-button variant="secondary" @click="showDialogCuenta = false">
                    {{ labels.close }}
                </b-button>
                <b-button v-if="fgl_excel" @click="excel(4)" variant="primary">
                    <font-awesome-icon :icon="['fas', 'file-excel']" class="mr-1" />
                    {{ labels.exportExcel }}
                </b-button>
            </template>
        </b-modal>

        <!-- ==================== MODAL DE PROGRESO ==================== -->
        <b-modal v-model="showGeneratingModal" title="Generando Detalle" hide-footer centered
            no-close-on-backdrop no-close-on-esc>
            <div class="text-center">
                <b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
                <h5 class="mt-3">
                    <b><i>{{ generatingMessage }}</i></b>
                </h5>
                <p class="mt-2">{{ generatingSubMessage }}</p>
                <b-progress v-if="generatingProgress >= 0" class="mt-3">
                    <b-progress-bar :value="generatingProgress" :label="`${generatingProgress}%`"
                        variant="primary" striped animated>
                    </b-progress-bar>
                </b-progress>
            </div>
        </b-modal>

        <!-- ==================== MODAL DE PROGRESO PARA WORD ==================== -->
        <b-modal v-model="showGeneratingWordModal" title="Generando Documento Word" hide-footer centered
            no-close-on-backdrop no-close-on-esc>
            <div class="text-center">
                <b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
                <h5 class="mt-3">
                    <b><i>{{ generatingWordMessage }}</i></b>
                </h5>
                <p class="mt-2">{{ generatingWordSubMessage }}</p>
                <b-progress v-if="generatingWordProgress >= 0" class="mt-3">
                    <b-progress-bar :value="generatingWordProgress" :label="`${generatingWordProgress}%`"
                        variant="primary" striped animated>
                    </b-progress-bar>
                </b-progress>
            </div>
        </b-modal>

    </div>
</template>
<script>
import Balance from "@/services/BalanceNiif"
import Currency from "@/services/Currency"
import Grupo from "@/services/Grupo"
import BotonesControl from "@/services/BotonesControl"
import CorporateDataTable from '../utils/CorporateDataTable.vue'
import RichTextEditor from '@/components/RichTextEditor.vue' 
import * as XLSX from "exceljs"
import { Document, Packer, Paragraph, TextRun, AlignmentType } from "docx"
import { Table, TableRow, TableCell } from "docx"
const ordenefechas = (arreglo = undefined) => {
 return [...arreglo]?.sort((a, b) => a - b) }
export default {
	name: "BalanceNiif",
	components: {
        CorporateDataTable,
		RichTextEditor
	},
	data: () => ({
		// ==================== SELECCIÓN DE VISTA ====================
		selectedViewOption: null,
		viewOptions: [
			{ value: 'balance', text: 'Balance', group: 'Reportes' },
			{ value: 'consolidado', text: 'Consolidado', group: 'Reportes' },
			{ value: 'comparativo', text: 'Comparativo', group: 'Reportes' },
			{ value: 'notas', text: 'Notas', group: 'Información' },
			{ value: 'informacion', text: 'Valor Manual', group: 'Información' }
		],

		// ==================== MODAL DE EMPRESAS ====================
		showEmpresasModal: false,
		selectAllCompaniesModal: false,
		isSavingCompanies: false,
		fromButtonGenerate: false,

		// ==================== TIPOS DE VISTA ====================
		mostrarBalance: false,
		mostrarComparativo: false,
		mostrarConsolidado: false,
		mostrarNotas: false,
		mostrarInformacion: false,

		// ==================== EXISTENTE (SE MANTIENE) ====================
		// Estos ya existen en tu código, solo asegúrate de que estén
		showDialog: false,
		showDialogCuenta: false,
		showGeneratingModal: false,
		showGeneratingWordModal: false,
		isLoading: false,
		isEmpty: true,
		generado: false,
		fgl_excel: true,
		error: false,

		dialogReportes: "",
		dialogFechas: "",
		dialogCompanias: "",
		selectedGrupo: "todos",
		codReporte: '',
		vigencia: '',
		idCompania: 0,

		reportes: [],
		fechas: [],
		grupos: [],
		companias: [],
		companiasFiltradas: [],
		companiaUsuario: [],
		currency: [],
		tasasCambio: [],
		listGrupos: [],
		GruposConsolida: [],

		balance: [],
		searched: [],
		notasEF: [],
		cuentas: [],
		a_detalle: [],
		a_detalle_columnas: [],
		a_detalle_cuentas: [],
		a_detalle_niif: [],
		a_detalle_filas: [],
		a_detalle_tabla: [],
		a_detalle_texto: [],
		a_informacion_tblm: [],
		a_informacion_txfc: [],
		a_informacion_txfg: [],
		a_informacion_txvc: [],
		a_informacion_txvg: [],
		a_Paragraph: [],
		a_titulos: [],
		a_informacion: [],

		EmpresasConsolida: [],
		EmpresasConsolidaExcel: [],
		empresasSeleccion: false,
		columnas: 0,
		titulo_columna: [],
		vistaConsolidado: 'Normal',
		monedaBalanceSeleccion: 'funcional1',

		formParrafo: '',
		formNotas: {},
		formCuentas: {},
		tbmTableData: {
			columns: [],
			rows: [],
			values: {}
		},

		generatingMessage: '',
		generatingSubMessage: '',
		generatingProgress: 0,
		generatingWordMessage: '',
		generatingWordSubMessage: '',
		generatingWordProgress: 0,

		saldosTBA: [],
		saldosTBT: [],
		saldosTBC: [],
		saldosNiifTNA: [],
		saldosNiifTNT: [],
		saldosNiifTNC: [],

		moneda: '',
		cmoneda: 0,
		amoneda: 0,
		tasa_cambio: 1,
		codigoCompanias: "",
		tituloConsolidado: "",
		vistaActiva: 'balance',
		mostrarColumnas: {
			saldo: true,
			funcional: true,
			alterna: true
		}
	}),
	computed: {
		// ==================== NUEVO: TEXTO DEL DROPDOWN ====================
		selectedViewOptionText() {
			if (!this.selectedViewOption) return this.$store.state._language == "es-ES" ? "Seleccione Vista" : "Select View"
			const option = this.viewOptions.find(opt => opt.value === this.selectedViewOption)
			return option ? option.text : this.$store.state._language == "es-ES" ? "Seleccione Vista" : "Select View"
		},

		// ==================== NUEVO: BALANCE FILTRADO ====================
		balanceFiltrado() {
			if (!this.balance || this.balance.length === 0) return []
			return this.balance
		},

		// ==================== NUEVO: VIGENCIA BLOQUEADA ====================
		isVigenciaBloqueada() {
			return this.dialogFechas ? !this.$store.getters.isPeriodoEnabled(this.dialogFechas) : false
		},

		labels() {
			const monedaFuncional = this.currency.find(moneda => moneda.isFuncional == 1);
			const acronimoFuncional = monedaFuncional ? monedaFuncional.acronimo : 'USD';
			const monedaAlterna = this.currency.find(moneda => moneda.isFuncional != 1);
			const acronimoAlterna = monedaAlterna ? monedaAlterna.acronimo : 'COP';
			const acronimoInterna = 'USD';
			const acronimoInternaAlterna = 'COP';
			if (this.$store.state._language == "es-ES") {
				return {
					title: this.f_titulo() || "BALANCE",
					codigo: "Codigo",
					nota: "Numero",
					parrafo: "Parrafo",
					parrafo_titulo: "Titulo",
					parrafo_texto: "Texto",
					tipo: "Tipo",
					descripcion: "Descripcion / Niif (IFRS)",
					descripcion_nota: "Descripcion",
					cuenta: "Cuenta",
					descripcion_cuenta: "Descripcion",
					saldo_periodo_anterior: "Saldo Periodo Anterior",
					saldo_actual: this.mostrarColumnas.saldo ? "Local" : "",
					funcional1: this.mostrarColumnas.funcional ? `Funcional ${acronimoFuncional}` : "",
					funcional2: this.mostrarColumnas.alterna ? `Funcional ${acronimoAlterna}` : "",
					promedio1: this.mostrarColumnas.funcional ? `Prom-${acronimoFuncional}` : "",
					promedio2: this.mostrarColumnas.alterna ? `Prom-${acronimoAlterna}` : "",
					interna1: this.mostrarColumnas.funcional ? `Interna ${acronimoInterna}` : "",
					interna2: this.mostrarColumnas.alterna ? `Interna ${acronimoInternaAlterna}` : "",
					saldo_periodo_actual: "Saldo A",
					diferencia: "Diferencia",
					funcional_dif: "Dif Funcional",
					alterna_dif: "Dif Alterna",
					compania: "Compañia",
					empty: "Sin Seleccion",
					notFoundMessage: "Sin Informacion",
					generar: "Generar",
					todas: "Genera Notas",
					ajustes: "Ajustes",
					consolidado: "Consolidado",
					moneda: "Moneda",
					select: "Seleccione...",
					allGroups: "Todos los grupos",
					// ==================== NUEVOS LABELS ====================
					selectReport: "Seleccione Reporte",
					selectValidity: "Seleccione Vigencia",
					selectCompany: "Seleccione Compañía",
					normal: "Normal",
					combined: "Combinado",
					selectCompanies: "Empresas para consolidar",
					selectCompaniesTitle: "Selección de empresas",
					selectCompaniesSubtitle: "Seleccione las empresas que desea consolidar",
					code: "Código",
					companyName: "Nombre",
					confirmSelection: "Confirmar selección",
					noCompaniesAvailable: "No hay empresas disponibles",
					selectAll: "Seleccionar todas",
					deselectAll: "Deseleccionar todas",
					selected: "Seleccionadas",
					exportExcel: "Exportar Excel",
					selectCriteria: "Seleccione un reporte, vigencia y compañía para generar la información",
					save: "Guardar",
					close: "Cerrar",
					noSort: "Sin orden",
					sortAsc: "A-Z / Menor a mayor",
					sortDesc: "Z-A / Mayor a menor",
					columns: "Columnas",
					showAllColumns: "Mostrar todas",
					filters: "Filtros",
					clearFilters: "Limpiar filtros",
					rowsPerPage: "Filas por página:",
					searchPlaceholder: "Buscar en la tabla...",
					noData: "No hay datos disponibles",
					noMatches: "No se encontraron resultados",
					edit: "Editar",
					monto: "Valor",
				}
			} else {
				return {
					title: this.f_titulo() || "NIIF CHECKING BALANCE",
					codigo: "Code",
					cuenta: "Account",
					descripcion_cuenta: "Description",
					descripcion_nota: "Descripcion",
					nota: "Number",
					parrafo: "Paragrah",
					parrafo_titulo: "Heading",
					parrafo_texto: "Text",
					tipo: "Kind",
					descripcion: "Description",
					saldo_actual: this.mostrarColumnas.saldo ? "Local" : "",
					funcional1: this.mostrarColumnas.funcional ? `Functional ${acronimoFuncional}` : "",
					funcional2: this.mostrarColumnas.alterna ? `Functional ${acronimoAlterna}` : "",
					promedio1: this.mostrarColumnas.funcional ? `Avg-${acronimoFuncional}` : "",
					promedio2: this.mostrarColumnas.alterna ? `Avg-${acronimoAlterna}` : "",
					interna1: this.mostrarColumnas.funcional ? `Internal ${acronimoInterna}` : "",
					interna2: this.mostrarColumnas.alterna ? `Internal ${acronimoInternaAlterna}` : "",
					saldo_periodo_anterior: "Previous Period Balance",
					saldo_periodo_actual: "Current Period Balance",
					diferencia: "Difference",
					funcional_dif: "Dif Funcional",
					alterna_dif: "Dif Alternate",
					monto: "Amount",
					compania: "Company",
					empty: "Without Information",
					notFoundMessage: "Without Information",
					generar: "Trigger",
					todas: "All Notes",
					ajustes: "Settings",
					consolidado: "Consolidated",
					moneda: "Currency",
					select: "Select...",
					allGroups: "All groups",
					// ==================== NUEVOS LABELS ====================
					selectReport: "Select Report",
					selectValidity: "Select Validity",
					selectCompany: "Select Company",
					normal: "Normal",
					combined: "Combined",
					selectCompanies: "Companies to consolidate",
					selectCompaniesTitle: "Company Selection",
					selectCompaniesSubtitle: "Select the companies you want to consolidate",
					code: "Code",
					companyName: "Name",
					confirmSelection: "Confirm selection",
					noCompaniesAvailable: "No companies available",
					selectAll: "Select all",
					deselectAll: "Deselect all",
					selected: "Selected",
					exportExcel: "Export Excel",
					selectCriteria: "Select a report, validity and company to generate the information",
					save: "Save",
					close: "Close",
					noSort: "No sorting",
					sortAsc: "A-Z / Low to high",
					sortDesc: "Z-A / High to low",
					columns: "Columns",
					showAllColumns: "Show all",
					filters: "Filters",
					clearFilters: "Clear filters",
					rowsPerPage: "Rows per page:",
					searchPlaceholder: "Search in table...",
					noData: "No data available",
					noMatches: "No results found",
					edit: "Edit",
				}
			}
		},

		// ==================== NUEVO: TABLE LABELS ====================
		tableLabels() {
			return {
				noRow: this.labels.noData,
				noMatches: this.labels.noMatches,
				searchPlaceholder: this.labels.searchPlaceholder,
				rowsPerPage: this.labels.rowsPerPage,
				noSort: this.labels.noSort,
				sortAsc: this.labels.sortAsc,
				sortDesc: this.labels.sortDesc,
				columns: this.labels.columns,
				showAllColumns: this.labels.showAllColumns,
				filters: this.labels.filters,
				clearFilters: this.labels.clearFilters
			}
		},

		// ==================== NUEVO: FIELDS PARA TABLAS ====================
		balanceFields() {
			const fields = [
				{ key: 'descripcion', label: this.labels.descripcion, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle', minWidth: '300px' },
				{ key: 'saldo_actual', label: this.labels.saldo_actual, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) },
				{ key: 'funcional1', label: this.labelFuncionalSeleccionada, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) },
				{ key: 'interna1', label: this.labelInternaSeleccionada, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) }
			]
			if (this.vistaActiva === 'funcional') {
				fields.push({ key: 'promedio1', label: this.labels.promedio1, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) })
			}
			fields.push({ key: 'accionDetalle', label: '', thClass: 'text-center', tdClass: 'text-center', sortable: false, minWidth: '50px' })
			return fields
		},

		balanceFilterDefs() {
			return [
				{ key: 'descripcion', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar descripción...' : 'Filter description...' }
			]
		},

		consolidadoFields() {
			const fields = [
				{ key: 'descripcion', label: this.labels.descripcion, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle', minWidth: '250px' }
			]

			// Para cada compañía: Saldo
			for (let i = 1; i <= this.columnas; i++) {
				const nombreEmpresa = this.titulo_columna[i - 1] || `Empresa ${i}`
				const sufijo = this.monedaBalanceSeleccion === 'funcional2' ? '_m2' : ''
				fields.push({
					key: `c${i}${sufijo}`,
					label: nombreEmpresa,
					sortable: true,
					thClass: 'text-right',
					tdClass: 'text-right align-middle',
					minWidth: '120px',
					formatter: (value) => this.formato_consol(value)
				})
			}

			const sufijo = this.monedaBalanceSeleccion === 'funcional2' ? '_m2' : ''
			fields.push(
				{ key: `ajustes${sufijo}`, label: this.labels.ajustes, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '120px', formatter: (value) => this.formato_consol(value) },
				{ key: `total${sufijo}`, label: this.labels.consolidado, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '120px', formatter: (value) => this.formato_consol(value) }
			)

			if (this.vistaConsolidado === 'Combinado') {
				fields.push(
					{ key: `combinado${sufijo}`, label: this.labels.combined || 'Combinado', sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '120px', formatter: (value) => this.formato_consol(value) },
					{ key: `total_combinado${sufijo}`, label: 'Total Combinado', sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '120px', formatter: (value) => this.formato_consol(value) }
				)
			}

			// ELIMINAR esta línea que agrega la columna del ojo
			// fields.push({ key: 'accionDetalle', label: '', thClass: 'text-center', tdClass: 'text-center', sortable: false, minWidth: '50px' })

			return fields
		},

		consolidadoFilterDefs() {
			return [
				{ key: 'descripcion', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar descripción...' : 'Filter description...' }
			]
		},

		comparativoFields() {
			const moneda = this.currency.find((moneda) => moneda.isFuncional == 1)
			const acronimo = moneda ? moneda.acronimo : 'USD'
			const vigenciaAnterior = this.vigencia ? `${parseInt(this.vigencia.substring(0, 4)) - 1}${this.vigencia.substring(4, 6)}` : ''

			return [
				{ key: 'descripcion', label: this.labels.descripcion, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle', minWidth: '300px' },
				{ key: 'anterior', label: `${acronimo} ${vigenciaAnterior}`, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) },
				{ key: 'actual', label: `${acronimo} ${this.vigencia}`, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) },
				{ key: 'diferencia', label: `DIF-${acronimo}`, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) },
				{ key: 'funcional_ant', label: `${this.labels.funcional1} ${vigenciaAnterior}`, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) },
				{ key: 'funcional_act', label: `${this.labels.funcional1} ${this.vigencia}`, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) },
				{ key: 'funcional_dif', label: `DIF-${this.labels.funcional1}`, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) },
				{ key: 'accionDetalle', label: '', thClass: 'text-center', tdClass: 'text-center', sortable: false, minWidth: '50px' }
			]
		},

		comparativoFilterDefs() {
			return [
				{ key: 'descripcion', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar descripción...' : 'Filter description...' }
			]
		},

		notasFields() {
			return [
				{ key: 'numero', label: this.labels.nota, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle', minWidth: '80px' },
				{ key: 'descripcion', label: this.labels.descripcion_nota, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle', minWidth: '300px' },
				{ key: 'accionVer', label: '', thClass: 'text-center', tdClass: 'text-center', sortable: false, minWidth: '50px' },
				{ key: 'accionEditar', label: '', thClass: 'text-center', tdClass: 'text-center', sortable: false, minWidth: '50px' }
			]
		},

		notasFilterDefs() {
			return [
				{ key: 'numero', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar número...' : 'Filter number...' },
				{ key: 'descripcion', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar descripción...' : 'Filter description...' }
			]
		},

		informacionFields() {
			return [
				{ key: 'parrafo', label: this.labels.parrafo, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle', minWidth: '100px' },
				{ key: 'tipo', label: this.labels.tipo, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle', minWidth: '80px' },
				{ key: 'titulo', label: this.labels.parrafo_titulo, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle', minWidth: '250px' },
				{ key: 'accionEditar', label: '', thClass: 'text-center', tdClass: 'text-center', sortable: false, minWidth: '50px' }
			]
		},

		informacionFilterDefs() {
			return [
				{ key: 'parrafo', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar párrafo...' : 'Filter paragraph...' },
				{ key: 'tipo', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar tipo...' : 'Filter type...' },
				{ key: 'titulo', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar título...' : 'Filter title...' }
			]
		},

		cuentasFields() {
			const fields = [
				{ key: 'cuenta', label: this.labels.cuenta, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle', minWidth: '120px' },
				{ key: 'descripcion', label: this.labels.descripcion_cuenta, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle', minWidth: '300px' }
			]
			if (this.mostrarColumnas.saldo) {
				fields.push({ key: 'saldo_actual', label: this.labels.saldo_actual, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) })
			}
			if (this.mostrarColumnas.funcional) {
				fields.push(
					{ key: 'funcional1', label: this.labelFuncionalSeleccionada, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) },
					{ key: 'interna1', label: this.labelInternaSeleccionada, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) }
				)
				if (this.vistaActiva === 'funcional') {
					fields.push({ key: 'promedio1', label: this.labels.promedio1, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) })
				}
			}
			if (this.mostrarColumnas.alterna) {
				fields.push(
					{ key: 'funcional2', label: this.labels.funcional2, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) },
					{ key: 'interna2', label: this.labels.interna2, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) }
				)
				if (this.vistaActiva === 'alterna') {
					fields.push({ key: 'promedio2', label: this.labels.promedio2, sortable: true, thClass: 'text-right', tdClass: 'text-right align-middle', minWidth: '150px', formatter: (value) => this.formato(value) })
				}
			}
			return fields
		},

		// ==================== EXISTENTES (SE MANTIENEN) ====================
		vistaConsolidadoBool: {
			get() {
				return this.vistaConsolidado === 'combinado';
			},
			set(value) {
				this.vistaConsolidado = value ? 'combinado' : 'normal';
				if (this.generado && this.mostrarConsolidado) {
					this.generar();
				}
			}
		},

		nombreCompaniaSeleccionada() {
			if (this.dialogCompanias) {
				const compania = this.companias.find(c => c.id == this.dialogCompanias);
				return compania ? compania.nombre : '';
			}
			return '';
		},

		columnasVisibles() {
			const sufijo = this.monedaBalanceSeleccion === 'funcional2' ? '_m2' : ''
			let base = [
				{ label: this.labels.ajustes, field: `ajustes${sufijo}` },
				{ label: this.labels.consolidado, field: `total${sufijo}` }
			]
			if (this.vistaConsolidado === 'combinado') {
				base.push(
					{ label: 'Combinado', field: `combinado${sufijo}` },
					{ label: 'Total Combinado', field: `total_combinado${sufijo}` }
				)
			}
			return base
		},

		isNotasVisible() {
			return this.$store.getters.isControlVisible('BalanceNiif', 'Notas')
		},

		isBalanceVisible() {
			return this.$store.getters.isControlVisible('BalanceNiif', 'Balance')
		},

		isComparativoVisible() {
			return this.$store.getters.isControlVisible('BalanceNiif', 'Comparativo')
		},

		isConsolidadoVisible() {
			return this.$store.getters.isControlVisible('BalanceNiif', 'Consolidado')
		},

		isInformacionVisible() {
			return this.$store.getters.isControlVisible('BalanceNiif', 'Informacion')
		},

		isSelectorMonedaVisible() {
			return this.$store.getters.isControlVisible('BalanceNiif', 'SelectorMoneda')
		},

		isSelectorMonedaConsolidadoVisible() {
			return this.$store.getters.isControlVisible('BalanceNiif', 'SelectorMonedaConsolidado')
		},

		isMonedaFuncional1Visible() {
			return this.$store.getters.isControlVisible('BalanceNiif', 'MonedaFuncional1')
		},

		isMonedaFuncional2Visible() {
			return this.$store.getters.isControlVisible('BalanceNiif', 'MonedaFuncional2')
		},

		monedaBalanceOptions() {
			const options = []
			const monedaBalance1 = this.getNombreMonedaBalance('funcional1')
			const monedaBalance2 = this.getNombreMonedaBalance('funcional2')
			
			console.log('=== monedaBalanceOptions ===');
			console.log('this.currency:', this.currency);
			console.log('monedaBalance1:', monedaBalance1);
			console.log('monedaBalance2:', monedaBalance2);
			console.log('isMonedaFuncional1Visible:', this.isMonedaFuncional1Visible);
			console.log('isMonedaFuncional2Visible:', this.isMonedaFuncional2Visible);
			
			if (this.isMonedaFuncional1Visible && monedaBalance1) {
				options.push({
					value: 'funcional1',
					text: monedaBalance1
				})
			}
			if (this.isMonedaFuncional2Visible && monedaBalance2) {
				options.push({
					value: 'funcional2',
					text: monedaBalance2
				})
			}
			
			console.log('Opciones finales:', options);
			return options
		},

		mostrarSelectorMonedaBalance() {
			return this.isSelectorMonedaVisible && this.monedaBalanceOptions.length > 1
		},

		mostrarSelectorMonedaBalanceTabla() {
			return this.mostrarSelectorMonedaBalance
		},

		mostrarSelectorMonedaConsolidado() {
			const resultado = this.mostrarConsolidado &&
				this.isSelectorMonedaVisible &&
				this.isSelectorMonedaConsolidadoVisible &&
				this.monedaBalanceOptions.length > 1
			
			console.log('=== mostrarSelectorMonedaConsolidado ===');
			console.log('mostrarConsolidado:', this.mostrarConsolidado);
			console.log('isSelectorMonedaVisible:', this.isSelectorMonedaVisible);
			console.log('isSelectorMonedaConsolidadoVisible:', this.isSelectorMonedaConsolidadoVisible);
			console.log('monedaBalanceOptions:', this.monedaBalanceOptions);
			console.log('Resultado:', resultado);
			
			return resultado
		},

		labelFuncionalSeleccionada() {
			return this.monedaBalanceSeleccion === 'funcional2'
				? (this.labels.funcional2 || 'Funcional 2')
				: this.labels.funcional1
		},

		labelInternaSeleccionada() {
			return this.monedaBalanceSeleccion === 'funcional2'
				? (this.labels.interna2 || 'Interna 2')
				: this.labels.interna1
		},
	},

	watch: {
		// ==================== NUEVO: WATCHER PARA SELECCIÓN DE VISTA ====================
		selectedViewOption(newVal) {
			// Resetear todas las vistas
			this.mostrarBalance = false
			this.mostrarComparativo = false
			this.mostrarConsolidado = false
			this.mostrarNotas = false
			this.mostrarInformacion = false
			
			// Activar la vista seleccionada
			switch(newVal) {
				case 'balance':
					this.mostrarBalance = true
					break
				case 'consolidado':
					this.mostrarConsolidado = true
					break
				case 'comparativo':
					this.mostrarComparativo = true
					break
				case 'notas':
					this.mostrarNotas = true
					break
				case 'informacion':
					this.mostrarInformacion = true
					break
			}
			
			// Limpiar datos previos
			this.onFiltroChange()
			this.f_titulo()
		},
	},
	methods: {
		getMonedaConsolidadoParametro() {
			return this.monedaBalanceSeleccion === 'funcional2' ? 2 : 1
		},
		onCambioMonedaConsolidado() {
			this.normalizaSelectorMonedaBalance()
		},
		getCampoConsolidado(campoBase = '') {
			if (!campoBase) return campoBase
			return this.monedaBalanceSeleccion === 'funcional2' ? `${campoBase}_m2` : campoBase
		},
		getValorConsolidado(item = {}, campoBase = '') {
			const campo = this.getCampoConsolidado(campoBase)
			return item[campo]
		},
		getValorConsolidadoColumna(item = {}, columna = 1) {
			const campoBase = `c${columna}`
			return this.getValorConsolidado(item, campoBase)
		},
		getValorFuncional(item = {}) {
			const campo = this.monedaBalanceSeleccion === 'funcional2' ? 'funcional2' : 'funcional1'
			return item[campo]
		},

		getValorInterna(item = {}) {
			const campo = this.monedaBalanceSeleccion === 'funcional2' ? 'interna2' : 'interna1'
			return item[campo]
		},
		getNombreMonedaBalance(tipo = 'funcional1') {
			const funcionalEsperada = tipo === 'funcional2' ? 2 : 1
			const moneda = (this.currency || []).find(
				(item) => Number(item.isFuncional) === funcionalEsperada
			)
			console.log('=== getNombreMonedaBalance ===');
			console.log('tipo:', tipo);
			console.log('funcionalEsperada:', funcionalEsperada);
			console.log('moneda encontrada:', moneda);
			console.log('nombre:', moneda?.nombre || moneda?.acronimo || '');
			
			if (!moneda) return ''
			return moneda.nombre || moneda.acronimo || ''
		},
		normalizaSelectorMonedaBalance() {
			const opciones = this.monedaBalanceOptions.map((item) => item.value)
			if (opciones.length === 0) {
				this.monedaBalanceSeleccion = 'funcional1'
				return
			}
			if (!opciones.includes(this.monedaBalanceSeleccion)) {
				this.monedaBalanceSeleccion = opciones[0]
			}
		},
		applyControlVisibility() {
			if (!this.isBalanceVisible) this.Balance = false
			if (!this.isComparativoVisible) this.Comparativo = false
			if (!this.isNotasVisible) this.Notas = false
			if (!this.isInformacionVisible) this.Informacion = false
			this.normalizaSelectorMonedaBalance()
			
			if (!this.isConsolidadoVisible) {
				this.ConsolidadoGe = false
				this.Consolidado = false
				this.Empresas = false
				this.Grupos = false
				this.showConsolidationSection = false
				this.showGroupConsolidationSection = false
			}
		},
		async loadButtonControlsFromDb() {
			const defaultControls = {
				Balance: true,
				Comparativo: true,
				Consolidado: true,
				Notas: true,
				Informacion: true,
				SelectorMoneda: true,
				SelectorMonedaConsolidado: true,
				MonedaFuncional1: true,
				MonedaFuncional2: true
			}
			const controlMap = {
				100: "Balance",
				200: "Comparativo",
				300: "Consolidado",
				400: "Notas",
				500: "Informacion",
				600: "SelectorMoneda",
				630: "SelectorMonedaConsolidado",
				610: "MonedaFuncional1",
				620: "MonedaFuncional2"
			}

			try {
				const roleId = Number(this.$store.state.userRole) || 0
				const response = await BotonesControl.getBotonesControl("BALNIIF", roleId)
				const botones = Array.isArray(response.data.botones) ? response.data.botones : []
				const controls = { ...defaultControls }

				botones.forEach((item) => {
					const key = controlMap[Number(item.id_boton)]
					if (!key) return
					controls[key] = item.enabled !== false
				})

				this.$store.commit("setComponentControls", {
					componentName: "BalanceNiif",
					controls
				})
			} catch (error) {
				console.log("Error cargando visibilidad de botones:", error)
			} finally {
				this.applyControlVisibility()
				this.normalizaSelectorMonedaBalance()
			}
		},
		f_fechas() {
			this.isEmpty = true
			this.showDialog = false
			this.showDialogCuenta = false
			Balance.leeTasas(this.dialogFechas)
    .then((result) => { 
					this.tasasCambio = result.data.tasasCambio
				})
		},
		parseNiifSortableValue(niif) {
			const raw = `${niif || ''}`.trim()
			if (!raw) return Number.MAX_SAFE_INTEGER
			const normalized = raw.replace(/[^\d-]/g, '')
			if (!normalized || normalized === '-') return Number.MAX_SAFE_INTEGER
			const parsed = parseInt(normalized, 10)
			return Number.isFinite(parsed) ? parsed : Number.MAX_SAFE_INTEGER
		},
		generarClaveFilaConsolidado(item = {}) {
			const normaliza = (valor) => `${valor || ''}`
    .trim() 
    .replace(/\s+/g, ' ') 
    .toUpperCase(); 
			return [
    normaliza(item.codigo), 
    normaliza(item.descripcion), 
    normaliza(item.informacion) 
   ].join('|'); 
		},
		ordenarNiifKeysParaDetalle(todasLasCuentas = {}) {
			const keys = Object.keys(todasLasCuentas || {})
			if (keys.length <= 1) return keys

			const defaultOrder = 999999
			const ordenDesdeBalance = new Map()

			if (Array.isArray(this.balance)) {
				this.balance.forEach((item, idx) => {
					const niifSort = this.parseNiifSortableValue(item.niif)
					if (!Number.isFinite(niifSort) || niifSort === Number.MAX_SAFE_INTEGER) return
					if (ordenDesdeBalance.has(niifSort)) return

					const primerNivel = Number.isFinite(parseInt(item.primer_nivel, 10))
						? parseInt(item.primer_nivel, 10)
						: defaultOrder
					const segundoNivel = Number.isFinite(parseInt(item.segundo_nivel, 10))
						? parseInt(item.segundo_nivel, 10)
						: defaultOrder

					ordenDesdeBalance.set(niifSort, {
						primerNivel,
						segundoNivel,
						indice: idx
					})
				})
			}

			const comparable = keys.map((key) => {
				const niifSort = this.parseNiifSortableValue(todasLasCuentas[key].niif)
				const metadata = ordenDesdeBalance.get(niifSort) || {}

				return {
					key,
					niifSort,
					primerNivel: metadata.primerNivel ?? defaultOrder,
					segundoNivel: metadata.segundoNivel ?? defaultOrder,
					indice: metadata.indice ?? defaultOrder
				}
			})

			comparable.sort((a, b) => {
				if (a.primerNivel !== b.primerNivel) return a.primerNivel - b.primerNivel
				if (a.segundoNivel !== b.segundoNivel) return a.segundoNivel - b.segundoNivel
				if (a.niifSort !== b.niifSort) return a.niifSort - b.niifSort
				if (a.indice !== b.indice) return a.indice - b.indice
				return a.key.localeCompare(b.key)
			})

			return comparable.map((item) => item.key)
		},
		onTbmCellChange(fila, columna, valor) {
			const key = `${fila}-${columna}`
			this.tbmTableData.values[key] = valor
		},
		async guardarTablaTBM() {
			try {
				this.showGeneratingModal = true
				this.generatingMessage = 'Guardando tabla...'
				this.generatingProgress = 0
				// Preparar datos para enviar
				const datos = {
					codReporte: this.codReporte,
					numero: this.formParrafo.numero,
					parrafo: this.formParrafo.parrafo,
					idCompania: this.idCompania,
					vigencia: this.vigencia,
					userId: this.$store.state.userId,
					valores: []
				}
				// Convertir valores de tabla a array
				this.tbmTableData.rows.forEach(fila => {
					this.tbmTableData.columns.forEach(col => {
      const key = `${fila.fila}-${col.columna}` 
						const valor = this.tbmTableData.values[key] || ''
      datos.valores.push({ 
       fila: fila.fila, 
       columna: col.columna, 
       valor: valor.toString().trim() 
						})
					})
				})
				// Llamar al servicio para guardar
    const response = await Balance.guardarTablaTBM(datos) 
    if (response.data.success) { 
					this.$toast.success("Tabla guardada exitosamente")
					this.showDialog = false
					this.Informacion = true
					// Actualizar datos locales
					this.a_informacion_tblm = response.data.nuevosValores || datos.valores
				} else {
					this.$toast.error("Error al guardar la tabla")
				}
			} catch (error) {
    console.error('Error guardando tabla TBM:', error) 
				this.$toast.error("Error al guardar la tabla")
			} finally {
				this.showGeneratingModal = false
			}
		},
		toggleAllGroups() {
			if (this.selectAllGroups) {
				this.GruposConsolida = this.gruposFiltrados.map(grupo => grupo.id);
			} else {
				this.GruposConsolida = [];
			}
		},
		toggleGroupConsolidationSection() {
			this.showGroupConsolidationSection = !this.showGroupConsolidationSection;
		},
		getEmpresasFromGrupos(gruposSeleccionados) {
			if (!this.companias || !gruposSeleccionados || gruposSeleccionados.length === 0) {
				return [];
			}
			const empresasDelGrupo = [];
			this.companias.forEach(company => {
    if (!company?.id_grupos) return;     // Regla de grupo principal: SOLO el primer id en id_grupos. 
    const grupoPrincipal = company.id_grupos 
     .split(',')[0] 
     .trim(); 
    const perteneceAlgunGrupo = gruposSeleccionados.some( 
     grupoId => grupoPrincipal === grupoId.toString() 
				);
				if (perteneceAlgunGrupo) {
     empresasDelGrupo.push(company.id); 
				}
			});
   console.log('Grupos seleccionados:', gruposSeleccionados); 
   console.log('Empresas de los grupos seleccionados:', empresasDelGrupo); 
			return empresasDelGrupo;
		},
		async hojaExcelDetalleCompleto(datos, companiaId, esCombinado = false) {
			let createdAt1 = new Date()
   let anio = createdAt1.getFullYear() 
   let mes = String(createdAt1.getMonth() + 1).padStart(2, '0') 
   let dia = String(createdAt1.getDate()).padStart(2, '0') 
			let createdAt = anio + "-" + mes + "-" + dia
   let reporte = datos.reporte 
   let compania = datos.compania 
   let vigencia = datos.vigencia 
   let titulo = datos.titulo 
   let userName = datos.userName 
   const detalleCompleto = datos.informacion 
   const ajustesCompania = datos.ajustes || [] 
			const { Workbook } = XLSX
			const workbook = new Workbook()
   const worksheet = workbook.addWorksheet("Detalle") 
			// Determinar si estamos en vista combinado (usar el parámetro)
			// const esCombinado = this.vistaConsolidado === 'combinado'
			const styles = {
				tituloPrincipal: {
					font: { name: "Calibri", size: 16, bold: true },
					alignment: { horizontal: "center", vertical: "middle" }
				},
				subtitulo: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "center", vertical: "middle" }
				},
				encabezadoLinea: {
					font: { name: "Calibri", size: 12, bold: true },
					alignment: { horizontal: "left", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }
				},
				encabezadoCuentas: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "center", vertical: "middle" },
					border: {
						top: { style: "thin" },
						left: { style: "thin" },
						bottom: { style: "thin" },
						right: { style: "thin" }
					}
				},
				datoCuenta: {
					font: { name: "Calibri", size: 10 },
					alignment: { horizontal: "left", vertical: "middle" },
					border: {
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					}
				},
				datoNumerico: {
					font: { name: "Calibri", size: 10 },
					alignment: { horizontal: "right", vertical: "middle" },
					numFmt: "#,##0",
					border: {
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					}
				}
			}
			// ENCABEZADO PRINCIPAL
			let columnasDetalle = 3 // CUENTA + DESCRIPCIÓN + FUNCIONAL
			if (esCombinado) {
				columnasDetalle = 5 // + AJUSTES + CONSOLIDADO
			}
   const endCol = String.fromCharCode(65 + columnasDetalle - 1) 
   worksheet.mergeCells(`A1:${endCol}1`) 
   worksheet.getCell('A1').value = titulo 
   Object.assign(worksheet.getCell('A1'), styles.tituloPrincipal) 
   worksheet.mergeCells(`A2:${endCol}2`) 
   worksheet.getCell('A2').value = `Vigencia: ${vigencia} | Compañía: ${compania}` 
   Object.assign(worksheet.getCell('A2'), styles.subtitulo) 
   worksheet.mergeCells(`A3:${endCol}3`) 
   worksheet.getCell('A3').value = `Generado: ${createdAt} por ${userName} | Reporte: ${reporte}` 
   Object.assign(worksheet.getCell('A3'), styles.subtitulo) 
   worksheet.addRow([]) 
			let n_fila = 5
   detalleCompleto.forEach((linea) => { 
    worksheet.mergeCells(`A${n_fila}:${endCol}${n_fila}`) 
    worksheet.getCell(`A${n_fila}`).value = `${linea.niif} - ${linea.linea}` 
    Object.assign(worksheet.getCell(`A${n_fila}`), styles.encabezadoLinea) 
				n_fila++
				// ENCABEZADO DE COLUMNAS - DINÁMICO SEGÚN VISTA
				const HEADER_ROW = ['CUENTA', 'DESCRIPCIÓN', 'FUNCIONAL']
				if (esCombinado) {
     HEADER_ROW.push('AJUSTES') 
     HEADER_ROW.push('Consolidado') 
				}
    const headerRow = worksheet.addRow(HEADER_ROW) 
    headerRow.eachCell((cell) => { 
     Object.assign(cell, styles.encabezadoCuentas) 
				})
				n_fila++
				let totalLinea = 0
				let totalAjustesLinea = 0
				let totalConsolidadoLinea = 0
    linea.cuentas.forEach((cuenta) => { 
     if (cuenta.cuenta) { 
						const v_fila = [
       cuenta.cuenta, 
       cuenta.descripcion, 
       parseFloat(cuenta.funcional1) || 0 
						]
						if (esCombinado) {
							// En vista combinado, usar los campos específicos si existen
							const ajusteCuenta = parseFloat(
        cuenta.ajuste_funcional1 || 
        cuenta.ajuste_funcional1_rounded || 
        cuenta.ajuste_actual || 
        cuenta.ajuste_actual_rounded || 
								0
							) || 0
       const consolidadoCuenta = parseFloat(cuenta.consolidado) || 
        (parseFloat(cuenta.funcional1) + ajusteCuenta) || 0 
       v_fila.push(ajusteCuenta) 
       v_fila.push(consolidadoCuenta) 
							totalAjustesLinea += ajusteCuenta
							totalConsolidadoLinea += consolidadoCuenta
						}
      const currentRow = worksheet.addRow(v_fila) 
      currentRow.eachCell((cell, colNumber) => { 
							if (colNumber <= 2) {
        Object.assign(cell, styles.datoCuenta) 
							} else {
        Object.assign(cell, styles.datoNumerico) 
							}
						})
						n_fila++
      totalLinea += parseFloat(cuenta.funcional1 || 0) 
					}
				})
				// FILA DE TOTAL POR LÍNEA
    const totalRow = ['', `TOTAL ${linea.niif}`, totalLinea] 
				if (esCombinado) {
     totalRow.push(totalAjustesLinea) 
     totalRow.push(totalConsolidadoLinea) 
				}
    worksheet.addRow(totalRow) 
				// Estilos para fila de total
				const totalRowIndex = n_fila
    for (let i = 1; i <= totalRow.length; i++) { 
     const cell = worksheet.getCell(totalRowIndex, i) 
					if (i === 2) {
      cell.font = { name: "Calibri", size: 10, bold: true } 
      cell.alignment = { horizontal: "right", vertical: "middle" } 
					} else if (i >= 3) {
      Object.assign(cell, styles.datoNumerico) 
      cell.font = { ...cell.font, bold: true } 
					}
				}
				n_fila++
    worksheet.addRow([]) 
				n_fila++
			})
			// SECCIÓN DE AJUSTES (solo si hay ajustes)
   if (ajustesCompania && ajustesCompania.length > 0 && !datos.esDescargaIndividual) { 
    const ajustesFiltrados = ajustesCompania.filter(ajuste => { 
					const ajusteFuncional =
      ajuste.ajuste_funcional1 || 
      ajuste.ajuste_funcional1_rounded || 
      ajuste.ajuste_actual || 
      ajuste.ajuste_actual_rounded || 
						0
					return Math.abs(ajusteFuncional) > 0.01
				})
    if (ajustesFiltrados.length > 0) { 
     worksheet.addRow([]) 
					n_fila++
					// Determinar número de columnas para ajustes
					const columnasAjustes = 9 // Columnas fijas para ajustes
     const endColAjustes = String.fromCharCode(65 + columnasAjustes - 1) 
     worksheet.mergeCells(`A${n_fila}:${endColAjustes}${n_fila}`) 
     worksheet.getCell(`A${n_fila}`).value = `AJUSTES DE CONSOLIDACIÓN - RELACIONES CON EMPRESAS SELECCIONADAS` 
     worksheet.getCell(`A${n_fila}`).font = { name: "Calibri", size: 12, bold: true } 
     worksheet.getCell(`A${n_fila}`).fill = { 
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "FFF2CC" }
					}
					n_fila++
     worksheet.mergeCells(`A${n_fila}:${endColAjustes}${n_fila}`) 
     worksheet.getCell(`A${n_fila}`).value = `Compañía analizada: ${compania}` 
     worksheet.getCell(`A${n_fila}`).font = { name: "Calibri", size: 11, italic: true } 
					n_fila++
					const ajustesHeaders = [
						'COMPAÑIA',
						'NIIF',
						'SECUENCIA',
						'TIPO',
						'TIPO AJUSTE',
						'CUENTA',
						'SALDO ORIGINAL',
						'AJUSTE LOCAL',
						'AJUSTE FUNCIONAL'
					]
     for (let i = 0; i < ajustesHeaders.length; i++) { 
      const cell = worksheet.getCell(n_fila, i + 1) 
      cell.value = ajustesHeaders[i] 
      cell.font = { name: "Calibri", size: 11, bold: true } 
      cell.alignment = { horizontal: "center", vertical: "middle" } 
      cell.fill = { 
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "E6E6E6" }
						}
      cell.border = { 
							top: { style: "thin" },
							left: { style: "thin" },
							bottom: { style: "thin" },
							right: { style: "thin" }
						}
					}
					n_fila++
     ajustesFiltrados.forEach((ajuste) => { 
      let tipoAjusteFormateado = ajuste.tipo_ajuste || '' 
						if (tipoAjusteFormateado === 'O') {
							tipoAjusteFormateado = 'Origen'
						} else if (tipoAjusteFormateado === 'D') {
							tipoAjusteFormateado = 'Destino'
						}
      let niifConDescripcion = ajuste.niif || '' 
						if (this.balance && this.balance.length > 0 && ajuste.niif) {
							const niifInfo = this.balance.find(item => item.niif === ajuste.niif)
       if (niifInfo && niifInfo.descripcion) { 
        niifConDescripcion = `${ajuste.niif} - ${niifInfo.descripcion}` 
							}
						}
      worksheet.getCell(n_fila, 1).value = compania 
      worksheet.getCell(n_fila, 2).value = niifConDescripcion 
      worksheet.getCell(n_fila, 3).value = ajuste.secuencia || '' 
      worksheet.getCell(n_fila, 4).value = ajuste.tipo_participante || '' 
      worksheet.getCell(n_fila, 5).value = tipoAjusteFormateado 
      worksheet.getCell(n_fila, 6).value = ajuste.cuenta || '' 
      worksheet.getCell(n_fila, 7).value = ajuste.saldo_actual || 0 
      worksheet.getCell(n_fila, 8).value = ajuste.ajuste_actual || ajuste.ajuste_actual_rounded || 0 
      worksheet.getCell(n_fila, 9).value = 
       ajuste.ajuste_funcional1 || 
       ajuste.ajuste_funcional1_rounded || 
       ajuste.ajuste_actual || 
       ajuste.ajuste_actual_rounded || 
							0
      const esAjustePropio = ajuste.id_compania == companiaId 
						if (esAjustePropio) {
       for (let i = 1; i <= ajustesHeaders.length; i++) { 
        const cell = worksheet.getCell(n_fila, i) 
        cell.fill = { 
									type: "pattern",
									pattern: "solid",
									fgColor: { argb: "E1F5FE" }
								}
							}
						}
      for (let i = 1; i <= ajustesHeaders.length; i++) { 
       const cell = worksheet.getCell(n_fila, i) 
       cell.font = { name: "Calibri", size: 10 } 
       cell.alignment = { horizontal: "left", vertical: "middle" } 
							if (i >= 7 && i <= 9) {
        cell.alignment = { horizontal: "right", vertical: "middle" } 
        cell.numFmt = "#,##0" 
							}
       cell.border = { 
								left: { style: "thin" },
								right: { style: "thin" },
								bottom: { style: "thin" }
							}
						}
						n_fila++
					})
				}
			}
			// Ajustar ancho de columnas
			if (esCombinado) {
    worksheet.columns = [ 
					{ width: 15 },
					{ width: 40 },
					{ width: 18 },
					{ width: 18 },
					{ width: 18 }
				]
			} else {
    worksheet.columns = [ 
					{ width: 15 },
					{ width: 40 },
					{ width: 15 }
				]
			}
   worksheet.views = [ 
				{ state: 'frozen', ySplit: 4 }
			]
   const file = await workbook.xlsx.writeBuffer() 
   const downloadLink = document.createElement("a") 
   let nombreArchivo = `Detalle_${compania}_${vigencia}_${createdAt}.xlsx` 
			if (esCombinado) {
    nombreArchivo = `Detalle_Combinado_${compania}_${vigencia}_${createdAt}.xlsx` 
			}
   downloadLink.download = nombreArchivo 
   downloadLink.href = window.URL.createObjectURL( 
				new Blob([file], {
     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 
				})
			)
   downloadLink.style.display = "none" 
   document.body.appendChild(downloadLink) 
   downloadLink.click() 
   downloadLink.remove() 
		},
		excelDetalleGeneral() {
			console.log('=== excelDetalleGeneral ===');
			console.log('mostrarConsolidado:', this.mostrarConsolidado);
			console.log('mostrarBalance:', this.mostrarBalance);
			console.log('dialogCompanias:', this.dialogCompanias);
			console.log('EmpresasConsolida:', this.EmpresasConsolida);
			console.log('==============================');

			const esCombinado = this.vistaConsolidado === 'combinado';
			
			let companiasProcesar = [];
			
			// Si estamos en Consolidado
			if (this.mostrarConsolidado) {
				if (this.EmpresasConsolida && this.EmpresasConsolida.length > 0) {
					this.EmpresasConsolida.forEach(id => {
						const comp = this.companias.find(c => c.id == id);
						if (comp) {
							companiasProcesar.push({
								id: comp.id,
								nombre: comp.nombre
							});
						}
					});
				} else if (this.dialogCompanias) {
					const comp = this.companias.find(c => c.id == this.dialogCompanias);
					if (comp) {
						companiasProcesar.push({
							id: comp.id,
							nombre: comp.nombre
						});
					}
				}
			} else if (this.mostrarBalance) {
				const comp = this.companias.find(c => c.id == this.dialogCompanias);
				if (comp) {
					companiasProcesar.push({
						id: comp.id,
						nombre: comp.nombre
					});
				}
			}
			
			if (companiasProcesar.length === 0) {
				this.$toast.warning("No hay compañías seleccionadas para generar el detalle");
				return;
			}
			
			if (companiasProcesar.length === 1) {
				this.descargarDetalleCompania(
					companiasProcesar[0].id, 
					companiasProcesar[0].nombre, 
					esCombinado
				);
			} else {
				this.descargarDetalleMultipleCompanias(companiasProcesar, esCombinado);
			}
		},
		construirBalancePorGruposDesdeGlobal(balanceGlobal = [], gruposSeleccionados = [], empresasPorGrupo = {}, empresasOrdenadas = []) {
			const numGrupos = gruposSeleccionados.length
			this.columnas = numGrupos;
			this.titulo_columna = gruposSeleccionados.map((grupoId) => this.getNombreGrupo(grupoId));
			const normaliza = (valor) => `${valor || ''}`
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '')
				.replace(/[^\w\s]/g, ' ')
				.trim()
				.replace(/\s+/g, ' ')
				.toUpperCase();
			const filaEtiquetas = (balanceGlobal || []).find((fila) => {
				if (!fila) return false
				return Object.keys(fila).some((k) => /^e\d+$/.test(k) && `${fila[k] || ''}`.trim() !== '')
			}) || ((balanceGlobal && balanceGlobal.length > 0) ? balanceGlobal[0] : {})
			const totalColumnasGlobal = parseInt(filaEtiquetas.columnas, 10) || empresasOrdenadas.length || 0
			const posicionesGlobales = Array.from({ length: totalColumnasGlobal }, (_, i) => i + 1)
			const empresasSeleccionadasSet = new Set((empresasOrdenadas || []).map((id) => `${id}`))
   // Índice de compañías por identificadores textuales para mapear eN -> id_compania real. 
			const companiasPorAlias = {};
			(this.companias || []).forEach((comp) => {
    if (empresasSeleccionadasSet.size > 0 && !empresasSeleccionadasSet.has(`${comp.id}`)) { 
					return;
				}
				const aliases = [
     comp.id, 
     comp.acronym, 
     comp.codigo, 
     comp.nombre 
				];
    aliases.forEach((alias) => { 
					const key = normaliza(alias);
					if (!key) return;
					if (!companiasPorAlias[key]) {
						companiasPorAlias[key] = [];
					}
     companiasPorAlias[key].push(comp.id); 
				});
			});
   // Resolver a qué compañía corresponde cada columna global cN. 
			const empresaPorPosicionGlobal = {};
			const empresasYaUsadas = new Set();
			posicionesGlobales.forEach((pos) => {
				const etiqueta = normaliza(filaEtiquetas['e' + pos]);
				if (!etiqueta) return;
				const candidatos = companiasPorAlias[etiqueta] || [];
				if (candidatos.length > 0) {
					const candidatoLibre = candidatos.find((id) => !empresasYaUsadas.has(`${id}`));
					const candidato = candidatoLibre !== undefined ? candidatoLibre : candidatos[0];
					empresaPorPosicionGlobal[pos] = candidato;
					empresasYaUsadas.add(`${candidato}`);
				}
			});
   // Fallback: si no pudimos mapear por etiqueta, usar orden de empresas enviadas. 
   posicionesGlobales.forEach((pos) => { 
				if (empresaPorPosicionGlobal[pos] !== undefined) return;
    const empresaOrden = (empresasOrdenadas || []).find((id) => !empresasYaUsadas.has(`${id}`)); 
				if (empresaOrden !== undefined) {
					empresaPorPosicionGlobal[pos] = empresaOrden;
     empresasYaUsadas.add(`${empresaOrden}`); 
				}
			});
   const posicionesPorGrupo = gruposSeleccionados.map((grupoId) => { 
				const empresas = empresasPorGrupo[`${grupoId}`] || [];
    const setEmpresasGrupo = new Set(empresas.map((id) => `${id}`)); 
    return posicionesGlobales?.filter((pos) =>      setEmpresasGrupo.has(`${empresaPorPosicionGlobal[pos]}`) 
				);
			});
			this.balance = (balanceGlobal || []).map((fila) => {
				const nuevaFila = {
     ...fila, 
     ...Object.fromEntries(Array.from({ length: 50 }, (_, i) => [`c${i + 1}`, 0])), 
     ...Object.fromEntries(Array.from({ length: 50 }, (_, i) => [`e${i + 1}`, ''])) 
				};
				let sumaColumnas = 0;
				for (let idxGrupo = 0; idxGrupo < numGrupos; idxGrupo++) {
					const columnaDestino = idxGrupo + 1;
					const posiciones = posicionesPorGrupo[idxGrupo] || [];
					let sumaGrupo = 0;
     posiciones.forEach((pos) => { 
						const valor = parseFloat(fila['c' + pos]) || 0;
						sumaGrupo += valor;
					});
					nuevaFila['c' + columnaDestino] = sumaGrupo;
					nuevaFila['e' + columnaDestino] = this.titulo_columna[idxGrupo] || `Grupo ${columnaDestino}`;
					sumaColumnas += sumaGrupo;
				}
    const ajustes = parseFloat(fila.ajustes) || 0; 
    const combinado = parseFloat(fila.combinado) || 0; 
    nuevaFila.ajustes = ajustes; 
    nuevaFila.total = sumaColumnas + ajustes; 
    nuevaFila.combinado = combinado; 
    nuevaFila.total_combinado = nuevaFila.total + combinado; 
    nuevaFila.columnas = numGrupos; 
				return nuevaFila;
			});
			this.searched = this.balance;
			if (this.balance.length !== 0) {
				this.isEmpty = false;
				this.generado = true;
				const monedaFuncional = this.currency.find((moneda) => moneda.isFuncional == 1);
				this.cmoneda = monedaFuncional ? monedaFuncional.id : 0;
				this.amoneda = monedaFuncional ? monedaFuncional.id : 0;
				this.tasa_cambio = 1;
			}
		},
		procesarMultiplesGrupos(gruposConDatos, consolidadoGlobal = []) {
   console.log('Datos recibidos del backend (MÚLTIPLES GRUPOS):', gruposConDatos); 
   const gruposOrdenados = [...gruposConDatos]; 
   const numGrupos = gruposOrdenados.length; 
			this.columnas = numGrupos;
			this.titulo_columna = gruposOrdenados.map((grupo) => this.getNombreGrupo(grupo.grupoId)); 
			const mapaFilasPorGrupo = {};
			const contadorUsoClavePorGrupo = {};
   gruposOrdenados.forEach((grupo, idx) => { 
				mapaFilasPorGrupo[idx] = {
					porClave: {}
				};
				contadorUsoClavePorGrupo[idx] = {};
    (grupo.data || []).forEach(item => { 
					if (!item) return;
					const clave = this.generarClaveFilaConsolidado(item);
     if (!mapaFilasPorGrupo[idx].porClave[clave]) { 
      mapaFilasPorGrupo[idx].porClave[clave] = []; 
					}
     mapaFilasPorGrupo[idx].porClave[clave].push(item); 
				});
			});
			let baseData = [];
    if (Array.isArray(consolidadoGlobal) && consolidadoGlobal.length > 0) { 
					baseData = consolidadoGlobal;
				} else {
					const mapaBase = new Map();
     gruposOrdenados.forEach((grupo) => { 
      (grupo.data || []).forEach((item) => { 
							const clave = this.generarClaveFilaConsolidado(item);
       if (item && clave && !mapaBase.has(clave)) { 
        mapaBase.set(clave, item); 
							}
						});
					});
     baseData = Array.from(mapaBase.values()); 
				}
			this.balance = baseData.map((filaBase) => {
					const claveBase = this.generarClaveFilaConsolidado(filaBase);
				const nuevaFila = {
     ...filaBase, 
     ...Object.fromEntries(Array.from({ length: 50 }, (_, i) => [`c${i + 1}`, 0])), 
     ...Object.fromEntries(Array.from({ length: 50 }, (_, i) => [`e${i + 1}`, ''])) 
				};
				for (let grupoIndex = 0; grupoIndex < numGrupos; grupoIndex++) {
					const columnaDestino = grupoIndex + 1;
     const filasPorClave = mapaFilasPorGrupo[grupoIndex].porClave[claveBase] || []; 
					const usoActualClave = contadorUsoClavePorGrupo[grupoIndex][claveBase] || 0;
					let filaGrupo = filasPorClave[usoActualClave] || null;
					if (filaGrupo) {
						contadorUsoClavePorGrupo[grupoIndex][claveBase] = usoActualClave + 1;
					}
					let sumaEmpresasGrupo = 0;
					if (filaGrupo) {
      const numColsGrupo = parseInt(filaGrupo.columnas_original || filaGrupo.columnas) || 0; 
						for (let i = 1; i <= numColsGrupo; i++) {
							const colKey = 'c' + i;
							if (filaGrupo[colKey] !== undefined && filaGrupo[colKey] !== null) {
								sumaEmpresasGrupo += parseFloat(filaGrupo[colKey]) || 0;
							}
						}
					}
					nuevaFila['c' + columnaDestino] = sumaEmpresasGrupo;
					nuevaFila['e' + columnaDestino] = this.getNombreGrupo(gruposOrdenados[grupoIndex].grupoId);
				}
				return nuevaFila;
			});
			console.log('Títulos de columnas:', this.titulo_columna);
			console.log(`Total de filas procesadas: ${this.balance.length}`);
   // Mapear ajustes globales por clave de fila para no cruzar líneas especiales. 
			const mapaAjustesGlobal = {};
			const contadorUsoAjustesGlobal = {};
   if (Array.isArray(consolidadoGlobal) && consolidadoGlobal.length > 0) { 
    consolidadoGlobal.forEach((fila) => { 
					const clave = this.generarClaveFilaConsolidado(fila);
					if (!clave) return;
					if (!mapaAjustesGlobal[clave]) {
						mapaAjustesGlobal[clave] = [];
					}
     mapaAjustesGlobal[clave].push({ 
      ajustes: parseFloat(fila.ajustes) || 0, 
      combinado: parseFloat(fila.combinado) || 0 
					});
				});
			}
			// Actualizar los totales para todas las filas
			this.balance = this.balance.map((nuevaFila) => {
				let sumaColumnas = 0;
				// Sumar todas las columnas de empresas
				for (let i = 1; i <= this.columnas; i++) {
					const valorColumna = nuevaFila['c' + i];
					if (valorColumna !== undefined && valorColumna !== null) {
						sumaColumnas += parseFloat(valorColumna) || 0;
					}
				}
				// Ajustes: preferir valor de consolidación global para alinear con checkbox "Empresas"
				const claveFila = this.generarClaveFilaConsolidado(nuevaFila);
				const ajustesPorClave = mapaAjustesGlobal[claveFila] || [];
				const usoAjuste = contadorUsoAjustesGlobal[claveFila] || 0;
				const ajustesGlobal = ajustesPorClave[usoAjuste] || null;
				if (ajustesGlobal) {
					contadorUsoAjustesGlobal[claveFila] = usoAjuste + 1;
				}
				const ajustes = ajustesGlobal
					? ajustesGlobal.ajustes
					: (parseFloat(nuevaFila.ajustes) || 0)
				nuevaFila.ajustes = ajustes
				// Calcular el total (empresas + ajustes)
				nuevaFila.total = sumaColumnas + ajustes
				const combinado = ajustesGlobal
					? ajustesGlobal.combinado
					: (parseFloat(nuevaFila.combinado) || 0)
				nuevaFila.combinado = combinado
				nuevaFila.total_combinado = nuevaFila.total + combinado
				nuevaFila.columnas = this.columnas;
				return nuevaFila;
			});
			// Actualizar la data mostrada
			this.searched = this.balance;
			// Actualizar estados
			if (this.balance.length !== 0) {
				this.isEmpty = false;
				this.generado = true;
				console.log('RESULTADO FINAL - Primera fila:', this.balance[0]);
				// Configurar moneda funcional
				const monedaFuncional = this.currency.find((moneda) => moneda.isFuncional == 1);
				this.cmoneda = monedaFuncional ? monedaFuncional.id : 0;
				this.amoneda = monedaFuncional ? monedaFuncional.id : 0;
				this.tasa_cambio = 1;
			}
		},
		// Método para descargar Excel de una columna específica (compañía específica)
		excelColumna(columnaIndex) {
   console.log('Descargando detalle para columna:', columnaIndex); 
			// Obtener el ID de la compañía correspondiente a esta columna
			let companiaId = null;
			let companiaNombre = this.titulo_columna[columnaIndex - 1];
			if (this.Grupos && this.GruposConsolida.length > 0) {
				// Para consolidación por grupos
				const grupoId = this.GruposConsolida[columnaIndex - 1];
				const empresasDelGrupo = this.getEmpresasFromGrupos([grupoId]);
    if (empresasDelGrupo.length > 0) { 
					companiaId = empresasDelGrupo[0];
				}
			} else {
				// Para consolidación por empresas
				if (this.EmpresasConsolidaExcel && this.EmpresasConsolidaExcel.length >= columnaIndex) {
					companiaId = this.EmpresasConsolidaExcel[columnaIndex - 1];
				} else if (this.EmpresasConsolidaExcel && this.EmpresasConsolidaExcel.length > 0) {
					companiaId = this.EmpresasConsolidaExcel[0];
				} else if (this.dialogCompanias) {
					companiaId = this.dialogCompanias;
				}
			}
			if (!companiaId) {
				this.$toast.warning("No se pudo identificar la compañía para esta columna");
				return;
			}
			this.descargarDetalleCompania(companiaId, companiaNombre);
		},
		excelDetalleCompleto() {
			console.log('=== excelDetalleCompleto ===');
			
			// Determinar si estamos en vista combinado
			const esCombinado = this.vistaConsolidado === 'combinado';
			
			// Asegurar que los arrays existan
			if (!this.GruposConsolida) this.GruposConsolida = [];
			if (!this.EmpresasConsolidaExcel) this.EmpresasConsolidaExcel = [];

			// Obtener la compañía o compañías a procesar
			let companiasProcesar = [];

			// ===== PRIMERO: Intentar usar EmpresasConsolidaExcel (la copia para Excel) =====
			if (this.mostrarConsolidado && this.EmpresasConsolidaExcel.length > 0) {
				console.log('Modo: Consolidado con empresas seleccionadas (Excel)', this.EmpresasConsolidaExcel);
				this.EmpresasConsolidaExcel.forEach(id => {
					const comp = this.companias.find(c => c.id == id);
					if (comp) {
						companiasProcesar.push({
							id: comp.id,
							nombre: comp.nombre
						});
					}
				});
			} 
			// Si estamos en Consolidado individual (sin empresas seleccionadas, solo la compañía actual)
			else if (this.mostrarConsolidado && this.dialogCompanias) {
				console.log('Modo: Consolidado individual', this.dialogCompanias);
				const comp = this.companias.find(c => c.id == this.dialogCompanias);
				if (comp) {
					companiasProcesar.push({
						id: comp.id,
						nombre: comp.nombre
					});
				}
			} 
			// Si estamos en Balance individual
			else if (this.mostrarBalance && this.dialogCompanias) {
				console.log('Modo: Balance individual', this.dialogCompanias);
				const comp = this.companias.find(c => c.id == this.dialogCompanias);
				if (comp) {
					companiasProcesar.push({
						id: comp.id,
						nombre: comp.nombre
					});
				}
			}

			// Si no hay compañías para procesar
			if (companiasProcesar.length === 0) {
				console.warn('No hay compañías seleccionadas para generar el detalle');
				this.$toast.warning("No hay compañías seleccionadas para generar el detalle");
				return;
			}

			console.log('Compañías a procesar (Excel):', companiasProcesar);

			// Si es una sola compañía
			if (companiasProcesar.length === 1) {
				this.descargarDetalleCompania(
					companiasProcesar[0].id, 
					companiasProcesar[0].nombre, 
					esCombinado
				);
			} else {
				// Si son múltiples compañías
				this.descargarDetalleMultipleCompanias(companiasProcesar, esCombinado);
			}
		},
		async descargarDetallePorGrupos(esCombinado = false) {
			console.log('EJECUTANDO descargarDetallePorGrupos');
			console.log('Grupos seleccionados:', this.GruposConsolida);
			console.log('Estado Consolidado:', this.Consolidado);
			console.log('Estado Grupos:', this.Grupos);

			// Verificar que GruposConsolida existe y tiene elementos
			if (!this.GruposConsolida || this.GruposConsolida.length === 0) {
				this.$toast.warning("No hay grupos seleccionados para descargar");
				return;
			}

			this.showGeneratingModal = true;
			this.generatingMessage = 'Recopilando información por grupos...';
			this.generatingSubMessage = `Procesando ${this.GruposConsolida.length} grupo(s)`;
			this.generatingProgress = 0;
			try {
				this.$toast.info(`Generando detalle para ${this.GruposConsolida.length} grupo(s)...`);
    const workbook = new XLSX.Workbook(); 
				const totalGrupos = this.GruposConsolida.length;
				console.log('Número de grupos a procesar:', this.GruposConsolida.length);
				for (let i = 0; i < this.GruposConsolida.length; i++) {
					const grupoId = this.GruposConsolida[i];
     console.log(`Procesando grupo ${i + 1}: ID ${grupoId}`); 
					const grupo = this.grupos.find(g => g.id == grupoId);
     console.log('Grupo encontrado:', grupo); 
					this.generatingProgress = Math.round((i / totalGrupos) * 50);
					this.generatingMessage = `Procesando grupo ${i + 1} de ${totalGrupos}`;
					this.generatingSubMessage = `Grupo: ${grupo ? grupo.nombre : 'ID ' + grupoId}`;
					// Obtener todas las empresas de este grupo
					const empresasDelGrupo = this.getEmpresasFromGrupos([grupoId]);
     console.log(`Empresas del grupo ${grupoId}:`, empresasDelGrupo); 
     if (empresasDelGrupo.length === 0) { 
      console.warn(`El grupo ${grupoId} no tiene empresas`); 
						continue;
					}
					// Obtener datos de las empresas del grupo
					const companiasDelGrupo = [];
     empresasDelGrupo.forEach(empresaId => { 
						const compania = this.companias.find(c => c.id == empresaId);
						if (compania) {
       companiasDelGrupo.push({ 
        id: compania.id, 
        nombre: compania.nombre 
							});
						}
					});
     if (companiasDelGrupo.length === 0) { 
						continue;
					}
					// Crear una hoja para este grupo
     const worksheet = workbook.addWorksheet( 
						grupo ? this.sanitizeSheetName(grupo.nombre) : `Grupo_${grupoId}`,
						{ views: [{ state: 'frozen', ySplit: 4 }] }
					);
					// Procesar datos del grupo - pasar el parámetro esCombinado
					await this.procesarGrupoParaExcel(worksheet, companiasDelGrupo, grupo, esCombinado);
				}
    if (workbook.worksheets.length === 0) { 
					this.showGeneratingModal = false;
					this.$toast.warning("No se pudo generar detalle para ningún grupo");
					return;
				}
				this.generatingProgress = 90;
				this.generatingMessage = 'Generando archivo Excel...';
				this.generatingSubMessage = 'Organizando hojas por grupo';
    const file = await workbook.xlsx.writeBuffer(); 
				this.generatingProgress = 100;
				this.generatingMessage = '¡Completado!';
					const nombreArchivo = esCombinado
						? `Detalle_Grupos_Combinado_${this.vigencia}.xlsx`
						: `Detalle_Grupos_${this.vigencia}.xlsx`;
				setTimeout(() => {
					this.showGeneratingModal = false;
					this.descargarArchivo(file, nombreArchivo);
					this.$toast.success("Detalle por grupos generado exitosamente");
				}, 500);
			} catch (error) {
				this.showGeneratingModal = false;
    console.error('Error generando detalle por grupos:', error); 
				this.$toast.error("Error al generar el detalle por grupos");
			}
		},
		async procesarGrupoParaExcel(worksheet, companiasDelGrupo, grupo, esCombinado = false) {
			const titulo = `DETALLE COMPLETO - ${grupo ? grupo.nombre : 'GRUPO'}`
			const vigencia = this.vigencia;
			const userName = this.$store.state.userName;
			const reporte = this.reportes.find(r => r.codigo === this.codReporte).nombre || 'Balance';
			let createdAt1 = new Date();
   let anio = createdAt1.getFullYear(); 
   let mes = String(createdAt1.getMonth() + 1).padStart(2, '0'); 
   let dia = String(createdAt1.getDate()).padStart(2, '0'); 
			let createdAt = anio + "-" + mes + "-" + dia;
			const combinacionesAgregadas = new Set();
			const datosPorCompania = [];
			const todosAjustes = [];
   for (let i = 0; i < companiasDelGrupo.length; i++) { 
				const compania = companiasDelGrupo[i];
				try {
     const resultBalance = await Balance.getBalanceNiif( 
						this.codReporte,
      compania.id, 
						vigencia
					);
     const balanceCompania = resultBalance.data.balanceNiif; 
     if (!balanceCompania || balanceCompania.length === 0) continue; 
					const detalleCompleto = [];
					for (const linea of balanceCompania) {
      if (linea.informacion === "I") { 
							try {
        const resultCuentas = await Balance.getCuentasNiif( 
									this.codReporte,
         compania.id, 
									vigencia,
         linea.niif 
								);
        if (resultCuentas.data.cuentas.length > 0) { 
         detalleCompleto.push({ 
          linea: linea.descripcion, 
          niif: linea.niif, 
          cuentas: resultCuentas.data.cuentas 
									});
								}
							} catch (error) {
        console.warn(`Error obteniendo cuentas ${linea.niif}`, error); 
							}
						}
					}
					const ajustesRaw = await this.obtenerAjustesPorEmpresa(
      compania.id, 
						vigencia,
      companiasDelGrupo.map(c => c.id) 
					);
					const ajustesFiltrados = [];
					for (const ajuste of ajustesRaw) {
      const secuencia = ajuste.secuencia; 
      const cuenta = ajuste.cuenta; 
      const tipoAjuste = ajuste.tipo_ajuste || ajuste.tipo || ''; 
      const idCompaniaAjuste = Number(ajuste.id_compania || 0); 
      const origenAjuste = ajuste.origen || ''; 
      const niifAjuste = ajuste.niif || ''; 
						const clave = `${idCompaniaAjuste}|${origenAjuste}|${secuencia}|${cuenta}|${tipoAjuste}|${niifAjuste}`;
      if (!combinacionesAgregadas.has(clave)) { 
       combinacionesAgregadas.add(clave); 
       ajustesFiltrados.push(ajuste); 
       todosAjustes.push({ 
        ...ajuste, 
        compania_origen: compania.nombre 
							});
						}
					}
     if (detalleCompleto.length > 0 || ajustesFiltrados.length > 0) { 
      datosPorCompania.push({ 
							compania,
							detalle: detalleCompleto,
							ajustes: ajustesFiltrados
						});
					}
				} catch (error) {
     console.error(`Error procesando ${compania.nombre}:`, error); 
				}
			}
			if (datosPorCompania.length === 0) {
				worksheet.mergeCells('A1:D1')
				worksheet.getCell('A1').value = `GRUPO: ${grupo ? grupo.nombre : 'Desconocido'}`
				worksheet.getCell('A1').font = { name: "Calibri", size: 14, bold: true }
				worksheet.mergeCells('A2:D2')
				worksheet.getCell('A2').value = 'No hay datos disponibles para este grupo'
				return;
			}
   const numCompanias = datosPorCompania.length; 
			let totalColumnsDetalle = 2 + numCompanias + 3;
			if (esCombinado) {
				totalColumnsDetalle += 2;
			}
   const endColDetalle = String.fromCharCode(65 + totalColumnsDetalle - 1); 
   worksheet.mergeCells(`A1:${endColDetalle}1`); 
   worksheet.getCell('A1').value = titulo; 
   worksheet.getCell('A1').font = { name: "Calibri", size: 16, bold: true }; 
   worksheet.getCell('A1').alignment = { horizontal: "center", vertical: "middle" }; 
   worksheet.mergeCells(`A2:${endColDetalle}2`); 
   worksheet.getCell('A2').value = `Vigencia: ${vigencia} | Grupo: ${grupo ? grupo.nombre : 'Desconocido'} | Empresas: ${datosPorCompania.length}`; 
   worksheet.getCell('A2').font = { name: "Calibri", size: 11, bold: true }; 
   worksheet.getCell('A2').alignment = { horizontal: "center", vertical: "middle" }; 
   worksheet.mergeCells(`A3:${endColDetalle}3`); 
   worksheet.getCell('A3').value = `Generado: ${createdAt} por ${userName} | Reporte: ${reporte}`; 
   worksheet.getCell('A3').font = { name: "Calibri", size: 11, bold: true }; 
   worksheet.getCell('A3').alignment = { horizontal: "center", vertical: "middle" }; 
   worksheet.addRow([]); 
			let n_fila = 5;
			const companiasRow = ['COMPAÑÍAS', ''];
   datosPorCompania.forEach((datoCompania) => { 
    companiasRow.push(datoCompania.compania.nombre); 
			});
   companiasRow.push('SUMATORIA'); 
   companiasRow.push('AJUSTES'); 
   companiasRow.push('CONSOLIDADO'); 
			if (esCombinado) {
    companiasRow.push('COMBINADO'); 
    companiasRow.push('TOTAL COMBINADO'); 
			}
   worksheet.addRow(companiasRow); 
   let companiaCell = worksheet.getCell(n_fila, 1); 
   companiaCell.font = { name: "Calibri", size: 11, bold: true }; 
   companiaCell.alignment = { horizontal: "center", vertical: "middle" }; 
   companiaCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }; 
   worksheet.mergeCells(n_fila, 1, n_fila, 2); 
   datosPorCompania.forEach((datoCompania, idx) => { 
    let nombreCompaniaCell = worksheet.getCell(n_fila, idx + 3); 
    nombreCompaniaCell.font = { name: "Calibri", size: 11, bold: true }; 
    nombreCompaniaCell.alignment = { horizontal: "center", vertical: "middle" }; 
				if (idx % 2 === 0) {
     nombreCompaniaCell.fill = { 
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "FCE4D6" }
					};
				} else {
     nombreCompaniaCell.fill = { 
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "D9EAD3" }
					};
				}
    nombreCompaniaCell.border = { 
					top: { style: "thin" },
					left: { style: "thin" },
					bottom: { style: "thin" },
					right: { style: "thin" }
				};
			});
			const sumatoriaCol = numCompanias + 3;
			const ajustesCol = sumatoriaCol + 1;
			const consolidadoCol = ajustesCol + 1;
   let sumatoriaCell = worksheet.getCell(n_fila, sumatoriaCol); 
   sumatoriaCell.font = { name: "Calibri", size: 11, bold: true }; 
   sumatoriaCell.alignment = { horizontal: "center", vertical: "middle" }; 
   sumatoriaCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }; 
   let ajustesCell = worksheet.getCell(n_fila, ajustesCol); 
   ajustesCell.font = { name: "Calibri", size: 11, bold: true }; 
   ajustesCell.alignment = { horizontal: "center", vertical: "middle" }; 
   ajustesCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }; 
   let consolidadoCell = worksheet.getCell(n_fila, consolidadoCol); 
   consolidadoCell.font = { name: "Calibri", size: 11, bold: true }; 
   consolidadoCell.alignment = { horizontal: "center", vertical: "middle" }; 
   consolidadoCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }; 
			if (esCombinado) {
				const combinadoCol = consolidadoCol + 1;
				const totalCombinadoCol = combinadoCol + 1;
    let combinadoCell = worksheet.getCell(n_fila, combinadoCol); 
    combinadoCell.font = { name: "Calibri", size: 11, bold: true }; 
    combinadoCell.alignment = { horizontal: "center", vertical: "middle" }; 
    combinadoCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }; 
    let totalCombinadoCell = worksheet.getCell(n_fila, totalCombinadoCol); 
    totalCombinadoCell.font = { name: "Calibri", size: 11, bold: true }; 
    totalCombinadoCell.alignment = { horizontal: "center", vertical: "middle" }; 
    totalCombinadoCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }; 
			}
			n_fila++;
			const ajustesPorNiif = {};
			const ajustesPorNiifCuenta = {};
   datosPorCompania.forEach(datoCompania => { 
    if (datoCompania.ajustes && datoCompania.ajustes.length > 0) { 
     datoCompania.ajustes.forEach(ajuste => { 
      const origenAjuste = String(ajuste.origen || '').toUpperCase(); 
						if (origenAjuste === 'B') return; // En AJUSTES no sumar combinados
      const niif = ajuste.niif; 
      const cuenta = ajuste.cuenta; 
						const valor = parseFloat(
       ajuste.ajuste_funcional1 || 
       ajuste.ajuste_funcional1_rounded || 
       ajuste.ajuste_actual || 
       ajuste.ajuste_actual_rounded || 
							0
						);
						if (!ajustesPorNiif[niif]) {
							ajustesPorNiif[niif] = 0;
						}
						ajustesPorNiif[niif] += valor;
						if (!ajustesPorNiifCuenta[niif]) {
							ajustesPorNiifCuenta[niif] = {};
						}
						if (!ajustesPorNiifCuenta[niif][cuenta]) {
							ajustesPorNiifCuenta[niif][cuenta] = 0;
						}
						ajustesPorNiifCuenta[niif][cuenta] += valor;
					});
				}
			});
			let ajustesOrigenBExternos = [];
			try {
				if (typeof this.obtenerAjustesOrigenB === 'function') {
					ajustesOrigenBExternos = await this.obtenerAjustesOrigenB();
				}
			} catch (error) {
    console.error("Error obteniendo ajustes de origen B:", error); 
			}
			const idsCompaniasSeleccionadasDetalle = new Set(
    (datosPorCompania || []).map(d => Number(d.compania.id)) 
			);
   ajustesOrigenBExternos = (ajustesOrigenBExternos || []).filter( 
    ajuste => idsCompaniasSeleccionadasDetalle.has(Number(ajuste.id_compania)) 
			);
			ajustesOrigenBExternos = this.deduplicarCombinadosB(ajustesOrigenBExternos);
			const ajustesOrigenBPorCuenta = {};
   if (ajustesOrigenBExternos && ajustesOrigenBExternos.length > 0) { 
    ajustesOrigenBExternos.forEach(ajuste => { 
     const cuenta = ajuste.cuenta; 
					if (!ajustesOrigenBPorCuenta[cuenta]) {
						ajustesOrigenBPorCuenta[cuenta] = 0;
					}
					const valorOrigenB = parseFloat(
      ajuste.ajuste_actual || 
      ajuste.ajuste_actual_rounded || 
						0
					);
					ajustesOrigenBPorCuenta[cuenta] += valorOrigenB;
				});
			}
			// AGREGAR AJUSTES DE ORIGEN B A TODOS LOS AJUSTES PARA LA TABLA FINAL
   if (esCombinado && ajustesOrigenBExternos && ajustesOrigenBExternos.length > 0) { 
				const clavesCombinadoB = new Set(
					(todosAjustes || [])
      .filter(a => String(a.origen || '').toUpperCase() === 'B') 
						.map(a => this.claveCombinadoB(a))
				);
    ajustesOrigenBExternos.forEach(ajuste => { 
     const secuencia = ajuste.secuencia; 
     const cuenta = ajuste.cuenta; 
     const tipoAjuste = ajuste.tipo_ajuste || ajuste.tipo || ''; 
     const idCompaniaAjuste = Number(ajuste.id_compania || 0); 
     const origenAjuste = ajuste.origen || ''; 
     const niifAjuste = ajuste.niif || ''; 
					const clave = `${idCompaniaAjuste}|${origenAjuste}|${secuencia}|${cuenta}|${tipoAjuste}|${niifAjuste}`;
					const claveB = this.claveCombinadoB(ajuste);
     if (!combinacionesAgregadas.has(clave) && !clavesCombinadoB.has(claveB)) { 
      combinacionesAgregadas.add(clave); 
      clavesCombinadoB.add(claveB); 
      todosAjustes.push({ 
       ...ajuste, 
							compania_origen: this.resolverNombreCompaniaAjuste(ajuste, datosPorCompania),
							origen: 'B'
						});
					}
				});
			}
			const todasLasCuentas = {};
   datosPorCompania.forEach((datoCompania) => { 
    const companiaId = datoCompania.compania.id; 
    if (!datoCompania?.detalle || datoCompania.detalle?.length === 0) return;     datoCompania.detalle.forEach(linea => { 
     const niifKey = `${linea.niif}-${linea.linea}`; 
					if (!todasLasCuentas[niifKey]) {
						todasLasCuentas[niifKey] = {
       niif: linea.niif, 
       descripcionLinea: linea.linea, 
							cuentas: new Map()
						};
					}
     if (!linea?.cuentas || linea.cuentas?.length === 0) return;      linea.cuentas.forEach(cuenta => { 
      if (cuenta.cuenta) { 
       const cuentaKey = cuenta.cuenta; 
       if (!todasLasCuentas[niifKey].cuentas.has(cuentaKey)) { 
        todasLasCuentas[niifKey].cuentas.set(cuentaKey, { 
         cuenta: cuenta.cuenta, 
         descripcion: cuenta.descripcion || '', 
         saldos: new Array(numCompanias).fill(0) 
								});
							}
       const companiaIndex = datosPorCompania.findIndex(d => d.compania.id === companiaId); 
							if (companiaIndex !== -1) {
        const cuentaData = todasLasCuentas[niifKey].cuentas.get(cuentaKey); 
        cuentaData.saldos[companiaIndex] = parseFloat(cuenta.funcional1) || 0; 
        if (!cuentaData.descripcion && cuenta.descripcion) { 
         cuentaData.descripcion = cuenta.descripcion; 
								}
        todasLasCuentas[niifKey].cuentas.set(cuentaKey, cuentaData); 
							}
						}
					});
				});
			});
   // Incluir cuentas de reclasificación (origen='R') aunque no existan en el detalle base por NIIF. 
   // Esto permite mostrar en la tabla superior el paso de un NIIF a otro para la misma cuenta. 
			const descripcionPorNiif = {};
   Object.keys(todasLasCuentas).forEach((niifKey) => { 
				const niifData = todasLasCuentas[niifKey];
    if (!descripcionPorNiif[niifData.niif]) { 
     descripcionPorNiif[niifData.niif] = niifData.descripcionLinea || 'AJUSTES'; 
				}
			});
   // Completar descripciones NIIF desde el balance consolidado para NIIFs que no traen detalle base. 
			if (this.balance && this.balance.length > 0) {
				this.balance.forEach((item) => {
     if (item && item.niif && !descripcionPorNiif[item.niif]) { 
      descripcionPorNiif[item.niif] = item.descripcion || item.linea || item.descripcion_linea || 'AJUSTES'; 
					}
				});
			}
     datosPorCompania.forEach((datoCompania) => { 
      if (!datoCompania?.ajustes || datoCompania.ajustes?.length === 0) return;       datoCompania.ajustes.forEach((ajuste) => { 
							const valorAjuste = parseFloat(
        ajuste.ajuste_funcional1 || 
        ajuste.ajuste_funcional1_rounded || 
        ajuste.ajuste_actual || 
        ajuste.ajuste_actual_rounded || 
								0
							) || 0;
       const tieneMovimientoAjuste = Math.abs(valorAjuste) > 0; 
       // Incluir cualquier cuenta con movimiento de ajuste (sin limitar por terminación de cuenta). 
							if (!tieneMovimientoAjuste) return;
     const niif = ajuste.niif; 
     const cuenta = ajuste.cuenta; 
					if (!niif || !cuenta) return;
						const descripcionLinea =
							descripcionPorNiif[niif] ||
       ajuste.descripcion_niif || 
       ajuste.linea || 
							'AJUSTES';
						const niifKey = `${niif}-${descripcionLinea}`;
						if (!todasLasCuentas[niifKey]) {
							todasLasCuentas[niifKey] = {
								niif: niif,
								descripcionLinea: descripcionLinea,
							cuentas: new Map()
						};
					}
     if (!todasLasCuentas[niifKey].cuentas.has(cuenta)) { 
      todasLasCuentas[niifKey].cuentas.set(cuenta, { 
							cuenta: cuenta,
       descripcion: ajuste.descripcion || '', 
        saldos: new Array(numCompanias).fill(0) 
							});
						}
      const companiaAjuste = Number(ajuste.id_compania); 
      const companiaIndex = datosPorCompania.findIndex( 
       d => Number(d.compania.id) === companiaAjuste 
						);
						if (companiaIndex !== -1) {
       const cuentaData = todasLasCuentas[niifKey].cuentas.get(cuenta); 
							// En reclasificación no forzar saldo espejo en NIIF destino:
       // el movimiento debe verse en AJUSTES/CONSOLIDADO cuando la cuenta no existe originalmente. 
       if (!cuentaData.descripcion && ajuste.descripcion) { 
        cuentaData.descripcion = ajuste.descripcion; 
							}
       todasLasCuentas[niifKey].cuentas.set(cuenta, cuentaData); 
						}
					});
				});
			this.ordenarNiifKeysParaDetalle(todasLasCuentas).forEach((niifKey) => {
				const dataNiif = todasLasCuentas[niifKey];
    worksheet.mergeCells(`A${n_fila}:B${n_fila}`); 
    worksheet.getCell(`A${n_fila}`).value = `${dataNiif.niif} - ${dataNiif.descripcionLinea}`; 
    worksheet.getCell(`A${n_fila}`).font = { name: "Calibri", size: 11, bold: true }; 
    worksheet.getCell(`A${n_fila}`).alignment = { horizontal: "center", vertical: "middle" }; 
    worksheet.getCell(`A${n_fila}`).fill = { 
					type: "pattern",
					pattern: "solid",
					fgColor: { argb: "F2F2F2" }
				};
    worksheet.getCell(`A${n_fila}`).border = { 
					top: { style: "thin" },
					left: { style: "thin" },
					bottom: { style: "thin" },
					right: { style: "thin" }
				};
				n_fila++;
				const headerRow = ['CUENTA', 'DESCRIPCIÓN'];
    for (let i = 0; i < datosPorCompania.length; i++) { 
     headerRow.push('FUNCIONAL'); 
				}
    headerRow.push('SUMATORIA'); 
    headerRow.push('AJUSTES'); 
    headerRow.push('CONSOLIDADO'); 
				if (esCombinado) {
     headerRow.push('COMBINADO'); 
     headerRow.push('TOTAL COMBINADO'); 
				}
    worksheet.addRow(headerRow); 
    for (let i = 1; i <= headerRow.length; i++) { 
     let headerCell = worksheet.getCell(n_fila, i); 
     headerCell.font = { name: "Calibri", size: 11, bold: true }; 
     headerCell.alignment = { horizontal: "center", vertical: "middle" }; 
					if (i <= 2) {
      headerCell.fill = { 
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "E6E6E6" }
						};
					} else if (i <= numCompanias + 2) {
						const companiaIndex = i - 3;
						if (companiaIndex % 2 === 0) {
       headerCell.fill = { 
								type: "pattern",
								pattern: "solid",
								fgColor: { argb: "FCE4D6" }
							};
						} else {
       headerCell.fill = { 
								type: "pattern",
								pattern: "solid",
								fgColor: { argb: "D9EAD3" }
							};
						}
					} else {
      headerCell.fill = { 
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "E6E6E6" }
						};
					}
     headerCell.border = { 
						top: { style: "thin" },
						left: { style: "thin" },
						bottom: { style: "thin" },
						right: { style: "thin" }
					};
				}
				n_fila++;
    const cuentasArray = Array.from(dataNiif.cuentas.values()) 
     .sort((a, b) => a.cuenta.localeCompare(b.cuenta)); 
    cuentasArray.forEach((cuenta) => { 
     const dataRow = [cuenta.cuenta, cuenta.descripcion]; 
     cuenta.saldos.forEach((saldo) => { 
      dataRow.push(saldo); 
					});
					let sumatoria = 0;
     cuenta.saldos.forEach(saldo => { 
						sumatoria += saldo;
					});
     dataRow.push(sumatoria); 
     const ajusteCuenta = ajustesPorNiifCuenta[dataNiif.niif]?.[cuenta.cuenta] || 0;
     dataRow.push(ajusteCuenta); 
					const consolidado = sumatoria + ajusteCuenta;
     dataRow.push(consolidado); 
					let combinadoValor = 0;
					if (esCombinado) {
      combinadoValor = ajustesOrigenBPorCuenta[cuenta.cuenta] || 0; 
      dataRow.push(combinadoValor); 
      dataRow.push(consolidado + combinadoValor); 
					}
     worksheet.addRow(dataRow); 
					let colCell = 1;
     let dataCell = worksheet.getCell(n_fila, colCell); 
     dataCell.font = { name: "Calibri", size: 10 }; 
     dataCell.alignment = { horizontal: "left", vertical: "middle" }; 
     dataCell.border = { 
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					};
					colCell++;
     dataCell = worksheet.getCell(n_fila, colCell); 
     dataCell.font = { name: "Calibri", size: 10 }; 
     dataCell.alignment = { horizontal: "left", vertical: "middle" }; 
     dataCell.border = { 
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					};
					colCell++;
     cuenta.saldos.forEach((saldo, saldoIndex) => { 
      dataCell = worksheet.getCell(n_fila, colCell); 
      dataCell.value = saldo; 
      dataCell.font = { name: "Calibri", size: 10 }; 
      dataCell.alignment = { horizontal: "right", vertical: "middle" }; 
      dataCell.numFmt = "#,##0"; 
						if (saldoIndex % 2 === 0) {
       dataCell.fill = { 
								type: "pattern",
								pattern: "solid",
								fgColor: { argb: "FCF8F3" }
							};
						} else {
       dataCell.fill = { 
								type: "pattern",
								pattern: "solid",
								fgColor: { argb: "F7FCF5" }
							};
						}
      dataCell.border = { 
							left: { style: "thin" },
							right: { style: "thin" },
							bottom: { style: "thin" }
						};
						colCell++;
					});
     dataCell = worksheet.getCell(n_fila, colCell); 
     dataCell.value = sumatoria; 
     dataCell.font = { name: "Calibri", size: 10 }; 
     dataCell.alignment = { horizontal: "right", vertical: "middle" }; 
     dataCell.numFmt = "#,##0"; 
     dataCell.border = { 
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					};
					colCell++;
     dataCell = worksheet.getCell(n_fila, colCell); 
     dataCell.value = ajusteCuenta; 
     dataCell.font = { name: "Calibri", size: 10 }; 
     dataCell.alignment = { horizontal: "right", vertical: "middle" }; 
     dataCell.numFmt = "#,##0"; 
     dataCell.border = { 
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					};
					colCell++;
     dataCell = worksheet.getCell(n_fila, colCell); 
     dataCell.value = consolidado; 
     dataCell.font = { name: "Calibri", size: 10 }; 
     dataCell.alignment = { horizontal: "right", vertical: "middle" }; 
     dataCell.numFmt = "#,##0"; 
     dataCell.border = { 
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					};
					colCell++;
					if (esCombinado) {
      dataCell = worksheet.getCell(n_fila, colCell); 
      dataCell.value = combinadoValor; 
      dataCell.font = { name: "Calibri", size: 10 }; 
      dataCell.alignment = { horizontal: "right", vertical: "middle" }; 
      dataCell.numFmt = "#,##0"; 
      dataCell.border = { 
							left: { style: "thin" },
							right: { style: "thin" },
							bottom: { style: "thin" }
						};
						colCell++;
      dataCell = worksheet.getCell(n_fila, colCell); 
      dataCell.value = consolidado + combinadoValor; 
      dataCell.font = { name: "Calibri", size: 10 }; 
      dataCell.alignment = { horizontal: "right", vertical: "middle" }; 
      dataCell.numFmt = "#,##0"; 
      dataCell.border = { 
							left: { style: "thin" },
							right: { style: "thin" },
							bottom: { style: "thin" }
						};
					}
					n_fila++;
				});
    const totalRow = ['', 'TOTAL ' + dataNiif.niif]; 
    const totalesPorCompania = new Array(numCompanias).fill(0); 
				let totalSumatoria = 0;
    cuentasArray.forEach(cuenta => { 
     cuenta.saldos.forEach((saldo, idx) => { 
						totalesPorCompania[idx] += saldo;
					});
				});
    totalesPorCompania.forEach(total => { 
     totalRow.push(total); 
					totalSumatoria += total;
				});
    const ajusteNiif = ajustesPorNiif[dataNiif.niif] || 0; 
    totalRow.push(totalSumatoria); 
    totalRow.push(ajusteNiif); 
				const consolidadoTotal = totalSumatoria + ajusteNiif;
    totalRow.push(consolidadoTotal); 
				let totalCombinadoNiif = 0;
				if (esCombinado) {
     cuentasArray.forEach(cuenta => { 
      totalCombinadoNiif += ajustesOrigenBPorCuenta[cuenta.cuenta] || 0; 
					});
     totalRow.push(totalCombinadoNiif); 
     totalRow.push(consolidadoTotal + totalCombinadoNiif); 
				}
    worksheet.addRow(totalRow); 
				let colTotal = 1;
    let totalCell = worksheet.getCell(n_fila, colTotal); 
    totalCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }; 
				colTotal++;
    totalCell = worksheet.getCell(n_fila, colTotal); 
    totalCell.font = { name: "Calibri", size: 10, bold: true }; 
    totalCell.alignment = { horizontal: "right", vertical: "middle" }; 
    totalCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }; 
				colTotal++;
    totalesPorCompania.forEach((total) => { 
     let companiaCell = worksheet.getCell(n_fila, colTotal); 
     companiaCell.value = total; 
     companiaCell.font = { name: "Calibri", size: 10, bold: true }; 
     companiaCell.alignment = { horizontal: "right", vertical: "middle" }; 
     companiaCell.numFmt = "#,##0"; 
     companiaCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }; 
     companiaCell.border = { 
						top: { style: "thin" },
						bottom: { style: "double" }
					};
					colTotal++;
				});
    let sumatoriaCellTotal = worksheet.getCell(n_fila, colTotal); 
    sumatoriaCellTotal.value = totalSumatoria; 
    sumatoriaCellTotal.font = { name: "Calibri", size: 10, bold: true }; 
    sumatoriaCellTotal.alignment = { horizontal: "right", vertical: "middle" }; 
    sumatoriaCellTotal.numFmt = "#,##0"; 
    sumatoriaCellTotal.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "D9E1F2" } }; 
    sumatoriaCellTotal.border = { 
					top: { style: "thin" },
					bottom: { style: "double" }
				};
				colTotal++;
    let ajustesCellTotal = worksheet.getCell(n_fila, colTotal); 
    ajustesCellTotal.value = ajusteNiif; 
    ajustesCellTotal.font = { name: "Calibri", size: 10, bold: true }; 
    ajustesCellTotal.alignment = { horizontal: "right", vertical: "middle" }; 
    ajustesCellTotal.numFmt = "#,##0"; 
    ajustesCellTotal.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF2CC" } }; 
    ajustesCellTotal.border = { 
					top: { style: "thin" },
					bottom: { style: "double" }
				};
				colTotal++;
    let consolidadoCellTotal = worksheet.getCell(n_fila, colTotal); 
    consolidadoCellTotal.value = consolidadoTotal; 
    consolidadoCellTotal.font = { name: "Calibri", size: 10, bold: true }; 
    consolidadoCellTotal.alignment = { horizontal: "right", vertical: "middle" }; 
    consolidadoCellTotal.numFmt = "#,##0"; 
    consolidadoCellTotal.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E2EFDA" } }; 
    consolidadoCellTotal.border = { 
					top: { style: "thin" },
					bottom: { style: "double" }
				};
				colTotal++;
				if (esCombinado) {
     let combinadoCellTotal = worksheet.getCell(n_fila, colTotal); 
     combinadoCellTotal.value = totalCombinadoNiif; 
     combinadoCellTotal.font = { name: "Calibri", size: 10, bold: true }; 
     combinadoCellTotal.alignment = { horizontal: "right", vertical: "middle" }; 
     combinadoCellTotal.numFmt = "#,##0"; 
     combinadoCellTotal.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFE699" } }; 
     combinadoCellTotal.border = { 
						top: { style: "thin" },
						bottom: { style: "double" }
					};
					colTotal++;
     let totalCombinadoCell = worksheet.getCell(n_fila, colTotal); 
     totalCombinadoCell.value = consolidadoTotal + totalCombinadoNiif; 
     totalCombinadoCell.font = { name: "Calibri", size: 10, bold: true }; 
     totalCombinadoCell.alignment = { horizontal: "right", vertical: "middle" }; 
     totalCombinadoCell.numFmt = "#,##0"; 
     totalCombinadoCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "B8CCE4" } }; 
     totalCombinadoCell.border = { 
						top: { style: "thin" },
						bottom: { style: "double" }
					};
				}
				n_fila++;
			});
   const totalesEcuacionPorCompania = new Array(datosPorCompania.length).fill(0); 
			let sumaTotalEcuacion = 0;
			let sumaAjustesEcuacion = 0;
			this.ordenarNiifKeysParaDetalle(todasLasCuentas).forEach(niifKey => {
				const dataNiif = todasLasCuentas[niifKey];
    const cuentasArray = Array.from(dataNiif.cuentas.values()); 
    const totalesPorCompaniaNiif = new Array(datosPorCompania.length).fill(0); 
    cuentasArray.forEach(cuenta => { 
     cuenta.saldos.forEach((saldo, idx) => { 
						totalesPorCompaniaNiif[idx] += saldo;
					});
				});
    totalesPorCompaniaNiif.forEach((total, idx) => { 
					totalesEcuacionPorCompania[idx] += total;
				});
    const totalNiif = totalesPorCompaniaNiif.reduce((a, b) => a + b, 0); 
    const ajusteNiif = ajustesPorNiif[dataNiif.niif] || 0; 
				sumaTotalEcuacion += totalNiif;
				sumaAjustesEcuacion += ajusteNiif;
			});
			const ecuacionRowData = ['ECUACIÓN PATRIMONIAL', ''];
   datosPorCompania.forEach((datoCompania, idx) => { 
				const totalCompania = totalesEcuacionPorCompania[idx] || 0;
    ecuacionRowData.push(totalCompania); 
			});
   ecuacionRowData.push(sumaTotalEcuacion); 
   ecuacionRowData.push(sumaAjustesEcuacion); 
			const consolidadoEcuacion = sumaTotalEcuacion + sumaAjustesEcuacion;
   ecuacionRowData.push(consolidadoEcuacion); 
			if (esCombinado) {
				let totalCombinadoEcuacion = 0;
    Object.values(ajustesOrigenBPorCuenta).forEach(valor => { 
					totalCombinadoEcuacion += valor;
				});
    ecuacionRowData.push(totalCombinadoEcuacion); 
    ecuacionRowData.push(consolidadoEcuacion + totalCombinadoEcuacion); 
			}
   worksheet.addRow(ecuacionRowData); 
   for (let i = 1; i <= ecuacionRowData.length; i++) { 
    const ecuacionCell = worksheet.getCell(n_fila, i); 
				if (i === 1) {
     ecuacionCell.font = { name: "Calibri", size: 11, bold: true }; 
     ecuacionCell.alignment = { horizontal: "left", vertical: "middle" }; 
     worksheet.mergeCells(n_fila, 1, n_fila, 2); 
				} else if (i === 2) {
					continue;
				} else {
     ecuacionCell.font = { name: "Calibri", size: 11, bold: true }; 
     ecuacionCell.alignment = { horizontal: "right", vertical: "middle" }; 
     ecuacionCell.numFmt = "#,##0"; 
     if (i <= datosPorCompania.length + 2) { 
						if ((i - 2) % 2 === 1) {
       ecuacionCell.fill = { 
								type: "pattern",
								pattern: "solid",
								fgColor: { argb: "FCE4D6" }
							};
						} else {
       ecuacionCell.fill = { 
								type: "pattern",
								pattern: "solid",
								fgColor: { argb: "D9EAD3" }
							};
						}
     } else if (i === datosPorCompania.length + 3) { 
      ecuacionCell.fill = { 
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "D9E1F2" }
						};
     } else if (i === datosPorCompania.length + 4) { 
      ecuacionCell.fill = { 
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "FFF2CC" }
						};
     } else if (i === datosPorCompania.length + 5) { 
      ecuacionCell.fill = { 
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "E2EFDA" }
						};
     } else if (i === datosPorCompania.length + 6) { 
      ecuacionCell.fill = { 
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "FFE699" }
						};
     } else if (i === datosPorCompania.length + 7) { 
      ecuacionCell.fill = { 
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "B8CCE4" }
						};
					}
				}
    ecuacionCell.border = { 
					top: { style: "medium" },
					left: { style: "thin" },
					right: { style: "thin" },
					bottom: { style: "double" }
				};
			}
			n_fila++;
   worksheet.addRow([]); 
			n_fila++;
   if (todosAjustes.length > 0) { 
    worksheet.addRow([]); 
				n_fila++;
				const ajustesHeaders = [
					'COMPAÑIA',
					'NIIF',
					'SECUENCIA',
					'TIPO',
					'TIPO AJUSTE',
					'CUENTA',
					'SALDO ORIGINAL',
					'AJUSTE LOCAL',
					'AJUSTE FUNCIONAL',
					'DESCRIPCIÓN',
					'ORIGEN'
				];
    const totalColumnsAjustes = ajustesHeaders.length; 
    const endColAjustes = String.fromCharCode(65 + totalColumnsAjustes - 1); 
    worksheet.mergeCells(`A${n_fila}:${endColAjustes}${n_fila}`); 
    worksheet.getCell(`A${n_fila}`).value = `AJUSTES DE CONSOLIDACIÓN - ${grupo ? grupo.nombre : 'GRUPO'}`;
    worksheet.getCell(`A${n_fila}`).font = { name: "Calibri", size: 12, bold: true }; 
    worksheet.getCell(`A${n_fila}`).fill = { 
					type: "pattern",
					pattern: "solid",
					fgColor: { argb: "FFF2CC" }
				};
    worksheet.getCell(`A${n_fila}`).alignment = { horizontal: "center", vertical: "middle" }; 
				n_fila++;
    for (let i = 0; i < ajustesHeaders.length; i++) { 
     worksheet.getCell(n_fila, i + 1).value = ajustesHeaders[i]; 
     worksheet.getCell(n_fila, i + 1).font = { name: "Calibri", size: 11, bold: true }; 
     worksheet.getCell(n_fila, i + 1).alignment = { horizontal: "center", vertical: "middle" }; 
     worksheet.getCell(n_fila, i + 1).fill = { 
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "E6E6E6" }
					};
     worksheet.getCell(n_fila, i + 1).border = { 
						top: { style: "thin" },
						left: { style: "thin" },
						bottom: { style: "thin" },
						right: { style: "thin" }
					};
				}
				n_fila++;
    todosAjustes.forEach((ajuste) => { 
     let tipoAjusteTexto = ajuste.tipo_ajuste || ''; 
					if (tipoAjusteTexto === 'O') {
						tipoAjusteTexto = 'Origen';
					} else if (tipoAjusteTexto === 'D') {
						tipoAjusteTexto = 'Destino';
					}
     let niifConDescripcion = ajuste.niif || ''; 
					if (this.balance && this.balance.length > 0 && ajuste.niif) {
						const niifInfo = this.balance.find(item => item.niif === ajuste.niif);
      if (niifInfo && niifInfo.descripcion) { 
       niifConDescripcion = `${ajuste.niif} - ${niifInfo.descripcion}`; 
						}
					}
     worksheet.getCell(n_fila, 1).value = ajuste.compania_origen || ''; 
     worksheet.getCell(n_fila, 2).value = niifConDescripcion; 
     worksheet.getCell(n_fila, 3).value = ajuste.secuencia || ''; 
     worksheet.getCell(n_fila, 4).value = ajuste.tipo_participante || ''; 
     worksheet.getCell(n_fila, 5).value = tipoAjusteTexto; 
     worksheet.getCell(n_fila, 6).value = ajuste.cuenta || ''; 
     worksheet.getCell(n_fila, 7).value = ajuste.saldo_actual || 0; 
     worksheet.getCell(n_fila, 8).value = ajuste.ajuste_actual || ajuste.ajuste_actual_rounded || 0; 
     worksheet.getCell(n_fila, 9).value = 
      ajuste.ajuste_funcional1 || 
      ajuste.ajuste_funcional1_rounded || 
      ajuste.ajuste_actual || 
      ajuste.ajuste_actual_rounded || 
						0;
     worksheet.getCell(n_fila, 10).value = ajuste.descripcion || ''; 
     worksheet.getCell(n_fila, 11).value = ajuste.origen || ''; 
     for (let i = 1; i <= ajustesHeaders.length; i++) { 
      const ajusteCell = worksheet.getCell(n_fila, i); 
      ajusteCell.font = { name: "Calibri", size: 10 }; 
      ajusteCell.alignment = { horizontal: "left", vertical: "middle" }; 
						if (i >= 7 && i <= 9) {
       ajusteCell.alignment = { horizontal: "right", vertical: "middle" }; 
       ajusteCell.numFmt = "#,##0"; 
						}
      ajusteCell.fill = { 
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "F5F5F5" }
						};
      ajusteCell.border = { 
							left: { style: "thin" },
							right: { style: "thin" },
							bottom: { style: "thin" }
						};
					}
					n_fila++;
				});
			}
			const columnWidths = [
				{ width: 15 },
				{ width: 40 },
			];
			for (let i = 0; i < numCompanias; i++) {
    columnWidths.push({ width: 18 }); 
			}
   columnWidths.push({ width: 18 }); 
   columnWidths.push({ width: 18 }); 
   columnWidths.push({ width: 18 }); 
			if (esCombinado) {
    columnWidths.push({ width: 18 }); 
    columnWidths.push({ width: 18 }); 
			}
   worksheet.columns = columnWidths; 
   worksheet.views = [ 
				{ state: 'frozen', ySplit: 4 }
			];
		},
		// MÉTODO AUXILIAR PARA SANITIZAR NOMBRES DE HOJAS
		sanitizeSheetName(name) {
			// Excel limita a 31 caracteres y no permite ciertos caracteres
   let sanitized = name.replace(/[\\/*.[\]]/g, '_'); 
   return sanitized?.substring(0, 31); 		},
		async descargarDetalleCompania(companiaId, companiaNombre, esCombinado = false) {
			this.showGeneratingModal = true;
			this.generatingMessage = 'Generando detalle...';
			this.generatingSubMessage = `Empresa: ${companiaNombre}`;
			this.generatingProgress = 25;
			try {
				this.$toast.info(`Generando detalle para ${companiaNombre}...`);
    const resultBalance = await Balance.getBalanceNiif( 
					this.codReporte,
					companiaId,
					this.vigencia
				);
    const balanceCompania = resultBalance.data.balanceNiif; 
    if (!balanceCompania || balanceCompania.length === 0) { 
					this.$toast.warning(`La compañía ${companiaNombre} no tiene datos`);
					this.showGeneratingModal = false;
					return;
				}
				this.generatingProgress = 50;
				this.generatingMessage = 'Obteniendo detalles de cuentas...';
				const lineasConCuentas = [];
				for (const linea of balanceCompania) {
     if (linea.informacion === "I") { 
						try {
       const resultCuentas = await Balance.getCuentasNiif( 
								this.codReporte,
								companiaId,
								this.vigencia,
        linea.niif 
							);
       if (resultCuentas.data.cuentas.length > 0) { 
        lineasConCuentas.push({ 
         linea: linea.descripcion, 
         niif: linea.niif, 
         cuentas: resultCuentas.data.cuentas 
								});
							}
						} catch (error) {
       console.warn(`Error obteniendo cuentas para ${linea.niif}:`, error); 
						}
					}
				}
				const ajustes = await this.obtenerAjustesPorEmpresa(companiaId, this.vigencia, []);
				this.generatingProgress = 75;
				this.generatingMessage = 'Organizando datos...';
				const datos = {
					titulo: `DETALLE COMPLETO - ${companiaNombre}`,
					compania: companiaNombre,
					vigencia: this.vigencia,
					reporte: this.reportes.find(r => r.codigo === this.codReporte).nombre || 'Balance',
					informacion: lineasConCuentas,
					ajustes: ajustes || [],
					userName: this.$store.state.userName,
					esCombinado: esCombinado,
					esDescargaIndividual: true
				};
				this.generatingProgress = 90;
				this.generatingMessage = 'Generando Excel...';
				await this.hojaExcelDetalleCompleto(datos, companiaId, esCombinado);
				this.generatingProgress = 100;
				setTimeout(() => {
					this.showGeneratingModal = false;
				}, 500);
			} catch (error) {
    console.error('Error descargando detalle:', error); 
				this.$toast.error(`Error al generar detalle para ${companiaNombre}`);
				this.showGeneratingModal = false;
			}
		},
		// Método auxiliar para descargar detalle de múltiples compañías
		async descargarDetalleMultipleCompanias(companias, esCombinado = false) {
			this.showGeneratingModal = true;
			this.generatingMessage = 'Recopilando información...';
			this.generatingSubMessage = `Procesando ${companias.length} compañía(s)`;
			this.generatingProgress = 0;
			try {
				this.$toast.info(`Generando detalle completo para ${companias.length} compañía(s)...`);
				// CORRECCIÓN: Crear workbook correctamente con ExcelJS
				const ExcelJS = require('exceljs');
    const workbook = new ExcelJS.Workbook(); 
    const worksheet = workbook.addWorksheet("Detalle Todas Empresas"); 
				const combinacionesAgregadas = new Set();
				const datosPorCompania = [];
    const totalCompanias = companias.length; 
    for (let i = 0; i < companias.length; i++) { 
					const compania = companias[i];
					this.generatingProgress = Math.round((i / totalCompanias) * 50);
					this.generatingMessage = `Procesando compañía ${i + 1} de ${totalCompanias}`;
					this.generatingSubMessage = `Empresa: ${compania.nombre}`;
					try {
      const resultBalance = await Balance.getBalanceNiif( 
							this.codReporte,
       compania.id, 
							this.vigencia
						);
      const balanceCompania = resultBalance.data.balanceNiif; 
      if (!balanceCompania || balanceCompania.length === 0) continue; 
						const detalleCompleto = [];
						for (const linea of balanceCompania) {
       if (linea.informacion === "I") { 
								try {
         const resultCuentas = await Balance.getCuentasNiif( 
										this.codReporte,
          compania.id, 
										this.vigencia,
          linea.niif 
									);
         if (resultCuentas.data.cuentas.length > 0) { 
          detalleCompleto.push({ 
           linea: linea.descripcion, 
           niif: linea.niif, 
           cuentas: resultCuentas.data.cuentas 
										});
									}
								} catch (error) {
         console.warn(`Error obteniendo cuentas ${linea.niif}`, error); 
								}
							}
						}
						// 🔹 Obtener ajustes
						const ajustesRaw = await this.obtenerAjustesPorEmpresa(
							compania.id,
							this.vigencia,
							this.EmpresasConsolidaExcel || []
						);
						// 🔹 FILTRO FINO
						const ajustesFiltrados = [];
						for (const ajuste of ajustesRaw) {
       const secuencia = ajuste.secuencia; 
       const cuenta = ajuste.cuenta; 
       const tipoAjuste = ajuste.tipo_ajuste || ajuste.tipo || ''; 
       const idCompaniaAjuste = Number(ajuste.id_compania || 0); 
       const origenAjuste = ajuste.origen || ''; 
       const niifAjuste = ajuste.niif || ''; 
							const clave = `${idCompaniaAjuste}|${origenAjuste}|${secuencia}|${cuenta}|${tipoAjuste}|${niifAjuste}`;
       if (!combinacionesAgregadas.has(clave)) { 
        combinacionesAgregadas.add(clave); 
        ajustesFiltrados.push(ajuste); 
							}
						}
      if (detalleCompleto.length > 0 || ajustesFiltrados.length > 0) { 
       datosPorCompania.push({ 
								compania,
								detalle: detalleCompleto,
								ajustes: ajustesFiltrados
							});
						}
					} catch (error) {
      console.error(`Error procesando ${compania.nombre}:`, error); 
					}
				}
    if (datosPorCompania.length === 0) { 
					this.showGeneratingModal = false;
					this.$toast.warning("No se pudo generar detalle para ninguna compañía");
					return;
				}
				this.generatingProgress = 75;
				this.generatingMessage = 'Generando archivo Excel...';
				this.generatingSubMessage = 'Organizando datos';
				// Asegurarse de que this.obtenerAjustesOrigenB existe
				if (typeof this.obtenerAjustesOrigenB !== 'function') {
     console.warn("Método obtenerAjustesOrigenB no encontrado, creando método temporal"); 
					this.obtenerAjustesOrigenB = async function () {
						try {
							const response = await Balance.getAjustesOrigenB(this.codReporte, this.vigencia);
       return response.data?.ajustesOrigenB || []; 						} catch (error) {
       console.error("Error en obtenerAjustesOrigenB:", error); 
							return [];
						}
					};
				}
				// Llamar al método llenarHojaCombinada
				await this.llenarHojaCombinada(worksheet, datosPorCompania, "", esCombinado);
				this.generatingProgress = 95;
				this.generatingMessage = 'Finalizando archivo...';
				// CORRECCIÓN: Usar el método correcto de ExcelJS para obtener el buffer
    const buffer = await workbook.xlsx.writeBuffer(); 
				this.generatingProgress = 100;
				this.generatingMessage = '¡Completado!';
					const nombreArchivo = esCombinado
						? `Detalle_Completo_Combinado_${this.vigencia}.xlsx`
						: `Detalle_Completo_${this.vigencia}.xlsx`;
				setTimeout(() => {
					this.showGeneratingModal = false;
					this.descargarArchivo(buffer, nombreArchivo);
					this.$toast.success("Detalle completo generado exitosamente");
				}, 500);
			} catch (error) {
				this.showGeneratingModal = false;
    console.error('Error generando detalle múltiple:', error); 
				this.$toast.error("Error al generar el detalle completo");
			}
		},
		async llenarHojaCombinada(worksheet, datosPorCompania, grupoNombre = "", esCombinado = false) {
			const titulo = `DETALLE COMPLETO - TODAS LAS EMPRESAS (CONSOLIDADO)`;
			let tituloConGrupo = titulo;
			if (grupoNombre) {
				tituloConGrupo = `DETALLE COMPLETO - ${grupoNombre} (CONSOLIDADO)`;
			}
			const vigencia = this.vigencia;
			const userName = this.$store.state.userName;
			const reporte = this.reportes.find(r => r.codigo === this.codReporte).nombre || 'Balance';
			// Obtener ajustes de origen B (esto es adicional, no debe afectar el Excel)
			let ajustesOrigenBExternos = [];
			try {
				if (typeof this.obtenerAjustesOrigenB === 'function') {
					ajustesOrigenBExternos = await this.obtenerAjustesOrigenB();
				} else {
     console.warn("Método obtenerAjustesOrigenB no disponible"); 
				}
			} catch (error) {
    console.error("Error obteniendo ajustes de origen B:", error); 
				// Continuamos con el Excel aunque fallen los ajustes
			}
			const idsCompaniasSeleccionadas = new Set(
    (datosPorCompania || []).map(d => Number(d.compania.id)) 
			);
   ajustesOrigenBExternos = (ajustesOrigenBExternos || []).filter( 
    ajuste => idsCompaniasSeleccionadas.has(Number(ajuste.id_compania)) 
			);
			ajustesOrigenBExternos = this.deduplicarCombinadosB(ajustesOrigenBExternos);
			const combinacionesAgregadas = new Set();
			let createdAt1 = new Date();
   let anio = createdAt1.getFullYear(); 
   let mes = String(createdAt1.getMonth() + 1).padStart(2, '0'); 
   let dia = String(createdAt1.getDate()).padStart(2, '0'); 
			let createdAt = anio + "-" + mes + "-" + dia;
			// ENCABEZADO PRINCIPAL - Calcular dinámicamente el rango de columnas
   let totalColumnsDetalle = 2 + datosPorCompania.length + 3; // CUENTA + DESCRIPCIÓN + N compañías + SUMATORIA + AJUSTES + CONSOLIDADO 
			if (esCombinado) {
				totalColumnsDetalle += 2; // Agregar COMBINADO y TOTAL COMBINADO
			}
   console.log("totalColumnsDetalle:", totalColumnsDetalle); 
   const endColDetalle = String.fromCharCode(65 + totalColumnsDetalle - 1); 
   worksheet.mergeCells(`A1:${endColDetalle}1`); 
   worksheet.getCell('A1').value = tituloConGrupo; 
   worksheet.getCell('A1').font = { name: "Calibri", size: 16, bold: true }; 
   worksheet.getCell('A1').alignment = { horizontal: "center", vertical: "middle" }; 
   worksheet.mergeCells(`A2:${endColDetalle}2`); 
   worksheet.getCell('A2').value = `Vigencia: ${vigencia} | Empresas: ${datosPorCompania.map(d => d.compania.nombre).join(', ')}`; 
   worksheet.getCell('A2').font = { name: "Calibri", size: 11, bold: true }; 
   worksheet.getCell('A2').alignment = { horizontal: "center", vertical: "middle" }; 
   worksheet.mergeCells(`A3:${endColDetalle}3`); 
   worksheet.getCell('A3').value = `Generado: ${createdAt} por ${userName} | Reporte: ${reporte}`; 
   worksheet.getCell('A3').font = { name: "Calibri", size: 11, bold: true }; 
   worksheet.getCell('A3').alignment = { horizontal: "center", vertical: "middle" }; 
   worksheet.addRow([]); 
			let n_fila = 5;
   const numCompanias = datosPorCompania.length; 
   console.log("numCompanias:", numCompanias); 
			const companiasRow = ['COMPAÑÍAS', ''];
			// Agregar nombres de compañías en la fila de "Compañías"
   datosPorCompania.forEach((datoCompania, idx) => { 
    console.log(`Compañía ${idx + 1}:`, datoCompania.compania.nombre); 
    companiasRow.push(datoCompania.compania.nombre); 
			});
			// Agregar las nuevas columnas al final
   companiasRow.push('SUMATORIA'); 
   companiasRow.push('AJUSTES'); 
   companiasRow.push('CONSOLIDADO'); 
			if (esCombinado) {
    companiasRow.push('COMBINADO'); 
    companiasRow.push('TOTAL COMBINADO'); 
			}
   console.log("companiasRow:", companiasRow); 
   worksheet.addRow(companiasRow); 
			// Aplicar estilos a la fila de Compañías
			// Primera columna "COMPAÑÍAS"
   let companiaCell = worksheet.getCell(n_fila, 1); 
   companiaCell.font = { name: "Calibri", size: 11, bold: true }; 
   companiaCell.alignment = { horizontal: "center", vertical: "middle" }; 
   companiaCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }; 
   worksheet.mergeCells(n_fila, 1, n_fila, 2); 
			// Nombres de compañías en sus columnas correspondientes
   datosPorCompania.forEach((datoCompania, idx) => { 
    let nombreCompaniaCell = worksheet.getCell(n_fila, idx + 3); 
    nombreCompaniaCell.font = { name: "Calibri", size: 11, bold: true }; 
    nombreCompaniaCell.alignment = { horizontal: "center", vertical: "middle" }; 
				if (idx % 2 === 0) {
     nombreCompaniaCell.fill = { 
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "FCE4D6" }
					};
				} else {
     nombreCompaniaCell.fill = { 
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "D9EAD3" }
					};
				}
    nombreCompaniaCell.border = { 
					top: { style: "thin" },
					left: { style: "thin" },
					bottom: { style: "thin" },
					right: { style: "thin" }
				};
			});
			// Estilos para las nuevas columnas
			const sumatoriaCol = numCompanias + 3;
			const ajustesCol = sumatoriaCol + 1;
			const consolidadoCol = ajustesCol + 1;
   console.log("Posiciones columnas - sumatoriaCol:", sumatoriaCol, "ajustesCol:", ajustesCol, "consolidadoCol:", consolidadoCol); 
			// SUMATORIA
   let sumatoriaCell = worksheet.getCell(n_fila, sumatoriaCol); 
   sumatoriaCell.font = { name: "Calibri", size: 11, bold: true }; 
   sumatoriaCell.alignment = { horizontal: "center", vertical: "middle" }; 
   sumatoriaCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }; 
			// AJUSTES
   let ajustesCell = worksheet.getCell(n_fila, ajustesCol); 
   ajustesCell.font = { name: "Calibri", size: 11, bold: true }; 
   ajustesCell.alignment = { horizontal: "center", vertical: "middle" }; 
   ajustesCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }; 
			// CONSOLIDADO
   let consolidadoCell = worksheet.getCell(n_fila, consolidadoCol); 
   consolidadoCell.font = { name: "Calibri", size: 11, bold: true }; 
   consolidadoCell.alignment = { horizontal: "center", vertical: "middle" }; 
   consolidadoCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }; 
			// AGREGAR ESTILOS PARA COMBINADO Y TOTAL COMBINADO
			if (esCombinado) {
				const combinadoCol = consolidadoCol + 1;
				const totalCombinadoCol = combinadoCol + 1;
				// COMBINADO
    let combinadoCell = worksheet.getCell(n_fila, combinadoCol); 
    combinadoCell.font = { name: "Calibri", size: 11, bold: true }; 
    combinadoCell.alignment = { horizontal: "center", vertical: "middle" }; 
    combinadoCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }; 
				// TOTAL COMBINADO
    let totalCombinadoCell = worksheet.getCell(n_fila, totalCombinadoCol); 
    totalCombinadoCell.font = { name: "Calibri", size: 11, bold: true }; 
    totalCombinadoCell.alignment = { horizontal: "center", vertical: "middle" }; 
    totalCombinadoCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }; 
			}
			n_fila++;
   console.log("Fila actual después de encabezados:", n_fila); 
			// ===== MAPAS DE AJUSTES =====
			const ajustesPorNiif = {};
			const ajustesPorNiifCuenta = {};
			const ajustesOrigenBPorCuenta = {}; // Para COMBINADO (solo origen B)
			// PROCESAR AJUSTES EXISTENTES (los que ya vienen en datosPorCompania)
   console.log("=== PROCESANDO AJUSTES EXISTENTES ==="); 
   datosPorCompania.forEach((datoCompania, idxCompania) => { 
    console.log(`Procesando ajustes de compañía ${idxCompania + 1}: ${datoCompania.compania.nombre}`); 
    if (datoCompania.ajustes && datoCompania.ajustes.length > 0) { 
     console.log(` Cantidad ajustes: ${datoCompania.ajustes.length}`); 
     datoCompania.ajustes.forEach((ajuste, idxAjuste) => { 
      const origenAjuste = String(ajuste.origen || '').toUpperCase(); 
						if (origenAjuste === 'B') return; // En AJUSTES no sumar combinados
      const niif = ajuste.niif; 
      const cuenta = ajuste.cuenta; 
						const valor = parseFloat(
       ajuste.ajuste_funcional1 || 
       ajuste.ajuste_funcional1_rounded || 
       ajuste.ajuste_actual || 
       ajuste.ajuste_actual_rounded || 
							0
						);
						if (idxAjuste < 3) { // Log solo primeros 3 ajustes para no saturar
       console.log(` Ajuste ${idxAjuste + 1}: niif=${niif}, cuenta=${cuenta}, valor=${valor}`); 
						}
						// TOTAL POR NIIF (para la fila TOTAL)
						if (!ajustesPorNiif[niif]) {
							ajustesPorNiif[niif] = 0;
						}
						ajustesPorNiif[niif] += valor;
						// TOTAL POR NIIF + CUENTA (para filas de cuentas)
						if (!ajustesPorNiifCuenta[niif]) {
							ajustesPorNiifCuenta[niif] = {};
						}
						if (!ajustesPorNiifCuenta[niif][cuenta]) {
							ajustesPorNiifCuenta[niif][cuenta] = 0;
						}
						ajustesPorNiifCuenta[niif][cuenta] += valor;
					});
				} else {
     console.log(` No hay ajustes para esta compañía`); 
				}
			});
			// PROCESAR AJUSTES DE ORIGEN B EXTERNOS (sin modificar datosPorCompania)
   console.log("=== PROCESANDO AJUSTES ORIGEN B EXTERNOS ==="); 
   if (ajustesOrigenBExternos && ajustesOrigenBExternos.length > 0) { 
    console.log(`Total ajustes origen B externos: ${ajustesOrigenBExternos.length}`); 
    ajustesOrigenBExternos.forEach((ajuste, idx) => { 
     const cuenta = ajuste.cuenta; 
					if (!ajustesOrigenBPorCuenta[cuenta]) {
						ajustesOrigenBPorCuenta[cuenta] = 0;
					}
					const valorOrigenB = parseFloat(
      ajuste.ajuste_actual || 
      ajuste.ajuste_actual_rounded || 
						0
					);
					ajustesOrigenBPorCuenta[cuenta] += valorOrigenB;
     console.log(` Ajuste ${idx + 1}: cuenta=${cuenta}, valor=${valorOrigenB}, total acumulado=${ajustesOrigenBPorCuenta[cuenta]}`); 
				});
			} else {
    console.log("No hay ajustes origen B externos"); 
			}
   console.log("AJUSTES ORIGEN B POR CUENTA FINAL:", ajustesOrigenBPorCuenta); 
			// Primero, recopilar todas las cuentas únicas de todas las compañías y NIIFs
   console.log("=== RECOPILANDO CUENTAS ==="); 
			const todasLasCuentas = {};
			// Recorrer todas las compañías y sus líneas NIIF
   datosPorCompania.forEach((datoCompania, idxCompania) => { 
    const companiaId = datoCompania.compania.id; 
    console.log(`Procesando detalle de compañía ${idxCompania + 1} (ID: ${companiaId})`); 
    if (!datoCompania.detalle || datoCompania.detalle.length === 0) { 
     console.log(` Compañía ${idxCompania + 1} no tiene detalle!`); 
					return;
				}
    console.log(` Detalle length: ${datoCompania.detalle.length}`); 
    datoCompania.detalle.forEach((linea, idxLinea) => { 
     const niifKey = `${linea.niif}-${linea.linea}`; 
					if (!todasLasCuentas[niifKey]) {
						todasLasCuentas[niifKey] = {
       niif: linea.niif, 
       descripcionLinea: linea.linea, 
							cuentas: new Map() // Usar Map para evitar duplicados por cuenta
						};
      console.log(` Creando NIIF key: ${niifKey}`); 
					}
					// Procesar cada cuenta de esta línea
     if (!linea.cuentas || linea.cuentas.length === 0) { 
      console.log(` Línea ${idxLinea + 1} no tiene cuentas!`); 
						return;
					}
     linea.cuentas.forEach((cuenta, idxCuenta) => { 
      if (cuenta.cuenta) { 
       const cuentaKey = cuenta.cuenta; 
       if (!todasLasCuentas[niifKey].cuentas.has(cuentaKey)) { 
								// Si la cuenta no existe, crearla
        todasLasCuentas[niifKey].cuentas.set(cuentaKey, { 
         cuenta: cuenta.cuenta, 
         descripcion: cuenta.descripcion || '', 
         saldos: new Array(numCompanias).fill(0) 
								});
								if (idxCuenta < 5) { // Log solo primeras 5 cuentas
         console.log(` Creando cuenta: ${cuentaKey} - ${cuenta.descripcion || ''}`); 
								}
							}
							// Obtener el índice de esta compañía
       const companiaIndex = datosPorCompania.findIndex(d => d.compania.id === companiaId); 
							if (companiaIndex !== -1) {
								// Actualizar el saldo en la posición correspondiente a esta compañía
        const cuentaData = todasLasCuentas[niifKey].cuentas.get(cuentaKey); 
        const saldoAnterior = cuentaData.saldos[companiaIndex]; 
        cuentaData.saldos[companiaIndex] = parseFloat(cuenta.funcional1) || 0; 
        if (idxCuenta < 5 && Math.abs(cuentaData.saldos[companiaIndex]) > 0) { 
         console.log(` Actualizando cuenta ${cuentaKey} para compañía ${companiaIndex + 1}: ${saldoAnterior} -> ${cuentaData.saldos[companiaIndex]}`); 
								}
								// Si la descripción está vacía y esta compañía tiene una, usarla
        if (!cuentaData.descripcion && cuenta.descripcion) { 
         cuentaData.descripcion = cuenta.descripcion; 
								}
        todasLasCuentas[niifKey].cuentas.set(cuentaKey, cuentaData); 
							}
						}
					});
				});
			});
   // Incluir cuentas de reclasificación (origen='R') aunque no existan en el detalle base por NIIF. 
   // Esto permite mostrar en la tabla superior el paso de un NIIF a otro para la misma cuenta. 
			const descripcionPorNiif = {};
   Object.keys(todasLasCuentas).forEach((niifKey) => { 
				const niifData = todasLasCuentas[niifKey];
    if (!descripcionPorNiif[niifData.niif]) { 
     descripcionPorNiif[niifData.niif] = niifData.descripcionLinea || 'AJUSTES'; 
				}
			});
   // Completar descripciones NIIF desde el balance consolidado para NIIFs que no traen detalle base. 
			if (this.balance && this.balance.length > 0) {
				this.balance.forEach((item) => {
     if (item && item.niif && !descripcionPorNiif[item.niif]) { 
      descripcionPorNiif[item.niif] = item.descripcion || item.linea || item.descripcion_linea || 'AJUSTES'; 
					}
				});
			}
     datosPorCompania.forEach((datoCompania) => { 
      if (!datoCompania?.ajustes || datoCompania.ajustes?.length === 0) return;       datoCompania.ajustes.forEach((ajuste) => { 
							const valorAjuste = parseFloat(
        ajuste.ajuste_funcional1 || 
        ajuste.ajuste_funcional1_rounded || 
        ajuste.ajuste_actual || 
        ajuste.ajuste_actual_rounded || 
								0
							) || 0;
       const tieneMovimientoAjuste = Math.abs(valorAjuste) > 0; 
       // Incluir cualquier cuenta con movimiento de ajuste (sin limitar por terminación de cuenta). 
							if (!tieneMovimientoAjuste) return;
     const niif = ajuste.niif; 
     const cuenta = ajuste.cuenta; 
					if (!niif || !cuenta) return;
						const descripcionLinea =
							descripcionPorNiif[niif] ||
       ajuste.descripcion_niif || 
       ajuste.linea || 
							'AJUSTES';
						const niifKey = `${niif}-${descripcionLinea}`;
						if (!todasLasCuentas[niifKey]) {
							todasLasCuentas[niifKey] = {
								niif: niif,
								descripcionLinea: descripcionLinea,
							cuentas: new Map()
						};
					}
     if (!todasLasCuentas[niifKey].cuentas.has(cuenta)) { 
      todasLasCuentas[niifKey].cuentas.set(cuenta, { 
							cuenta: cuenta,
       descripcion: ajuste.descripcion || '', 
        saldos: new Array(numCompanias).fill(0) 
							});
						}
      const companiaAjuste = Number(ajuste.id_compania); 
      const companiaIndex = datosPorCompania.findIndex( 
       d => Number(d.compania.id) === companiaAjuste 
						);
						if (companiaIndex !== -1) {
       const cuentaData = todasLasCuentas[niifKey].cuentas.get(cuenta); 
							// En reclasificación no forzar saldo espejo en NIIF destino:
       // el movimiento debe verse en AJUSTES/CONSOLIDADO cuando la cuenta no existe originalmente. 
       if (!cuentaData.descripcion && ajuste.descripcion) { 
        cuentaData.descripcion = ajuste.descripcion; 
							}
       todasLasCuentas[niifKey].cuentas.set(cuenta, cuentaData); 
						}
					});
				});
   console.log("Total NIIFs procesados:", Object.keys(todasLasCuentas).length); 
			// Ahora, para cada NIIF, crear la sección en el Excel
   console.log("=== CREANDO SECCIONES EN EXCEL ==="); 
			const niifKeys = this.ordenarNiifKeysParaDetalle(todasLasCuentas);
   console.log("NIIFs a procesar:", niifKeys); 
   niifKeys.forEach((niifKey, idxNiif) => { 
				const dataNiif = todasLasCuentas[niifKey];
    console.log(`Procesando NIIF ${idxNiif + 1}: ${dataNiif.niif} - ${dataNiif.descripcionLinea}`); 
				// FILA DE NIIF (solo en las primeras dos columnas)
    worksheet.mergeCells(`A${n_fila}:B${n_fila}`); 
    worksheet.getCell(`A${n_fila}`).value = `${dataNiif.niif} - ${dataNiif.descripcionLinea}`; 
    worksheet.getCell(`A${n_fila}`).font = { name: "Calibri", size: 11, bold: true }; 
    worksheet.getCell(`A${n_fila}`).alignment = { horizontal: "center", vertical: "middle" }; 
    worksheet.getCell(`A${n_fila}`).fill = { 
					type: "pattern",
					pattern: "solid",
					fgColor: { argb: "F2F2F2" } // Gris muy claro
				};
    worksheet.getCell(`A${n_fila}`).border = { 
					top: { style: "thin" },
					left: { style: "thin" },
					bottom: { style: "thin" },
					right: { style: "thin" }
				};
				n_fila++;
				// ENCABEZADO DE COLUMNAS DE DATOS
				const headerRow = ['CUENTA', 'DESCRIPCIÓN'];
				// Agregar "FUNCIONAL" repetido para cada compañía
    for (let i = 0; i < datosPorCompania.length; i++) { 
     headerRow.push('FUNCIONAL'); 
				}
				// Agregar las nuevas columnas al final
    headerRow.push('SUMATORIA'); 
    headerRow.push('AJUSTES'); 
    headerRow.push('CONSOLIDADO'); 
				if (esCombinado) {
     headerRow.push('COMBINADO'); 
     headerRow.push('TOTAL COMBINADO'); 
				}
    console.log(` headerRow length: ${headerRow.length}`); 
    worksheet.addRow(headerRow); 
    for (let i = 1; i <= headerRow.length; i++) { 
     let headerCell = worksheet.getCell(n_fila, i); 
     headerCell.font = { name: "Calibri", size: 11, bold: true }; 
     headerCell.alignment = { horizontal: "center", vertical: "middle" }; 
					if (i <= 2) {
						// CUENTA y DESCRIPCIÓN - Gris claro
      headerCell.fill = { 
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "E6E6E6" }
						};
					} else if (i <= numCompanias + 2) {
						// FUNCIONAL por compañía
						const companiaIndex = i - 3;
						if (companiaIndex % 2 === 0) {
       headerCell.fill = { 
								type: "pattern",
								pattern: "solid",
								fgColor: { argb: "FCE4D6" }
							};
						} else {
       headerCell.fill = { 
								type: "pattern",
								pattern: "solid",
								fgColor: { argb: "D9EAD3" }
							};
						}
					} else {
						// Todas las demás columnas (SUMATORIA, AJUSTES, CONSOLIDADO, COMBINADO, TOTAL COMBINADO)
      headerCell.fill = { 
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "E6E6E6" }
						};
					}
     headerCell.border = { 
						top: { style: "thin" },
						left: { style: "thin" },
						bottom: { style: "thin" },
						right: { style: "thin" }
					};
				}
				// IMPORTANTE: Incrementar n_fila DESPUÉS de aplicar estilos
				n_fila++;
				// Convertir Map a Array y ordenar por cuenta
    const cuentasArray = Array.from(dataNiif.cuentas.values()) 
     .sort((a, b) => a.cuenta.localeCompare(b.cuenta)); 
    console.log(` Total cuentas en este NIIF: ${cuentasArray.length}`); 
				// DATOS DE CUENTAS
    cuentasArray.forEach((cuenta) => { 
     const dataRow = [cuenta.cuenta, cuenta.descripcion]; 
					// Agregar saldos para cada compañía
     cuenta.saldos.forEach(saldo => { 
      dataRow.push(saldo); 
					});
					// Calcular sumatoria horizontal para esta fila
					let sumatoria = 0;
     cuenta.saldos.forEach(saldo => { 
						sumatoria += saldo;
					});
     dataRow.push(sumatoria); 
					// AJUSTES por cuenta y NIIF
     const ajusteCuenta = ajustesPorNiifCuenta[dataNiif.niif]?.[cuenta.cuenta] || 0;
     dataRow.push(ajusteCuenta); 
					// CONSOLIDADO (sumatoria + ajuste)
					const consolidado = sumatoria + ajusteCuenta;
     dataRow.push(consolidado); 
					// COMBINADO (solo origen B)
					let combinadoValor = 0;
					if (esCombinado) {
      combinadoValor = ajustesOrigenBPorCuenta[cuenta.cuenta] || 0; 
      dataRow.push(combinadoValor); 
						// TOTAL COMBINADO (consolidado + combinado)
      dataRow.push(consolidado + combinadoValor); 
					}
     worksheet.addRow(dataRow); 
					// Aplicar estilos a la fila
					let colCell = 1;
					// CUENTA
     let dataCell = worksheet.getCell(n_fila, colCell); 
     dataCell.font = { name: "Calibri", size: 10 }; 
     dataCell.alignment = { horizontal: "left", vertical: "middle" }; 
     dataCell.border = { 
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					};
					colCell++;
					// DESCRIPCIÓN
     dataCell = worksheet.getCell(n_fila, colCell); 
     dataCell.font = { name: "Calibri", size: 10 }; 
     dataCell.alignment = { horizontal: "left", vertical: "middle" }; 
     dataCell.border = { 
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					};
					colCell++;
					// SALDOS por compañía
     cuenta.saldos.forEach((saldo, saldoIndex) => { 
      dataCell = worksheet.getCell(n_fila, colCell); 
      dataCell.value = saldo; 
      dataCell.font = { name: "Calibri", size: 10 }; 
      dataCell.alignment = { horizontal: "right", vertical: "middle" }; 
      dataCell.numFmt = "#,##0"; 
						// Color de fondo alternado según compañía
						if (saldoIndex % 2 === 0) {
       dataCell.fill = { 
								type: "pattern",
								pattern: "solid",
								fgColor: { argb: "FCF8F3" }
							};
						} else {
       dataCell.fill = { 
								type: "pattern",
								pattern: "solid",
								fgColor: { argb: "F7FCF5" }
							};
						}
      dataCell.border = { 
							left: { style: "thin" },
							right: { style: "thin" },
							bottom: { style: "thin" }
						};
						colCell++;
					});
					// SUMATORIA
     dataCell = worksheet.getCell(n_fila, colCell); 
     dataCell.value = sumatoria; 
     dataCell.font = { name: "Calibri", size: 10 }; 
     dataCell.alignment = { horizontal: "right", vertical: "middle" }; 
     dataCell.numFmt = "#,##0"; 
     dataCell.border = { 
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					};
					colCell++;
					// AJUSTES
     dataCell = worksheet.getCell(n_fila, colCell); 
     dataCell.value = ajusteCuenta; 
     dataCell.font = { name: "Calibri", size: 10 }; 
     dataCell.alignment = { horizontal: "right", vertical: "middle" }; 
     dataCell.numFmt = "#,##0"; 
     dataCell.border = { 
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					};
					colCell++;
					// CONSOLIDADO
     dataCell = worksheet.getCell(n_fila, colCell); 
     dataCell.value = consolidado; 
     dataCell.font = { name: "Calibri", size: 10 }; 
     dataCell.alignment = { horizontal: "right", vertical: "middle" }; 
     dataCell.numFmt = "#,##0"; 
     dataCell.border = { 
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					};
					colCell++;
					if (esCombinado) {
						// COMBINADO
      dataCell = worksheet.getCell(n_fila, colCell); 
      dataCell.value = combinadoValor; 
      dataCell.font = { name: "Calibri", size: 10 }; 
      dataCell.alignment = { horizontal: "right", vertical: "middle" }; 
      dataCell.numFmt = "#,##0"; 
      dataCell.border = { 
							left: { style: "thin" },
							right: { style: "thin" },
							bottom: { style: "thin" }
						};
						colCell++;
						// TOTAL COMBINADO
      dataCell = worksheet.getCell(n_fila, colCell); 
      dataCell.value = consolidado + combinadoValor; 
      dataCell.font = { name: "Calibri", size: 10 }; 
      dataCell.alignment = { horizontal: "right", vertical: "middle" }; 
      dataCell.numFmt = "#,##0"; 
      dataCell.border = { 
							left: { style: "thin" },
							right: { style: "thin" },
							bottom: { style: "thin" }
						};
					}
					n_fila++;
				});
				// FILA DE TOTAL POR NIIF Y POR COMPAÑÍA
    const totalRow = ['', 'TOTAL ' + dataNiif.niif]; 
				// Calcular totales por compañía para esta NIIF
    const totalesPorCompania = new Array(numCompanias).fill(0); 
				let totalSumatoria = 0;
    cuentasArray.forEach(cuenta => { 
     cuenta.saldos.forEach((saldo, idx) => { 
						totalesPorCompania[idx] += saldo;
					});
				});
				// Agregar totales a la fila
    totalesPorCompania.forEach(total => { 
     totalRow.push(total); 
					totalSumatoria += total;
				});
				// Obtener ajustes para este NIIF
    const ajusteNiif = ajustesPorNiif[dataNiif.niif] || 0; 
				// SUMATORIA (suma de todas las compañías)
    totalRow.push(totalSumatoria); 
				// AJUSTES (total de ajustes para este NIIF)
    totalRow.push(ajusteNiif); 
				// CONSOLIDADO (sumatoria + ajustes)
				const consolidadoTotal = totalSumatoria + ajusteNiif;
    totalRow.push(consolidadoTotal); 
				if (esCombinado) {
					// Calcular total combinado para este NIIF
					let totalCombinado = 0;
     cuentasArray.forEach(cuenta => { 
      totalCombinado += ajustesOrigenBPorCuenta[cuenta.cuenta] || 0; 
					});
     totalRow.push(totalCombinado); 
     totalRow.push(consolidadoTotal + totalCombinado); 
     console.log(` TOTAL NIIF ${dataNiif.niif} - sumatoria: ${totalSumatoria}, ajustes: ${ajusteNiif}, consolidado: ${consolidadoTotal}, combinado: ${totalCombinado}`); 
				}
    worksheet.addRow(totalRow); 
				// Aplicar estilos a la fila de total
				let colTotal = 1;
				// Celda vacía (columna cuenta)
    let totalCell = worksheet.getCell(n_fila, colTotal); 
    totalCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }; 
				colTotal++;
				// TOTAL descripción
    totalCell = worksheet.getCell(n_fila, colTotal); 
    totalCell.font = { name: "Calibri", size: 10, bold: true }; 
    totalCell.alignment = { horizontal: "right", vertical: "middle" }; 
    totalCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }; 
				colTotal++;
				// TOTALES numéricos por compañía
    totalesPorCompania.forEach((total) => { 
     let companiaCell = worksheet.getCell(n_fila, colTotal); 
     companiaCell.value = total; 
     companiaCell.font = { name: "Calibri", size: 10, bold: true }; 
     companiaCell.alignment = { horizontal: "right", vertical: "middle" }; 
     companiaCell.numFmt = "#,##0"; 
     companiaCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }; 
     companiaCell.border = { 
						top: { style: "thin" },
						bottom: { style: "double" }
					};
					colTotal++;
				});
				// SUMATORIA total
    let sumatoriaCellTotal = worksheet.getCell(n_fila, colTotal); 
    sumatoriaCellTotal.value = totalSumatoria; 
    sumatoriaCellTotal.font = { name: "Calibri", size: 10, bold: true }; 
    sumatoriaCellTotal.alignment = { horizontal: "right", vertical: "middle" }; 
    sumatoriaCellTotal.numFmt = "#,##0"; 
    sumatoriaCellTotal.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "D9E1F2" } }; 
    sumatoriaCellTotal.border = { 
					top: { style: "thin" },
					bottom: { style: "double" }
				};
				colTotal++;
				// AJUSTES total
    let ajustesCellTotal = worksheet.getCell(n_fila, colTotal); 
    ajustesCellTotal.value = ajusteNiif; 
    ajustesCellTotal.font = { name: "Calibri", size: 10, bold: true }; 
    ajustesCellTotal.alignment = { horizontal: "right", vertical: "middle" }; 
    ajustesCellTotal.numFmt = "#,##0"; 
    ajustesCellTotal.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF2CC" } }; 
    ajustesCellTotal.border = { 
					top: { style: "thin" },
					bottom: { style: "double" }
				};
				colTotal++;
				// CONSOLIDADO total
    let consolidadoCellTotal = worksheet.getCell(n_fila, colTotal); 
    consolidadoCellTotal.value = consolidadoTotal; 
    consolidadoCellTotal.font = { name: "Calibri", size: 10, bold: true }; 
    consolidadoCellTotal.alignment = { horizontal: "right", vertical: "middle" }; 
    consolidadoCellTotal.numFmt = "#,##0"; 
    consolidadoCellTotal.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E2EFDA" } }; 
    consolidadoCellTotal.border = { 
					top: { style: "thin" },
					bottom: { style: "double" }
				};
				colTotal++;
				if (esCombinado) {
					// COMBINADO total
					let totalCombinado = 0;
     cuentasArray.forEach(cuenta => { 
      totalCombinado += ajustesOrigenBPorCuenta[cuenta.cuenta] || 0; 
					});
     let combinadoCellTotal = worksheet.getCell(n_fila, colTotal); 
     combinadoCellTotal.value = totalCombinado; 
     combinadoCellTotal.font = { name: "Calibri", size: 10, bold: true }; 
     combinadoCellTotal.alignment = { horizontal: "right", vertical: "middle" }; 
     combinadoCellTotal.numFmt = "#,##0"; 
     combinadoCellTotal.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFE699" } }; 
     combinadoCellTotal.border = { 
						top: { style: "thin" },
						bottom: { style: "double" }
					};
					colTotal++;
					// TOTAL COMBINADO
     let totalCombinadoCell = worksheet.getCell(n_fila, colTotal); 
     totalCombinadoCell.value = consolidadoTotal + totalCombinado; 
     totalCombinadoCell.font = { name: "Calibri", size: 10, bold: true }; 
     totalCombinadoCell.alignment = { horizontal: "right", vertical: "middle" }; 
     totalCombinadoCell.numFmt = "#,##0"; 
     totalCombinadoCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "B8CCE4" } }; 
     totalCombinadoCell.border = { 
						top: { style: "thin" },
						bottom: { style: "double" }
					};
				}
				n_fila++;
			});
			// AGREGAR TODOS LOS AJUSTES (incluyendo los de origen B si existen)
   console.log("=== AGREGANDO TABLA DE AJUSTES ==="); 
			const todosAjustes = [];
			// Ajustes existentes - USAR EL NOMBRE DE COMPAÑÍA QUE VIENE DEL BACKEND
   datosPorCompania.forEach(datoCompania => { 
    if (datoCompania.ajustes && datoCompania.ajustes.length > 0) { 
     todosAjustes.push(...datoCompania.ajustes.map(ajuste => ({ 
      ...ajuste, 
						// Usar el nombre_compania que viene del backend si existe
      compania_origen: ajuste.nombre_compania || datoCompania.compania.nombre 
					})));
				}
			});
			// Agregar ajustes de origen B externos si existen - USAR EL NOMBRE DE COMPAÑÍA DEL BACKEND
   if (esCombinado && ajustesOrigenBExternos && ajustesOrigenBExternos.length > 0) { 
				const clavesCombinadoB = new Set(
					(todosAjustes || [])
      .filter(a => String(a.origen || '').toUpperCase() === 'B') 
						.map(a => this.claveCombinadoB(a))
				);
    ajustesOrigenBExternos.forEach(ajuste => { 
     const secuencia = ajuste.secuencia; 
     const cuenta = ajuste.cuenta; 
     const tipoAjuste = ajuste.tipo_ajuste || ajuste.tipo || ''; 
     const idCompaniaAjuste = Number(ajuste.id_compania || 0); 
     const origenAjuste = ajuste.origen || ''; 
     const niifAjuste = ajuste.niif || ''; 
					const clave = `${idCompaniaAjuste}|${origenAjuste}|${secuencia}|${cuenta}|${tipoAjuste}|${niifAjuste}`;
					const claveB = this.claveCombinadoB(ajuste);
     if (!combinacionesAgregadas.has(clave) && !clavesCombinadoB.has(claveB)) { 
      combinacionesAgregadas.add(clave); 
      clavesCombinadoB.add(claveB); 
      todosAjustes.push({ 
       ...ajuste, 
							compania_origen: this.resolverNombreCompaniaAjuste(ajuste, datosPorCompania),
							origen: 'B'
						});
					}
				});
			}
   console.log(`Total ajustes para tabla final: ${todosAjustes.length}`); 
   worksheet.addRow([]); 
			n_fila++;
			// Calcular totales de la Ecuación Patrimonial usando exactamente
   // los mismos valores que se muestran en la tabla superior por NIIF. 
   console.log("=== CALCULANDO ECUACIÓN PATRIMONIAL ==="); 
   const totalesEcuacionPorCompania = new Array(datosPorCompania.length).fill(0); 
			let sumaTotalEcuacion = 0;
			let sumaAjustesEcuacion = 0;
			this.ordenarNiifKeysParaDetalle(todasLasCuentas).forEach(niifKey => {
				const dataNiif = todasLasCuentas[niifKey];
    const cuentasArray = Array.from(dataNiif.cuentas.values()); 
    const totalesPorCompaniaNiif = new Array(datosPorCompania.length).fill(0); 
    cuentasArray.forEach(cuenta => { 
     cuenta.saldos.forEach((saldo, idx) => { 
						totalesPorCompaniaNiif[idx] += saldo;
					});
				});
    totalesPorCompaniaNiif.forEach((total, idx) => { 
					totalesEcuacionPorCompania[idx] += total;
				});
    const totalNiif = totalesPorCompaniaNiif.reduce((a, b) => a + b, 0); 
    const ajusteNiif = ajustesPorNiif[dataNiif.niif] || 0; 
				sumaTotalEcuacion += totalNiif;
				sumaAjustesEcuacion += ajusteNiif;
			});
   console.log("Totales ecuación por compañía:", totalesEcuacionPorCompania); 
   console.log("Suma total ecuación:", sumaTotalEcuacion); 
   console.log("Suma ajustes ecuación:", sumaAjustesEcuacion); 
			// Crear fila de Ecuación Patrimonial
			const ecuacionRowData = ['ECUACIÓN PATRIMONIAL', ''];
			// Agregar totales por compañía (suma de NIIF mostrados)
   datosPorCompania.forEach((datoCompania, idx) => { 
				const totalCompania = totalesEcuacionPorCompania[idx] || 0;
    ecuacionRowData.push(totalCompania); 
			});
			// Agregar columnas de ajustes y consolidado
			// Agregar columnas de SUMATORIA y AJUSTES
   ecuacionRowData.push(sumaTotalEcuacion); // SUMATORIA 
   ecuacionRowData.push(sumaAjustesEcuacion); // AJUSTES 
			// CONSOLIDADO (Sumatoria + Ajustes)
			const consolidadoEcuacion = sumaTotalEcuacion + sumaAjustesEcuacion;
   ecuacionRowData.push(consolidadoEcuacion); 
			if (esCombinado) {
				// Calcular total combinado para ecuación patrimonial (suma de todos los origen B)
				let totalCombinadoEcuacion = 0;
    Object.values(ajustesOrigenBPorCuenta).forEach(valor => { 
					totalCombinadoEcuacion += valor;
				});
    ecuacionRowData.push(totalCombinadoEcuacion); 
    ecuacionRowData.push(consolidadoEcuacion + totalCombinadoEcuacion); 
    console.log("Ecuación patrimonial - totalCombinado:", totalCombinadoEcuacion); 
			}
   console.log("Fila ecuación patrimonial:", ecuacionRowData); 
			// Agregar fila de Ecuación Patrimonial
   worksheet.addRow(ecuacionRowData); 
			// Aplicar estilos a la fila de Ecuación Patrimonial
   for (let i = 1; i <= ecuacionRowData.length; i++) { 
    const ecuacionCell = worksheet.getCell(n_fila, i); 
				if (i === 1) {
					// Columna A: "ECUACIÓN PATRIMONIAL"
     ecuacionCell.font = { name: "Calibri", size: 11, bold: true }; 
     ecuacionCell.alignment = { horizontal: "left", vertical: "middle" }; 
					// Fusionar A y B
     worksheet.mergeCells(n_fila, 1, n_fila, 2); 
				} else if (i === 2) {
					// Columna B: vacía (fusionada con A)
					continue;
				} else {
					// Columnas numéricas
     ecuacionCell.font = { name: "Calibri", size: 11, bold: true }; 
     ecuacionCell.alignment = { horizontal: "right", vertical: "middle" }; 
     ecuacionCell.numFmt = "#,##0"; 
					// Color de fondo diferenciado
     if (i <= datosPorCompania.length + 2) { // Columnas de compañías 
						if ((i - 2) % 2 === 1) {
       ecuacionCell.fill = { 
								type: "pattern",
								pattern: "solid",
								fgColor: { argb: "FCE4D6" }
							};
						} else {
       ecuacionCell.fill = { 
								type: "pattern",
								pattern: "solid",
								fgColor: { argb: "D9EAD3" }
							};
						}
     } else if (i === datosPorCompania.length + 3) { // SUMATORIA 
      ecuacionCell.fill = { 
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "D9E1F2" }
						};
     } else if (i === datosPorCompania.length + 4) { // AJUSTES 
      ecuacionCell.fill = { 
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "FFF2CC" }
						};
     } else if (i === datosPorCompania.length + 5) { // CONSOLIDADO 
      ecuacionCell.fill = { 
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "E2EFDA" }
						};
     } else if (i === datosPorCompania.length + 6) { // COMBINADO 
      ecuacionCell.fill = { 
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "FFE699" }
						};
     } else if (i === datosPorCompania.length + 7) { // TOTAL COMBINADO 
      ecuacionCell.fill = { 
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "B8CCE4" }
						};
					}
				}
				// Bordes
    ecuacionCell.border = { 
					top: { style: "medium" },
					left: { style: "thin" },
					right: { style: "thin" },
					bottom: { style: "double" }
				};
			}
			n_fila++;
   worksheet.addRow([]); 
			n_fila++;
   if (todosAjustes.length > 0) { 
    console.log("Creando tabla de ajustes con", todosAjustes.length, "registros"); 
				// Espacio antes de ajustes
    worksheet.addRow([]); 
				n_fila++;
				const ajustesHeaders = [
					'COMPAÑIA',
					'NIIF',
					'SECUENCIA',
					'TIPO',
					'TIPO AJUSTE',
					'CUENTA',
					'SALDO ORIGINAL',
					'AJUSTE LOCAL',
					'AJUSTE FUNCIONAL',
					'DESCRIPCIÓN',
					'ORIGEN'
				];
    const totalColumnsAjustes = ajustesHeaders.length; 
    const endColAjustes = String.fromCharCode(65 + totalColumnsAjustes - 1); 
    worksheet.mergeCells(`A${n_fila}:${endColAjustes}${n_fila}`); 
    worksheet.getCell(`A${n_fila}`).value = `AJUSTES DE CONSOLIDACIÓN - TODAS LAS EMPRESAS`; 
    worksheet.getCell(`A${n_fila}`).font = { name: "Calibri", size: 12, bold: true }; 
    worksheet.getCell(`A${n_fila}`).fill = { 
					type: "pattern",
					pattern: "solid",
					fgColor: { argb: "FFF2CC" }
				};
    worksheet.getCell(`A${n_fila}`).alignment = { horizontal: "center", vertical: "middle" }; 
				n_fila++;
				// Crear encabezados de ajustes
    for (let i = 0; i < ajustesHeaders.length; i++) { 
     worksheet.getCell(n_fila, i + 1).value = ajustesHeaders[i]; 
     worksheet.getCell(n_fila, i + 1).font = { name: "Calibri", size: 11, bold: true }; 
     worksheet.getCell(n_fila, i + 1).alignment = { horizontal: "center", vertical: "middle" }; 
     worksheet.getCell(n_fila, i + 1).fill = { 
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "E6E6E6" }
					};
     worksheet.getCell(n_fila, i + 1).border = { 
						top: { style: "thin" },
						left: { style: "thin" },
						bottom: { style: "thin" },
						right: { style: "thin" }
					};
				}
				n_fila++;
				// DATOS DE AJUSTES - USAR EL NOMBRE DE COMPAÑÍA QUE VIENE DEL BACKEND
    todosAjustes.forEach((ajuste, idx) => { 
					if (idx < 5) {
      console.log(`Ajuste ${idx + 1}:`, ajuste); 
					}
     let tipoAjusteTexto = ajuste.tipo_ajuste || ''; 
					if (tipoAjusteTexto === 'O') {
						tipoAjusteTexto = 'Origen';
					} else if (tipoAjusteTexto === 'D') {
						tipoAjusteTexto = 'Destino';
					}
     let niifConDescripcion = ajuste.niif || ''; 
					if (this.balance && this.balance.length > 0 && ajuste.niif) {
						const niifInfo = this.balance.find(item => item.niif === ajuste.niif);
      if (niifInfo && niifInfo.descripcion) { 
       niifConDescripcion = `${ajuste.niif} - ${niifInfo.descripcion}`; 
						}
					}
					// USAR EL NOMBRE DE COMPAÑÍA DEL AJUSTE (nombre_compania) QUE VIENE DEL BACKEND
     worksheet.getCell(n_fila, 1).value = ajuste.nombre_compania || ajuste.compania_origen || ''; 
     worksheet.getCell(n_fila, 2).value = niifConDescripcion; 
     worksheet.getCell(n_fila, 3).value = ajuste.secuencia || ''; 
     worksheet.getCell(n_fila, 4).value = ajuste.tipo_participante || ''; 
     worksheet.getCell(n_fila, 5).value = tipoAjusteTexto; 
     worksheet.getCell(n_fila, 6).value = ajuste.cuenta || ''; 
     worksheet.getCell(n_fila, 7).value = ajuste.saldo_actual || 0; 
     worksheet.getCell(n_fila, 8).value = ajuste.ajuste_actual || ajuste.ajuste_actual_rounded || 0; 
     worksheet.getCell(n_fila, 9).value = 
      ajuste.ajuste_funcional1 || 
      ajuste.ajuste_funcional1_rounded || 
      ajuste.ajuste_actual || 
      ajuste.ajuste_actual_rounded || 
						0;
     worksheet.getCell(n_fila, 10).value = ajuste.descripcion || ''; 
     worksheet.getCell(n_fila, 11).value = ajuste.origen || ''; 
					// Aplicar estilos
     for (let i = 1; i <= ajustesHeaders.length; i++) { 
      const ajusteCell = worksheet.getCell(n_fila, i); 
      ajusteCell.font = { name: "Calibri", size: 10 }; 
      ajusteCell.alignment = { horizontal: "left", vertical: "middle" }; 
						if (i >= 7 && i <= 9) {
       ajusteCell.alignment = { horizontal: "right", vertical: "middle" }; 
       ajusteCell.numFmt = "#,##0"; 
						}
      ajusteCell.fill = { 
							type: "pattern",
							pattern: "solid",
							fgColor: { argb: "F5F5F5" }
						};
      ajusteCell.border = { 
							left: { style: "thin" },
							right: { style: "thin" },
							bottom: { style: "thin" }
						};
					}
					n_fila++;
				});
			} else {
    console.log("No hay ajustes para mostrar en la tabla final"); 
			}
			// AJUSTAR ANCHO DE COLUMNAS dinámicamente
   console.log("=== AJUSTANDO ANCHO DE COLUMNAS ==="); 
			const columnWidths = [
				{ width: 15 }, // CUENTA
				{ width: 40 }, // DESCRIPCIÓN
			];
			// Agregar anchos para cada columna FUNCIONAL
			for (let i = 0; i < numCompanias; i++) {
    columnWidths.push({ width: 18 }); // FUNCIONAL [Compañía] 
			}
			// Agregar anchos para las nuevas columnas
   columnWidths.push({ width: 18 }); // SUMATORIA 
   columnWidths.push({ width: 18 }); // AJUSTES 
   columnWidths.push({ width: 18 }); // CONSOLIDADO 
			if (esCombinado) {
    columnWidths.push({ width: 18 }); // COMBINADO 
    columnWidths.push({ width: 18 }); // TOTAL COMBINADO 
			}
   console.log("columnWidths length:", columnWidths.length); 
   worksheet.columns = columnWidths; 
   worksheet.views = [ 
				{ state: 'frozen', ySplit: 4 }
			];
   console.log("=== FIN llenarHojaCombinada ==="); 
		},
		async obtenerAjustesOrigenB() {
			try {
				const response = await Balance.getAjustesOrigenB(this.codReporte, this.vigencia);
    return response.data?.ajustesOrigenB || []; 			} catch (error) {
    console.error("Error en obtenerAjustesOrigenB:", error); 
				return [];
			}
		},
		resolverNombreCompaniaAjuste(ajuste, datosPorCompania = []) {
   const nombreBackend = ajuste.nombre_compania; 
   if (nombreBackend && String(nombreBackend)?.trim() !== '') return nombreBackend;    const idCompania = Number(ajuste.id_compania); 
   if (!Number?.isFinite(idCompania)) return '';    const desdeSeleccion = (datosPorCompania || []).find( 
    d => Number(d.compania.id) === idCompania 
   ).compania.nombre; 
   if (desdeSeleccion && String(desdeSeleccion)?.trim() !== '') return desdeSeleccion; 			const desdeCatalogo = (this.companias || []).find(
    c => Number(c.id) === idCompania 
   ).nombre; 
   if (desdeCatalogo && String(desdeCatalogo)?.trim() !== '') return desdeCatalogo; 			return '';
		},
		normalizaClaveCombinadoB(valor) {
			if (valor === null || valor === undefined) return '';
   return String(valor)?.trim(); 		},
		claveCombinadoB(ajuste = {}) {
			const valorAjuste = Number.parseFloat(
				ajuste.ajuste_funcional1 ??
				ajuste.ajuste_funcional1_rounded ??
				ajuste.ajuste_actual ??
				ajuste.ajuste_actual_rounded ??
				0
			)
			const valorNormalizado = Number.isFinite(valorAjuste) ? valorAjuste.toFixed(6) : '0.000000'
			return [
				this.normalizaClaveCombinadoB(ajuste.id_compania),
				this.normalizaClaveCombinadoB(ajuste.secuencia),
				this.normalizaClaveCombinadoB(ajuste.cuenta),
				this.normalizaClaveCombinadoB(ajuste.niif),
				this.normalizaClaveCombinadoB(ajuste.tipo_ajuste || ajuste.tipo),
				this.normalizaClaveCombinadoB(ajuste.tipo_participante),
				valorNormalizado
   ].join('|'); 
		},
		deduplicarCombinadosB(ajustes = []) {
			const vistos = new Set();
   return (ajustes || [])?.filter((ajuste) => { 				const clave = this.claveCombinadoB(ajuste);
    if (vistos?.has(clave)) return false;     vistos.add(clave); 
				return true;
			});
		},
		descargarArchivo(buffer, nombreArchivo) {
   const downloadLink = document.createElement("a"); 
   downloadLink.download = nombreArchivo; 
   downloadLink.href = window.URL.createObjectURL( 
				new Blob([buffer], {
     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 
				})
			);
   downloadLink.style.display = "none"; 
   document.body.appendChild(downloadLink); 
   downloadLink.click(); 
   downloadLink.remove(); 
		},
		cambiarVista(vista) {
			this.vistaActiva = vista;
			// Resetear todas las columnas
			this.mostrarColumnas = {
				saldo: false,
				funcional: false,
				alterna: false
			};
			// Configurar columnas según la vista seleccionada
			switch (vista) {
				case 'balance':
					this.mostrarColumnas.saldo = true;
					this.mostrarColumnas.funcional = true;
					this.mostrarColumnas.alterna = true;
					break;
				case 'funcional':
					this.mostrarColumnas.funcional = true;
					break;
				case 'alterna':
					this.mostrarColumnas.alterna = true;
					break;
			}
			// Forzar actualización de los labels
			this.$forceUpdate();
		},
		toggleConsolidationSection() {
			this.showConsolidationSection = !this.showConsolidationSection;
			this.Empresas = this.showConsolidationSection;
		},
		grabeNotaParrafo() {
			// Obtener el HTML del editor
			let texto_html = '';
			let texto_plano = '';
			if (this.$refs.textEditor && this.$refs.textEditor.getHTML) {
				texto_html = this.$refs.textEditor.getHTML();
			}
			if (this.$refs.textEditor && this.$refs.textEditor.getText) {
				texto_plano = this.$refs.textEditor.getText();
			}
			// Preparar datos para enviar
			this.formParrafo.numero = this.formNotas.numero;
			this.formParrafo.vigencia = this.dialogFechas;
			this.formParrafo.idCompania = this.dialogCompanias;
			this.formParrafo.idUser = this.$store.state.userId;
			// Agregar el texto HTML y plano
			this.formParrafo.texto_html = texto_html;
			this.formParrafo.texto = texto_plano;
			Balance.grabeNotaParrafo(this.formParrafo)
    .then(() => { 
					this.$toast.success("Párrafo Modificado");
					this.showDialog = false;
					this.Informacion = true;
					// Recargar datos
					Balance.getNotas(this.codReporte, this.dialogCompanias, this.dialogFechas, this.formNotas.numero)
      .then((result) => { 
							// Actualizar arrays con datos nuevos
							this.a_detalle = result.data.a_detalle;
							this.a_detalle_texto = result.data.a_detalle_texto;
							this.a_informacion_txfg = result.data.a_informacion_txfg;
							this.a_informacion_txfc = result.data.a_informacion_txfc;
							this.a_informacion_txvg = result.data.a_informacion_txvg;
							this.a_informacion_txvc = result.data.a_informacion_txvc;
							this.a_informacion_tblm = result.data.a_informacion_tblm;
						})
      .catch(() => { 
							this.error = true;
						});
					setTimeout(() => {
						this.Modifica = true;
					}, 1000);
				})
    .catch(() => { 
					this.$toast.error("Error al Actualizar el Párrafo");
				});
		},
		seleccionaCompania() {
			this.onFiltroChange()
			let buscaMoneda = this.companias.filter((item) => item.id == this.dialogCompanias)
			if (buscaMoneda.length > 0) {
				this.moneda = buscaMoneda[0].acronimo
			} else {
				this.moneda = ''
			}
		},
		seleccionaEmpresa() {
			this.isEmpty = true;
		},
		toggleAllCompanies() {
			if (this.selectAllCompanies) {
				// Seleccionar todas las compañías
				this.EmpresasConsolida = this.companiasFiltradas.map(compania => compania.id);
			} else {
				// Deseleccionar todas
				this.EmpresasConsolida = [];
			}
		},
		selectViewOption(value) {
			this.selectedViewOption = value
			this.onFiltroChange()
			
			// Resetear todas las vistas
			this.mostrarBalance = false
			this.mostrarComparativo = false
			this.mostrarConsolidado = false
			this.mostrarNotas = false
			this.mostrarInformacion = false
			
			// Activar la vista seleccionada
			switch(value) {
				case 'balance':
					this.mostrarBalance = true
					break
				case 'consolidado':
					this.mostrarConsolidado = true
					break
				case 'comparativo':
					this.mostrarComparativo = true
					break
				case 'notas':
					this.mostrarNotas = true
					break
				case 'informacion':
					this.mostrarInformacion = true
					break
			}
			
			this.f_titulo()
		},

		onFiltroChange() {
			this.isEmpty = true
			this.generado = false
			this.balance = []
			this.searched = []
			this.columnas = 0
			this.titulo_columna = []
			this.showDialog = false
			this.showDialogCuenta = false
			this.empresasSeleccion = false
			this.EmpresasConsolida = []
			this.selectAllCompaniesModal = false
		},

		// ==================== NUEVO: MÉTODOS PARA EL MODAL DE EMPRESAS ====================
		isCompanySelectedModal(compania) {
			return this.EmpresasConsolida.includes(compania.id)
		},

		toggleCompanySelectionModal(compania) {
			const index = this.EmpresasConsolida.indexOf(compania.id)
			if (index > -1) {
				this.EmpresasConsolida.splice(index, 1)
			} else {
				this.EmpresasConsolida.push(compania.id)
			}
			this.updateSelectAllCompaniesModal()
		},

		toggleSelectAllCompaniesModal() {
			this.selectAllCompaniesModal = !this.selectAllCompaniesModal
			if (this.selectAllCompaniesModal) {
				const selectedIds = this.companiasFiltradas.map(c => c.id)
				selectedIds.forEach(id => {
					if (!this.EmpresasConsolida.includes(id)) {
						this.EmpresasConsolida.push(id)
					}
				})
			} else {
				const filteredIds = this.companiasFiltradas.map(c => c.id)
				this.EmpresasConsolida = this.EmpresasConsolida.filter(id => !filteredIds.includes(id))
			}
		},

		updateSelectAllCompaniesModal() {
			if (this.companiasFiltradas.length === 0) {
				this.selectAllCompaniesModal = false
				return
			}
			this.selectAllCompaniesModal = this.companiasFiltradas.every(c => this.EmpresasConsolida.includes(c.id))
		},

		openEmpresasModal() {
			this.EmpresasConsolida = []
			this.EmpresasConsolidaExcel = []
			this.selectAllCompaniesModal = false
			this.empresasSeleccion = false
			this.showEmpresasModal = true
			this.updateSelectAllCompaniesModal()
		},

		closeEmpresasModal() {
			if (this.isSavingCompanies) return
			this.showEmpresasModal = false
			if (this.fromButtonGenerate) {
				this.fromButtonGenerate = false
			}
		},

		confirmEmpresasSelectionModal() {
			if (this.isSavingCompanies) return
			if (this.EmpresasConsolida.length === 0) {
				this.$toast.warning(
					this.$store.state._language == "es-ES"
						? "Por favor seleccione al menos una empresa"
						: "Please select at least one company"
				)
				return
			}

			this.isSavingCompanies = true
			this.showEmpresasModal = false
			this.empresasSeleccion = true
			
			// ===== IMPORTANTE: Guardar copia para Excel =====
			this.EmpresasConsolidaExcel = [...this.EmpresasConsolida]
			console.log('Empresas para Excel:', this.EmpresasConsolidaExcel)
			
			this.isSavingCompanies = false

			// Limpiar datos previos
			this.balance = []
			this.searched = []
			this.isEmpty = true
			this.generado = false
			this.columnas = 0
			this.titulo_columna = []

			// Ejecutar generar después de un pequeño delay
			setTimeout(() => {
				this.generar()
			}, 300)
		},
		// ==================== NUEVO: MÉTODO DE FILTRO MODIFICADO ====================
		filtraCompaniasPorGrupo(valor = null) {
			const grupoIdSeleccionado = valor !== null ? valor : this.selectedGrupo
			
			this.onFiltroChange()
			this.dialogCompanias = null
			this.empresasSeleccion = false
			this.EmpresasConsolida = []
			// ===== NO limpiar EmpresasConsolidaExcel aquí =====
			this.selectAllCompaniesModal = false

			if (grupoIdSeleccionado === 'todos' || !grupoIdSeleccionado) {
				this.companiasFiltradas = [...this.companias]
			} else {
				const grupoIdStr = grupoIdSeleccionado.toString()
				this.companiasFiltradas = this.companias.filter(compania => {
					if (!compania?.id_grupos) return false
					const gruposCompania = compania.id_grupos.split(',').map(id => id.trim())
					return gruposCompania.includes(grupoIdStr)
				})
			}
		},
		f_titulo() {
			let titulo = ""
			let tituloEN = ""
			let tituloConsolidado = ""

			switch (this.$route.name) {
				case "balanceNiif":
					titulo = "Balance"
					tituloEN = "Balance"
					break
				case "reporteEsf":
					titulo = "Estado de Situación Financiera"
					tituloEN = "FINANCIAL POSITION STATEMENT"
					break
				case "reporteEri":
					titulo = "Estado de Resultados Integrales"
					tituloEN = "COMPREHENSIVE INCOME STATEMENT"
					break
				default:
					titulo = "Balance"
					tituloEN = "Balance"
			}

			if (this.$store.state._language == "es-ES") {
				tituloConsolidado = titulo
			} else {
				tituloConsolidado = tituloEN
			}

			if (this.mostrarConsolidado) {
				if (this.$store.state._language == "es-ES") {
					tituloConsolidado = tituloConsolidado.concat(" Consolidado")
				} else {
					tituloConsolidado = "CONSOLIDATED " + tituloConsolidado
				}
			}

			if (this.mostrarComparativo) {
				if (this.$store.state._language == "es-ES") {
					tituloConsolidado = titulo.concat(" Comparativo")
				} else {
					tituloConsolidado = "COMPARATIVE " + tituloEN
				}
			}

			if (this.mostrarNotas) {
				if (this.$store.state._language == "es-ES") {
					tituloConsolidado = "NOTAS ESTADOS FINANCIEROS"
				} else {
					tituloConsolidado = "FINANCIAL STATEMENT NOTES"
				}
			}

			if (this.mostrarInformacion) {
				if (this.$store.state._language == "es-ES") {
					tituloConsolidado = "INFORMACION DE NOTAS ESTADOS FINANCIEROS"
				} else {
					tituloConsolidado = "FINANCIAL STATEMENT NOTES INFORMATION"
				}
			}

			if (this.vigencia) {
				tituloConsolidado = tituloConsolidado.concat(" ", this.vigencia.toUpperCase())
			}

			this.tituloConsolidado = tituloConsolidado
			return tituloConsolidado
		},
		obtenerTitulosColumnas() {
			let titulos = [];
			for (let i = 0; i < this.columnas; i++) {
				titulos.push(this.titulo_columna[i] || `Compañía ${i + 1}`);
			}
			titulos.push(this.labels.ajustes || 'Ajustes');
			if (this.vistaConsolidado === 'normal') {
				titulos.push(this.labels.consolidado || 'Consolidado');
			} else {
				titulos.push(this.labels.consolidado || 'Consolidado');
    titulos.push('Combinado'); 
    titulos.push('Total Combinado'); 
			}
			return titulos;
		},
		getNombreGrupo(grupoId) {
			const grupo = this.grupos.find(g => g.id == grupoId);
   return grupo ? grupo?.nombre : 'Grupo'; 		},
		procesarConsolidacionPorGrupos(datos) {
   console.log('🔧 Procesando consolidación por grupos...'); 
   console.log('📊 Datos recibidos:', datos); 
   if (!datos || datos?.length === 0) return datos;    return datos?.map(item => { 				// Resetear todas las columnas existentes
				for (let i = 1; i <= 10; i++) {
					item['c' + i] = 0;
				}
				if (this.GruposConsolida.length >= 1) {
     item.c1 = item.total; 
				}
    item.total = 0; 
    item.ajustes = 0; 
    console.log('📈 Item procesado:', { 
     descripcion: item.descripcion, 
     c1: item.c1, 
     total_original: item.total 
				});
				return item;
			});
		},


		filtrarEmpresasConDatos(balance, nombresCompanias = null) {
			if (!balance || balance.length === 0) return []
			
			// Determinar cuántas columnas hay
			const totalColumnas = balance[0]?.columnas || 0
			if (totalColumnas === 0) return []
			
			// Para cada columna, verificar si tiene algún valor > 0 en todas las filas
			const columnasConDatos = []
			const nombres = nombresCompanias || []
			
			for (let i = 1; i <= totalColumnas; i++) {
				let tieneDatos = false
				
				// Recorrer todas las filas para ver si esta columna tiene algún valor
				for (const fila of balance) {
					const valor = parseFloat(fila[`c${i}`]) || 0
					if (Math.abs(valor) > 0.01) {
						tieneDatos = true
						break
					}
				}
				
				// Si tiene datos, incluir esta columna
				if (tieneDatos) {
					const nombre = (nombres && nombres[i - 1]) 
						? nombres[i - 1] 
						: this.obtenerNombreEmpresa(i)
					columnasConDatos.push({
						index: i,
						nombre: nombre,
						nombreOriginal: nombres ? nombres[i - 1] : null
					})
				}
			}
			
			console.log('Empresas con datos:', columnasConDatos)
			return columnasConDatos
		},

		filtrarColumnasBalance(balance, empresasConDatos) {
			if (!balance || balance.length === 0 || empresasConDatos.length === 0) {
				return balance
			}
			
			// Crear un nuevo array con las columnas filtradas
			const balanceFiltrado = balance.map(fila => {
				const nuevaFila = { ...fila }
				
				// Crear nuevas columnas c1, c2, ... solo con las que tienen datos
				let nuevoIndex = 1
				for (const empresa of empresasConDatos) {
					const columnaOriginal = empresa.index
					const valorOriginal = fila[`c${columnaOriginal}`] || 0
					nuevaFila[`c${nuevoIndex}`] = valorOriginal
					
					// También mover los títulos e${i}
					if (fila[`e${columnaOriginal}`] !== undefined) {
						nuevaFila[`e${nuevoIndex}`] = fila[`e${columnaOriginal}`]
					}
					
					nuevoIndex++
				}
				
				// Actualizar el número de columnas
				nuevaFila.columnas = empresasConDatos.length
				
				return nuevaFila
			})
			
			return balanceFiltrado
		},

		obtenerNombreEmpresa(index) {
			// Si tenemos EmpresasConsolida, usarlas para obtener el nombre
			if (this.EmpresasConsolida && this.EmpresasConsolida.length >= index) {
				const id = this.EmpresasConsolida[index - 1]
				const comp = this.companias.find(c => c.id == id)
				return comp ? comp.acronym || comp.nombre : `Empresa ${index}`
			}
			
			// Si no, buscar en los títulos de columnas del balance
			if (this.balance && this.balance[0]) {
				const colKey = `e${index}`
				if (this.balance[0][colKey] !== undefined) {
					return this.balance[0][colKey]
				}
			}
			
			return `Empresa ${index}`
		},
		generar() {
			// Si es Consolidado y no hay empresas seleccionadas, abrir modal
			if (this.selectedViewOption === 'consolidado' && !this.empresasSeleccion && this.EmpresasConsolida.length === 0) {
				this.fromButtonGenerate = true
				this.openEmpresasModal()
				return
			}

			// Validaciones generales
			if (!this.dialogFechas) {
				this.$toast.warning(this.$store.state._language == "es-ES" ? "Por favor seleccione una vigencia" : "Please select a validity")
				return
			}
			if (!this.dialogReportes) {
				this.$toast.warning(this.$store.state._language == "es-ES" ? "Por favor seleccione un reporte" : "Please select a report")
				return
			}
			if (!this.dialogCompanias && !this.mostrarConsolidado) {
				this.$toast.warning(this.$store.state._language == "es-ES" ? "Por favor seleccione una compañía" : "Please select a company")
				return
			}

			this.isLoading = true
			this.idCompania = this.dialogCompanias
			this.vigencia = this.dialogFechas
			this.codReporte = this.dialogReportes
			this.isEmpty = true
			this.generado = false

			// Obtener el módulo según la ruta
			const modulo = this.$route.name === 'balanceNiif' ? 'BAL' :
						this.$route.name === 'reporteEsf' ? 'ESF' : 'ERI'

			// ===== BALANCE =====
			if (this.mostrarBalance) {
				let promesa;
				if (this.$route.name === 'balanceNiif') {
					promesa = Balance.getBalanceNiif(this.codReporte, this.idCompania, this.vigencia);
				} else if (this.$route.name === 'reporteEsf') {
					promesa = Balance.getReporteEsf(this.codReporte, this.idCompania, this.vigencia);
				} else if (this.$route.name === 'reporteEri') {
					promesa = Balance.getReporteEri(this.codReporte, this.idCompania, this.vigencia);
				} else {
					promesa = Balance.getBalanceNiif(this.codReporte, this.idCompania, this.vigencia);
				}

				promesa.then((result) => {
					// Para balanceNiif usa result.data.balanceNiif, para ESF/ERI usa result.data.reporteEsf o result.data.reporteEri
					if (this.$route.name === 'balanceNiif') {
						this.balance = result.data.balanceNiif;
					} else if (this.$route.name === 'reporteEsf') {
						this.balance = result.data.reporteEsf;
					} else if (this.$route.name === 'reporteEri') {
						this.balance = result.data.reporteEri;
					}
					this.searched = this.balance;
					if (this.balance.length != 0) {
						this.isEmpty = false;
						this.generado = true;
						const monedaFuncional = this.currency.find((moneda) => moneda.isFuncional == 1);
						this.cmoneda = monedaFuncional ? monedaFuncional.id : 0;
						this.amoneda = monedaFuncional ? monedaFuncional.id : 0;
						this.tasa_cambio = 1;
					}
					this.isLoading = false;
				})
				.catch(() => {
					this.error = true;
					this.isLoading = false;
					this.$toast.error(this.$store.state._language == "es-ES" ? "Error al cargar Balance" : "Error loading Balance");
				});
				return;
			}

			// ===== CONSOLIDADO =====
			if (this.mostrarConsolidado) {
				let empresasParam = [];
				if (this.empresasSeleccion && this.EmpresasConsolida.length > 0) {
					empresasParam = this.EmpresasConsolida;
				} else {
					empresasParam = [this.idCompania];
				}

				let promesa;
				if (this.$route.name === 'balanceNiif') {
					promesa = Balance.getBalanceNiifConsol(
						this.codReporte,
						parseInt(this.vigencia),
						empresasParam,
						this.getMonedaConsolidadoParametro()
					);
				} else if (this.$route.name === 'reporteEsf') {
					promesa = Balance.getReporteEsfConsol(
						this.codReporte,
						empresasParam,
						this.vigencia
					);
				} else if (this.$route.name === 'reporteEri') {
					promesa = Balance.getReporteEriConsol(
						this.codReporte,
						empresasParam,
						this.vigencia
					);
				} else {
					promesa = Balance.getBalanceNiifConsol(
						this.codReporte,
						parseInt(this.vigencia),
						empresasParam,
						this.getMonedaConsolidadoParametro()
					);
				}

				promesa.then((result) => {
					// Para balanceNiif usa result.data.balanceNiif, para ESF/ERI usa result.data.reporteEsf o result.data.reporteEri
					if (this.$route.name === 'balanceNiif') {
						this.balance = result.data.balanceNiif;
					} else if (this.$route.name === 'reporteEsf') {
						this.balance = result.data.reporteEsf;
					} else if (this.$route.name === 'reporteEri') {
						this.balance = result.data.reporteEri;
					}
					this.searched = this.balance;
					
					if (this.balance.length != 0) {
						this.isEmpty = false;
						this.generado = true;
						
						// ===== NUEVO: FILTRAR EMPRESAS SIN DATOS =====
						const empresasConDatos = this.filtrarEmpresasConDatos(this.balance, result.data.nombres_companias);
						
						// Actualizar columnas solo con empresas que tienen datos
						this.columnas = empresasConDatos.length;
						this.titulo_columna = empresasConDatos.map(emp => emp.nombre);
						
						// Filtrar el balance para que solo tenga las columnas con datos
						this.balance = this.filtrarColumnasBalance(this.balance, empresasConDatos);
						
						// Reemplazar la data mostrada
						this.searched = this.balance;
						
						const monedaFuncional = this.currency.find((moneda) => moneda.isFuncional == 1);
						this.cmoneda = monedaFuncional ? monedaFuncional.id : 0;
						this.amoneda = monedaFuncional ? monedaFuncional.id : 0;
						this.tasa_cambio = 1;
					}
					
					// Limpiar selección de empresas después de generar
					this.empresasSeleccion = false;
					this.EmpresasConsolida = [];
					this.isLoading = false;
				})
				.catch(() => {
					this.error = true;
					this.isLoading = false;
					this.$toast.error(this.$store.state._language == "es-ES" ? "Error al cargar Consolidado" : "Error loading Consolidated");
				});
				return;
			}

			// ===== COMPARATIVO =====
			if (this.mostrarComparativo) {
				let promesa;
				if (this.$route.name === 'balanceNiif') {
					promesa = Balance.getBalanceNiifCompar(this.codReporte, this.idCompania, this.vigencia);
				} else if (this.$route.name === 'reporteEsf') {
					promesa = Balance.getReporteEsfCompar(this.codReporte, this.idCompania, this.vigencia);
				} else if (this.$route.name === 'reporteEri') {
					promesa = Balance.getReporteEriCompar(this.codReporte, this.idCompania, this.vigencia);
				} else {
					promesa = Balance.getBalanceNiifCompar(this.codReporte, this.idCompania, this.vigencia);
				}

				promesa.then((result) => {
					// Para balanceNiif usa result.data.balanceNiif, para ESF/ERI usa result.data.reporteEsf o result.data.reporteEri
					if (this.$route.name === 'balanceNiif') {
						this.balance = result.data.balanceNiif;
					} else if (this.$route.name === 'reporteEsf') {
						this.balance = result.data.reporteEsf;
					} else if (this.$route.name === 'reporteEri') {
						this.balance = result.data.reporteEri;
					}
					this.searched = this.balance;
					if (this.balance.length != 0) {
						this.isEmpty = false;
						this.generado = true;
					}
					this.isLoading = false;
				})
				.catch(() => {
					this.error = true;
					this.isLoading = false;
					this.$toast.error(this.$store.state._language == "es-ES" ? "Error al cargar Comparativo" : "Error loading Comparative");
				});
				return;
			}

			// ===== NOTAS =====
			if (this.mostrarNotas) {
				Balance.getNotasEF(this.codReporte, this.idCompania, this.vigencia, modulo)
					.then((result) => {
						this.notasEF = result.data.notasEF[0] || []
						this.searched = this.notasEF
						if (this.notasEF.length != 0) {
							this.isEmpty = false
							this.generado = true
						}
						this.isLoading = false
					})
					.catch(() => {
						this.error = true
						this.isLoading = false
						this.$toast.error(this.$store.state._language == "es-ES" ? "Error al cargar Notas" : "Error loading Notes")
					})
				return
			}

			// ===== INFORMACION (VALOR MANUAL) =====
			if (this.mostrarInformacion) {
				Balance.getNotasEF(this.codReporte, this.idCompania, this.vigencia, modulo)
					.then((result) => {
						this.notasEF = result.data.notasEF[0] || []
						this.searched = this.notasEF
						if (this.notasEF.length != 0) {
							this.isEmpty = false
							this.generado = true
						}
						this.isLoading = false
					})
					.catch(() => {
						this.error = true
						this.isLoading = false
						this.$toast.error(this.$store.state._language == "es-ES" ? "Error al cargar Información" : "Error loading Information")
					})
				return
			}

			// Si llegamos aquí, no se ejecutó ninguna consulta
			console.log('No se ejecutó ninguna consulta')
			this.isLoading = false
		},	
		fc_columna(opcion) {
			if (opcion == 1) {
				const v_moneda = this.labels.ajustes
				return v_moneda
			}
			if (opcion == 2) {
				const v_moneda = this.labels.consolidado
				return v_moneda
			}
		},
		f_columnas() {
			this.titulo_columna = []
			
			// Si es consolidación por grupos, usar los nombres de los grupos
			if (this.Grupos && this.GruposConsolida.length > 0) {
				for (let idx = 0; idx < this.GruposConsolida.length; idx++) {
					const grupoId = this.GruposConsolida[idx]
					this.titulo_columna[idx] = this.getNombreGrupo(grupoId)
				}
				this.columnas = Math.max(1, this.GruposConsolida.length)
				return
			}
			
			// Si es consolidado y tenemos títulos de empresas válidos
			if (this.Consolidado && this.titulo_columna && this.titulo_columna.length > 0) {
				// Verificar si los títulos tienen nombres reales (no "Empresa X")
				const tieneNombresReales = this.titulo_columna.some(t => 
					t && !t.includes('Empresa') && t.trim() !== ''
				)
				if (tieneNombresReales) {
					console.log('Usando títulos de empresas ya asignados:', this.titulo_columna)
					return
				}
			}
			
			// Lógica original para empresas individuales
			for (let idx = 0; idx < this.columnas; idx++) {
				const colKey = 'e' + (idx + 1)
				if (this.balance[0] && this.balance[0][colKey] !== undefined) {
					this.titulo_columna[idx] = this.balance[0][colKey]
				} else {
					// Intentar obtener el nombre de la empresa desde EmpresasConsolida
					if (this.EmpresasConsolida && this.EmpresasConsolida.length > idx) {
						const comp = this.companias.find(c => c.id == this.EmpresasConsolida[idx])
						this.titulo_columna[idx] = comp ? comp.acronym || comp.nombre : `Empresa ${idx + 1}`
					} else {
						this.titulo_columna[idx] = `Empresa ${idx + 1}`
					}
				}
			}
			
			console.log('Títulos de columnas:', this.titulo_columna)
			console.log('Número de columnas:', this.columnas)
		},
		titulo(opcion) {
			let periodo_anterior = this.vigencia.substring(0, 4) - 1;
			let v_periodo_anterior = ""
   v_periodo_anterior = v_periodo_anterior.concat(periodo_anterior, "12") 
			if (opcion == -1) {
				return "DIF-" + this.moneda
			}
			if (opcion == 0) {
				return this.moneda + " " + v_periodo_anterior;
			}
			if (opcion == 1) {
				return this.moneda + " " + this.vigencia;
			}
			let moneda = this.currency.find((moneda) => moneda.isFuncional == 1)
			if (opcion == 2) {
				if (moneda) {
     return moneda?.acronimo + " " + v_periodo_anterior; 				}
				return this.labels.funcional1 + " " + v_periodo_anterior;
			}
			if (opcion == 3) {
				if (moneda) {
					return moneda.acronimo + " " + this.vigencia;
				}
				return this.labels.funcional1 + " " + this.vigencia;
			}
			if (opcion == -2) {
				if (moneda) {
     return "DIF-" + moneda?.acronimo 				}
				return this.labels.funcional_dif
			}
			moneda = this.currency.find((moneda) => moneda.isFuncional == 2)
			if (opcion == 4) {
				if (moneda) {
     return moneda?.acronimo + " " + v_periodo_anterior; 				}
				return this.labels.alterna1 + " " + v_periodo_anterior;
			}
			if (opcion == 5) {
				if (moneda) {
					return moneda.acronimo + " " + this.vigencia;
				}
				return this.labels.alterna1 + " " + this.vigencia;
			}
		},
		f_escribe_renglon(v_informacion) {
			if (v_informacion == "E") return false;
			return true;
		},
		f_escribe_renglon1(v_informacion) {
			if (v_informacion == "E") return false;
			return true;
		},
		uncheck(opcion) {
			// Resetear todos los checkboxes principales (excepto los de Consolidado)
			this.Balance = false;
			this.Comparativo = false;
			this.Notas = false;
			this.Informacion = false;
			this.Modifica = false;
			this.showDialog = false;
			this.showDialogCuenta = false;
			// NO resetear ConsolidadoGe cuando se trata de opciones del grupo Consolidado
			if (opcion !== 2 && opcion !== 21 && opcion !== 22) {
				this.ConsolidadoGe = false;
				this.Consolidado = false;
				this.Empresas = false;
				this.Grupos = false;
				this.showConsolidationSection = false;
				this.showGroupConsolidationSection = false;
			}
			// Manejar cada opción individualmente
			if (opcion === 1) {
				this.Balance = true;
			}
			else if (opcion === 3) {
				this.Comparativo = true;
			}
			else if (opcion === 20) {
				this.ConsolidadoGe = true;
				// Al seleccionar Consolidado, mantener Individual marcado por defecto
				this.Consolidado = true;
				this.Empresas = false;
				this.Grupos = false;
				this.showConsolidationSection = false;
				this.showGroupConsolidationSection = false;
				// AGREGAR: Incluir automáticamente la compañía seleccionada
				if (this.dialogCompanias) {
					this.EmpresasConsolida = [this.dialogCompanias];
				}
			}
			else if (opcion === 4) {
				this.Notas = true;
			}
			else if (opcion === 5) {
				this.Informacion = true;
			}
			else if (opcion === 2) {
				// Individual - mantener ConsolidadoGe marcado
				this.ConsolidadoGe = true;
				this.Consolidado = true;
				this.Empresas = false;
				this.Grupos = false;
				this.showConsolidationSection = false;
				this.showGroupConsolidationSection = false;
				// AGREGAR: Incluir automáticamente la compañía seleccionada
				if (this.dialogCompanias) {
					this.EmpresasConsolida = [this.dialogCompanias];
				}
			}
			else if (opcion === 21) {
				// Empresas - mantener ConsolidadoGe e Individual marcados
				this.ConsolidadoGe = true;
				this.Consolidado = true;
				this.Empresas = true;
				this.Grupos = false;
				this.showConsolidationSection = true;
				this.showGroupConsolidationSection = false;
			}
			else if (opcion === 22) {
				// Grupos - mantener ConsolidadoGe e Individual marcados
				this.ConsolidadoGe = true;
				this.Consolidado = true;
				this.Empresas = false;
				this.Grupos = true;
				this.showConsolidationSection = false;
				this.showGroupConsolidationSection = true;
			}
			this.isEmpty = true;
			this.generado = false;
		},
		excel(opcion) {
			let datos = {}
			const v_reporte = this.reportes.find((reporte) => reporte.codigo === this.codReporte)
   datos.reporte = v_reporte.nombre 
			datos.idCompania = this.idCompania
			const v_compania = this.companias.find((compania) => compania.id === this.idCompania)
			if (v_compania) {
    datos.compania = v_compania.nombre 
			} else {
    datos.compania = "Consolidado General" 
    datos.idCompania = 0 
			}
   datos.grupoNombre = ""; 
			if (this.selectedGrupo) {
				const grupo = this.grupos.find(g => g.id == this.selectedGrupo);
				if (grupo) {
     datos.grupoNombre = grupo.nombre; 
				}
			} else if (this.gruposFiltrados && this.gruposFiltrados.length > 1) {
    datos.grupoNombre = "VARIOS GRUPOS"; 
			}
			datos.vigencia = this.vigencia
   datos.opcion = opcion 
			datos.userId = this.$store.state.userId
			datos.userName = this.$store.state.userName
			// NUEVO: Agregar la vista activa a los datos
			datos.vistaActiva = this.vistaActiva
			if (opcion === 1) {
				datos.titulo = this.f_titulo()
				datos.informacion = this.balance
				this.hojaExcelBalance(datos)
			}
			if (opcion === 2) {
				datos.titulo = this.f_titulo()
				datos.informacion = this.balance
    datos.columnas = [ 
					this.titulo(0),
					this.titulo(1),
					this.labels.diferencia,
					this.titulo(2),
					this.titulo(3),
					this.labels.funcional_dif
				]
				this.hojaExcelComparativo(datos)
			}
			if (opcion === 3) {
				datos.titulo = this.f_titulo()
				datos.informacion = this.balance
    datos.columnas = [] 
    datos.idCompania = 0 
    datos.compania = "Consolidado General" 
				let i = 0
				for (i = 0; i < this.titulo_columna.length; i++) {
					datos.columnas[i] = this.titulo_columna[i]
				}
    datos.columnas[i] = "Ajustes" 
				i = i + 1
    datos.columnas[i] = "Consolidado" 
				datos.nombreArchivo = this.generarNombreArchivoExcel();
				this.hojaExcelConsolidadoConDisenioDetalle(datos)
			}
			if (opcion === 4) {
				datos.titulo = this.f1_titulo()
				datos.informacion = this.cuentas
				this.hojaExcelCuentas(datos)
			}
		},
		generarNombreArchivoExcel() {
			let nombre = "Balance_Consolidado";
			if (this.selectedGrupo) {
				const grupo = this.grupos.find(g => g.id == this.selectedGrupo);
				if (grupo) {
     nombre += `_${grupo.nombre.replace(/\s+/g, '_')}`; 
				}
			} else if (this.grupos && this.grupos.length > 1) {
				nombre += "_VARIOS_GRUPOS";
			}
			nombre += `_${this.vigencia}`;
			const fecha = new Date();
   const fechaStr = fecha.toISOString().split('T')[0]; 
			nombre += `_${fechaStr}`;
			return nombre;
		},

		f1_titulo() {
			let v_titulo = ""
			if (this.mostrarNotas) {
				v_titulo = "NOTAS A LOS ESTADOS FINANCIEROS"
			} else {
				v_titulo = "PARRAFOS NOTA "
			}
			return v_titulo + " " + (this.formCuentas?.descripcion || '')
		},

		f2_titulo() {
			let v_titulo = ""
			if (this.mostrarNotas) {
				v_titulo = "NOTAS A LOS ESTADOS FINANCIEROS"
			} else {
				v_titulo = "CUENTAS CONTABLES "
			}
			return v_titulo + " " + (this.formCuentas?.descripcion || '')
		},
		async hojaExcelConsolidadoConDisenioDetalle(datos) {
			let createdAt1 = new Date()
   let anio = createdAt1.getFullYear() 
   let mes = String(createdAt1.getMonth() + 1).padStart(2, '0') 
   let dia = String(createdAt1.getDate()).padStart(2, '0') 
			let createdAt = anio + "-" + mes + "-" + dia
   let reporte = datos.reporte 
   let compania = datos.compania 
   let vigencia = datos.vigencia 
   let titulo = datos.titulo 
   let userName = datos.userName 
   const balance = datos.informacion 
   const columnas = datos.columnas 
			const { Workbook } = XLSX
			const workbook = new Workbook()
			let nombreHoja = "Consolidado";
			if (this.selectedGrupo) {
				const grupo = this.grupos.find(g => g.id == this.selectedGrupo);
				if (grupo) {
     nombreHoja = `Consolidado_${grupo.nombre.substring(0, 25)}`; 
				}
			} else if (this.grupos && this.grupos.length > 1) {
				nombreHoja = "Consolidado_Varios_Grupos";
			}
   nombreHoja = nombreHoja.substring(0, 31); 
   const worksheet = workbook.addWorksheet(nombreHoja) 
			const styles = {
				tituloPrincipal: {
					font: { name: "Calibri", size: 16, bold: true },
					alignment: { horizontal: "center", vertical: "middle" }
				},
				subtitulo: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "center", vertical: "middle" }
				},
				encabezadoColumnas: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "center", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
					border: {
						top: { style: "thin" },
						left: { style: "thin" },
						bottom: { style: "thin" },
						right: { style: "thin" }
					}
				},
				datoDescripcion: {
					font: { name: "Calibri", size: 10 },
					alignment: { horizontal: "left", vertical: "middle" },
					border: {
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					}
				},
				datoNumerico: {
					font: { name: "Calibri", size: 10 },
					alignment: { horizontal: "right", vertical: "middle" },
					numFmt: "#,##0",
					border: {
						left: { style: "thin" },
						right: { style: "thin" },
						bottom: { style: "thin" }
					}
				}
			}
			// Determinar si estamos en vista combinado
			const esCombinado = this.vistaConsolidado === 'combinado'
			// Construir array de columnas final
   let columnasFinales = [...columnas] 
			if (esCombinado) {
    columnasFinales.push('Combinado') 
    columnasFinales.push('Total Combinado') 
			}
   const totalColumnas = columnasFinales.length + 1 
   const endCol = String.fromCharCode(65 + totalColumnas - 1) 
			// Título
   worksheet.mergeCells(`A1:${endCol}1`) 
   worksheet.getCell('A1').value = titulo 
   Object.assign(worksheet.getCell('A1'), styles.tituloPrincipal) 
			// Subtítulo 1
   worksheet.mergeCells(`A2:${endCol}2`) 
   worksheet.getCell('A2').value = `Vigencia: ${vigencia} | Compañía: ${compania}` 
   Object.assign(worksheet.getCell('A2'), styles.subtitulo) 
			// Subtítulo 2
   worksheet.mergeCells(`A3:${endCol}3`) 
   worksheet.getCell('A3').value = `Generado: ${createdAt} por ${userName} | Reporte: ${reporte}` 
   Object.assign(worksheet.getCell('A3'), styles.subtitulo) 
   worksheet.addRow([]) 
			// Encabezado de columnas
   const headerRow = worksheet.addRow(['DESCRIPCIÓN', ...columnasFinales]) 
   headerRow.eachCell((cell) => { 
    Object.assign(cell, styles.encabezadoColumnas) 
			})
			// Datos del balance
   balance.forEach((item) => { 
				if (this.f_escribe_renglon(item.informacion)) {
     const rowData = [item.descripcion] 
					for (let i = 0; i < this.titulo_columna.length; i++) {
						const valorColumna = this.getValorConsolidadoColumna(item, i + 1) || 0
      rowData.push(parseFloat(valorColumna) || 0) 
					}
					rowData.push(parseFloat(this.getValorConsolidado(item, 'ajustes')) || 0)
					rowData.push(parseFloat(this.getValorConsolidado(item, 'total')) || 0)
					if (esCombinado) {
						rowData.push(parseFloat(this.getValorConsolidado(item, 'combinado')) || 0)
						rowData.push(parseFloat(this.getValorConsolidado(item, 'total_combinado')) || 0)
					}
     const currentRow = worksheet.addRow(rowData) 
     currentRow.eachCell((cell, colNumber) => { 
						if (colNumber === 1) {
       Object.assign(cell, styles.datoDescripcion) 
						} else {
       Object.assign(cell, styles.datoNumerico) 
						}
					})
				}
			})
			// Ajustar ancho de columnas
			const columnWidths = [
				{ width: 40 }, // Descripción
    ...columnasFinales.map(() => ({ width: 15 })) 
			]
   worksheet.columns = columnWidths 
   worksheet.views = [ 
				{ state: 'frozen', ySplit: 5 }
			]
   const file = await workbook.xlsx.writeBuffer() 
   const downloadLink = document.createElement("a") 
   let nombreArchivo = datos.nombreArchivo || `Consolidado_${compania}_${vigencia}_${createdAt}.xlsx`; 
			if (esCombinado) {
    nombreArchivo = `Consolidado_Combinado_${compania}_${vigencia}_${createdAt}.xlsx`; 
			}
   downloadLink.download = nombreArchivo 
   downloadLink.href = window.URL.createObjectURL( 
				new Blob([file], {
     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 
				})
			)
   downloadLink.style.display = "none" 
   document.body.appendChild(downloadLink) 
   downloadLink.click() 
   downloadLink.remove() 
		},
		async hojaExcelBalance(datos) {
			let createdAt1 = new Date()
   let anio = createdAt1.getFullYear() 
   let mes = String(createdAt1.getMonth() + 1).padStart(2, '0') 
   let dia = String(createdAt1.getDate()).padStart(2, '0') 
			let createdAt = anio + "-" + mes + "-" + dia
   let reporte = datos.reporte 
   let compania = datos.compania 
   let vigencia = datos.vigencia 
   let titulo = datos.titulo 
   let userName = datos.userName 
   const filas = datos.informacion 
			const { Workbook } = XLSX
			const workbook = new Workbook()
   const worksheet = workbook.addWorksheet("Balance") 
			const styles = {
				tituloPrincipal: {
					font: { name: "Calibri", size: 16, bold: true },
					alignment: { horizontal: "center", vertical: "middle" }
				},
				subtitulo: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "center", vertical: "middle" }
				},
				encabezado: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "center", vertical: "middle" },
					border: {
						top: { style: "thin" },
						left: { style: "thin" },
						bottom: { style: "thin" },
						right: { style: "thin" }
					}
				},
				nivel1: {
					font: { name: "Calibri", size: 12, bold: true },
					alignment: { horizontal: "left", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "F2F2F2" } },
					border: {
						bottom: { style: "thin" }
					}
				},
				nivel2: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "left", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "F8F8F8" } },
					indent: 1
				},
				datoNormal: {
					font: { name: "Calibri", size: 10 },
					alignment: { horizontal: "right", vertical: "middle" },
					numFmt: "#,##0",
					border: {
						left: { style: "thin" },
						right: { style: "thin" }
					},
					indent: 2
				},
				total: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "right", vertical: "middle" },
					numFmt: "#,##0",
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
					border: {
						top: { style: "medium" },
						bottom: { style: "double" }
					}
				},
				descripcionTotal: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "right", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
					border: {
						top: { style: "medium" },
						bottom: { style: "double" }
					}
				}
			}
			// ENCABEZADO PRINCIPAL
   worksheet.mergeCells('A1:D1') 
   worksheet.getCell('A1').value = titulo 
   Object.assign(worksheet.getCell('A1'), styles.tituloPrincipal) 
   worksheet.mergeCells('A2:D2') 
   worksheet.getCell('A2').value = `Vigencia: ${vigencia} | Compañía: ${compania}` 
   Object.assign(worksheet.getCell('A2'), styles.subtitulo) 
   worksheet.mergeCells('A3:D3') 
   worksheet.getCell('A3').value = `Generado: ${createdAt} por ${userName} | Reporte: ${reporte}` 
   Object.assign(worksheet.getCell('A3'), styles.subtitulo) 
			// ESPACIO
   worksheet.addRow([]) 
			// ENCABEZADO DE COLUMNAS
			const HEADER_ROW = [
				'DESCRIPCIÓN',
				'LOCAL',
				(this.labelFuncionalSeleccionada || this.labels.funcional1 || 'FUNCIONAL').toUpperCase(),
				(this.labelInternaSeleccionada || this.labels.interna1 || 'INTERNA').toUpperCase()
			]
   const headerRow = worksheet.addRow(HEADER_ROW) 
   headerRow.eachCell((cell) => { 
    Object.assign(cell, styles.encabezado) 
			})
			// PROCESAR FILAS
			let n_fila = 6 // Empezamos después del encabezado
   filas.forEach((fila) => { 
    if (fila.informacion === "E") { 
					// ENCABEZADO DE SECCIÓN (Nivel 1) - Con fondo gris claro y borde inferior
     worksheet.addRow([fila.descripcion, '', '', '']) 
     worksheet.mergeCells(`A${n_fila}:D${n_fila}`) 
     Object.assign(worksheet.getCell(`A${n_fila}`), styles.nivel1) 
					n_fila++
				} else if (this.f_escribe_renglon(fila.informacion)) {
					const valorFuncional = this.getValorFuncional(fila)
					const valorInterna = this.getValorInterna(fila)
					const v_fila = [
      fila.descripcion, 
      (fila.saldo_actual === null) ? fila.saldo_actual : parseFloat(fila.saldo_actual), 
      (valorFuncional === null) ? valorFuncional : parseFloat(valorFuncional), 
      (valorInterna === null) ? valorInterna : parseFloat(valorInterna) 
					]
     const currentRow = worksheet.addRow(v_fila) 
					// APLICAR ESTILOS SEGÚN EL TIPO DE FILA
     if (fila.informacion === "T" || (fila.informacion === "S" && fila.segundo_nivel === 999)) { 
						// TOTALES (T) o SUBTOTALES (S) fuera de niveles - fondo gris y bordes destacados
      currentRow.eachCell((cell, colNumber) => { 
							if (colNumber === 1) {
        Object.assign(cell, styles.descripcionTotal) 
							} else {
        Object.assign(cell, styles.total) 
							}
						})
					} else {
						// FILAS NORMALES
      currentRow.eachCell((cell, colNumber) => { 
							if (colNumber === 1) {
								// Columna descripción - diferenciar niveles
        if (fila.segundo_nivel > 0 && fila.segundo_nivel < 999) { 
         Object.assign(cell, styles.nivel2) 
								} else {
									// Datos normales en descripción
         cell.font = { name: "Calibri", size: 10 } 
         cell.alignment = { horizontal: "right", vertical: "middle" } 
         cell.indent = 2 
								}
							} else {
								// Columnas numéricas
        Object.assign(cell, styles.datoNormal) 
							}
						})
					}
					n_fila++
				}
			})
			// AJUSTAR ANCHO DE COLUMNAS
   worksheet.columns = [ 
				{ width: 45 }, // Descripción - más ancho para mejor legibilidad
				{ width: 18 }, // Local
				{ width: 18 }, // Funcional USD
				{ width: 18 }  // Interna USD
			]
			// AGREGAR BORDES VERTICALES PARA MEJOR LEGIBILIDAD
			const lastRow = n_fila - 1;
			for (let row = 6; row <= lastRow; row++) {
				for (let col = 1; col <= 4; col++) {
     const cell = worksheet.getCell(row, col); 
     if (!cell.border) { 
      cell.border = { 
							left: { style: "thin" },
							right: { style: "thin" },
							top: { style: "thin" },
							bottom: { style: "thin" }
						};
					}
				}
			}
			// CONGELAR PANELES (encabezados siempre visibles)
   worksheet.views = [ 
				{ state: 'frozen', ySplit: 5 } // Congela hasta la fila 5
			]
   const file = await workbook.xlsx.writeBuffer() 
   const downloadLink = document.createElement("a") 
   downloadLink.download = `Balance_${compania}_${vigencia}_${createdAt}.xlsx` 
   downloadLink.href = window.URL.createObjectURL( 
				new Blob([file], {
     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 
				})
			)
   downloadLink.style.display = "none" 
   document.body.appendChild(downloadLink) 
   downloadLink.click() 
   downloadLink.remove() 
		},
		async hojaExcelComparativo(datos) {
			let createdAt1 = new Date()
   let anio = createdAt1.getFullYear() 
   let mes = createdAt1.getMonth() + 1 
   let dia = createdAt1.getDate() 
			let createdAt = anio + "-" + mes + "-" + dia
   let reporte = datos.reporte 
   let compania = datos.compania 
   let vigencia = datos.vigencia 
   let titulo = datos.titulo 
   let columnas = datos.columnas 
   let userName = datos.userName 
   const filas = datos.informacion 
			const { Workbook } = XLSX
			const workbook = new Workbook()
   const worksheet = workbook.addWorksheet("Comparativo") 
			const ENCABEZADO1 = [
				titulo
			]
   worksheet.addRow(ENCABEZADO1) 
			const ENCABEZADO2 = [
				"Vigencia " + vigencia,
			]
   worksheet.addRow(ENCABEZADO2) 
			const ENCABEZADO3 = [
				"Creado " + createdAt + " por " + userName,
			]
   worksheet.addRow(ENCABEZADO3) 
			const ENCABEZADO4 = [
				"Compañia " + compania,
			]
   worksheet.addRow(ENCABEZADO4) 
			const ENCABEZADO5 = [
			]
   worksheet.addRow(ENCABEZADO5) 
			const HEADER_ROW = [
    'DESCRIPCION/NIIF (IFRS) ' + reporte.toUpperCase(), 
				columnas[0],
				columnas[1],
				columnas[2],
				columnas[3],
				columnas[4],
				columnas[5],
			]
   worksheet.addRow(HEADER_ROW) 
			for (let fila = 1; fila < 7; fila++) {
    worksheet.getRow(fila).font = { 
					name: "Arial Black",
					family: 2,
					size: 14,
					bold: true,
					italic: true,
				}
			}
			for (let columna = 1; columna < 7; columna++) {
    const v_columna = String.fromCharCode(columna + 65) + "6" 
    worksheet.getCell(v_columna).alignment = { 
					horizontal: "center",
				}
			}
			var n_fila = 7
   filas.forEach((fila) => { 
    if (fila.informacion === "E") { 
					const v_salto = [""]
     worksheet.addRow(v_salto) 
					n_fila++
					return;
				}
				const v_fila = [
     fila.descripcion, 
     (fila.anterior === null) ? fila.anterior : parseFloat(fila.anterior), 
     (fila.actual === null) ? fila.actual : parseFloat(fila.actual), 
     (fila.diferencia === null) ? fila.diferencia : parseFloat(fila.diferencia), 
     (fila.funcional_ant === null) ? fila.funcional_ant : parseFloat(fila.funcional_ant), 
     (fila.funcional_act === null) ? fila.funcional_act : parseFloat(fila.funcional_act), 
     (fila.funcional_dif === null) ? fila.funcional_dif : parseFloat(fila.funcional_dif), 
				]
    worksheet.addRow(v_fila) 
				for (let columna = 0; columna < 7; columna++) {
     const v_columna = String.fromCharCode(columna + 65) + n_fila.toString() 
					if (columna === 0) {
      worksheet.getCell(v_columna).font = { 
							name: "Arial Black",
							family: 2,
							size: 13,
       bold: (fila.informacion === "E" || fila.informacion === "T") ? true : false, 
       italic: (fila.informacion === "E" || fila.informacion === "T") ? true : false, 
						}
      worksheet.getCell(v_columna).alignment = { 
       horizontal: (fila.informacion === "I" || (fila.informacion === 'T' && fila.segundo_nivel > 0 && fila.segundo_nivel < 999) || (fila.informacion = 'E' && fila.segundo_nivel > 0 && fila.segundo_nivel < 999)) ? 'right' : 'left', 
						}
					} else {
      worksheet.getCell(v_columna).font = { 
							size: 13,
						}
      worksheet.getCell(v_columna).numFmt = "#,0" 
					}
				}
				n_fila++
			})
   const file = await workbook.xlsx.writeBuffer() 
   const downloadLink = document.createElement("a") 
   downloadLink.download = "Comparativo" + vigencia + ".xlsx" 
   downloadLink.href = window.URL.createObjectURL( 
				new Blob([file], {
     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 
				})
			)
   downloadLink.style.display = "none"; 
   document.body.appendChild(downloadLink); 
   downloadLink.click(); 
   downloadLink.remove(); 
		},
		async hojaExcelConsolidado(datos) {
			let createdAt1 = new Date()
   let anio = createdAt1.getFullYear() 
   let mes = createdAt1.getMonth() + 1 
   let dia = createdAt1.getDate() 
			let createdAt = anio + "-" + mes + "-" + dia
   let reporte = datos.reporte 
   let compania = datos.compania 
   let vigencia = datos.vigencia 
   let titulo = datos.titulo 
   let columnas = datos.columnas 
   let userName = datos.userName 
   const filas = datos.informacion 
			const { Workbook } = XLSX
			const workbook = new Workbook()
   const worksheet = workbook.addWorksheet("Consolidado") 
			const ENCABEZADO1 = [
				titulo
			]
   worksheet.addRow(ENCABEZADO1) 
			const ENCABEZADO2 = [
				"Vigencia " + vigencia,
			]
   worksheet.addRow(ENCABEZADO2) 
			const ENCABEZADO3 = [
				"Creado " + createdAt + " por " + userName,
			]
   worksheet.addRow(ENCABEZADO3) 
			const ENCABEZADO4 = [
				"Compañia " + compania,
			]
   worksheet.addRow(ENCABEZADO4) 
			const ENCABEZADO5 = [
			]
   worksheet.addRow(ENCABEZADO5) 
			const HEADER_ROW = [
    'DESCRIPCION/NIIF (IFRS) ' + reporte.toUpperCase(), 
			]
   for (let k = 0; k < (filas[0].columnas - 1) + 2; k++) { 
				const v_celda = columnas[k]
    HEADER_ROW.push(v_celda) 
			}
   worksheet.addRow(HEADER_ROW) 
			for (let fila = 1; fila < 7; fila++) {
    worksheet.getRow(fila).font = { 
					name: "Arial Black",
					family: 2,
					size: 14,
					bold: true,
					italic: true,
				}
			}
   for (let columna = 1; columna < filas[0].columnas + 2; columna++) { 
    const v_columna = String.fromCharCode(columna + 65) + "6" 
    worksheet.getCell(v_columna).alignment = { 
					horizontal: "center",
				}
			}
			var n_fila = 7
   filas.forEach((fila) => { 
    const v_informacion = fila.informacion 
    if (fila.informacion === "E") { 
					const v_salto = [""]
     worksheet.addRow(v_salto) 
					n_fila++
					return;
				}
				const v_fila = [
     fila.descripcion, 
				]
    for (let k = 0; k < filas[0].columnas - 1; k++) { 
					const v_celda = this.f_val_fila(v_informacion, fila, k)
     v_fila.push(v_celda) 
				}
				const v_ajustes = this.f_valor(v_informacion, this.getValorConsolidado(fila, 'ajustes'))
    v_fila.push(v_ajustes) 
				const v_total = this.f_valor(v_informacion, this.getValorConsolidado(fila, 'total'))
    v_fila.push(v_total) 
    worksheet.addRow(v_fila) 
    for (let columna = 0; columna <= filas[0].columnas + 2; columna++) { 
     const v_columna = String.fromCharCode(columna + 65) + n_fila.toString() 
					if (columna === 0) {
      worksheet.getCell(v_columna).font = { 
							name: "Arial Black",
							family: 2,
							size: 13,
       bold: (fila.informacion === "E" || fila.informacion === "T") ? true : false, 
       italic: (fila.informacion === "E" || fila.informacion === "T") ? true : false, 
						}
      worksheet.getCell(v_columna).alignment = { 
       horizontal: (fila.informacion === "I" || (fila.informacion === 'T' && fila.segundo_nivel > 0 && fila.segundo_nivel < 999) || (fila.informacion = 'E' && fila.segundo_nivel > 0 && fila.segundo_nivel < 999)) ? 'right' : 'left', 
						}
					} else {
      worksheet.getCell(v_columna).font = { 
							size: 13,
						}
      worksheet.getCell(v_columna).numFmt = "#,0" 
					}
				}
				n_fila++
			})
   const file = await workbook.xlsx.writeBuffer() 
   const downloadLink = document.createElement("a") 
   downloadLink.download = "Consolidado" + vigencia + ".xlsx" 
   downloadLink.href = window.URL.createObjectURL( 
				new Blob([file], {
     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 
				})
			)
   downloadLink.style.display = "none"; 
   document.body.appendChild(downloadLink); 
   downloadLink.click(); 
   downloadLink.remove(); 
		},
		async obtenerAjustesPorEmpresa(companiaId, vigencia, empresasRelacionadas) {
			try {
				let empresasValidas = [];

				// Prioridad: lista explícita recibida (empresasRelacionadas)
				if (empresasRelacionadas && empresasRelacionadas.length > 0) {
					empresasValidas = [...empresasRelacionadas];
					console.log('Usando empresasRelacionadas:', empresasValidas);

				} else if (this.EmpresasConsolidaExcel && this.EmpresasConsolidaExcel.length > 0) {
					empresasValidas = [...this.EmpresasConsolidaExcel];
					console.log('Usando EmpresasConsolidaExcel:', empresasValidas);

				} else if (this.EmpresasConsolida && this.EmpresasConsolida.length > 0) {
					empresasValidas = [...this.EmpresasConsolida];
					console.log('Usando EmpresasConsolida:', empresasValidas);

				} else if (this.idCompania) {
					empresasValidas = [this.idCompania];
					console.log('Consolidado individual:', empresasValidas);

				} else {
					console.warn('No hay empresas válidas');
					return [];
				}
    const response = await Balance.getAjustesDetallados( 
					this.codReporte,
					vigencia,
					empresasValidas
				);
    let ajustes = response.data.ajustes || []; 
    if (ajustes.length === 0) { 
					return [];
				}
    console.log('Ajustes recibidos:', ajustes.length); 
				// Detectar secuencias con origen A que son "auto-compañía" (misma compañía en toda la secuencia),
    // para no descartarlas cuando alguna línea O/D venga en cero. 
				const secuenciasAutoCompaniaA = new Set();
				const companiasPorSecuenciaA = new Map();
				ajustes.forEach((ajuste) => { 
					const origen = (ajuste.origen || '').toString().trim().toUpperCase(); 
					if (origen !== 'A') return;
					const secuencia = `${ajuste.secuencia || ''}`
					if (!secuencia) return;
     const idAjuste = Number(ajuste.id_compania); 
     if (!companiasPorSecuenciaA.has(secuencia)) { 
      companiasPorSecuenciaA.set(secuencia, new Set()); 
					}
     companiasPorSecuenciaA.get(secuencia).add(idAjuste); 
				});
    companiasPorSecuenciaA.forEach((setCompanias, secuencia) => { 
     if (setCompanias.size === 1) { 
      secuenciasAutoCompaniaA.add(secuencia); 
					}
				});
    ajustes = ajustes.filter(ajuste => { 
     const idAjuste = Number(ajuste.id_compania); 
					if (!empresasValidas.includes(idAjuste)) { 
						return false;
					}
					const ajusteValor =
						ajuste.ajuste_funcional1 ??
						ajuste.ajuste_funcional1_rounded ??
						ajuste.ajuste_actual ??
						ajuste.ajuste_actual_rounded ??
						0
					const valorNumerico = Math.abs(parseFloat(ajusteValor) || 0); 
					if (valorNumerico < 0.01) { 
						const origen = (ajuste.origen || '').toString().trim().toUpperCase(); 
						const secuencia = `${ajuste.secuencia || ''}`
						const esAutoCompaniaA = origen === 'A' && secuenciasAutoCompaniaA.has(secuencia); 
						if (esAutoCompaniaA) {
							return true;
						}
						return false;
					}
					return true;
				});
    ajustes.sort((a, b) => { 
     const aEsPropia = a.id_compania == companiaId; 
     const bEsPropia = b.id_compania == companiaId; 
					if (aEsPropia && !bEsPropia) return -1;
					if (!aEsPropia && bEsPropia) return 1;
     return (a?.secuencia || 0) - (b?.secuencia || 0); 				});
    console.log(`Ajustes finales empresa ${companiaId}:`, ajustes.length); 
				return ajustes;
			} catch (error) {
    console.warn(`Error obteniendo ajustes detallados para empresa ${companiaId}:`, error); 
				return [];
			}
		},
		f_val_fila(p_informacion, fila, k) {
			let v_valor = this.getValorConsolidadoColumna(fila, k + 1)
			if (p_informacion === "E") {
				v_valor = null
			}
   const valor = (v_valor === null) ? v_valor : parseFloat(v_valor) 
			return valor
		},
		f_valor(p_informacion, p_valor) {
			let v_valor = p_valor
			if (p_informacion === "E") {
				v_valor = null
			}
   const valor = (v_valor === null) ? v_valor : parseFloat(v_valor) 
			return valor
		},
		async hojaExcelCuentas(datos) {
			let createdAt1 = new Date()
   let anio = createdAt1.getFullYear() 
   let mes = createdAt1.getMonth() + 1 
   let dia = createdAt1.getDate() 
			let createdAt = anio + "-" + mes + "-" + dia
   let reporte = datos.reporte.toUpperCase() 
   let compania = datos.compania 
   let vigencia = datos.vigencia 
   let titulo = datos.titulo.toUpperCase() 
   let userName = datos.userName 
   const filas = datos.informacion 
			const { Workbook } = XLSX
			const workbook = new Workbook()
   const worksheet = workbook.addWorksheet("Cuentas") 
			const ENCABEZADO0 = [reporte]
   worksheet.addRow(ENCABEZADO0) 
			const ENCABEZADO1 = [titulo]
   worksheet.addRow(ENCABEZADO1) 
			const ENCABEZADO2 = ["Vigencia " + vigencia]
   worksheet.addRow(ENCABEZADO2) 
			const ENCABEZADO3 = ["Creado " + createdAt + " por " + userName]
   worksheet.addRow(ENCABEZADO3) 
			const ENCABEZADO4 = ["Compañia " + compania]
   worksheet.addRow(ENCABEZADO4) 
			const HEADER_ROW = [
				"CUENTA",
				"DESCRIPCION",
				"SALDO",
				"FUNCIONAL",
				"PROMEDIO",
				"ALTERNA",
				"PROMEDIO",
			]
   worksheet.addRow(HEADER_ROW) 
			for (let fila = 1; fila < 7; fila++) {
    worksheet.getRow(fila).font = { 
					name: "Arial Black",
					family: 2,
					size: 14,
					bold: true,
					italic: true,
				}
			}
			for (let columna = 2; columna < 7; columna++) {
    const v_columna = String.fromCharCode(columna + 65) + "6" 
    worksheet.getCell(v_columna).alignment = { 
					horizontal: "center",
				}
			}
			var n_fila = 7
   filas.forEach((fila) => { 
    if (fila.informacion === "E") { 
					const v_salto = [""]
     worksheet.addRow(v_salto) 
					n_fila++
					return;
				}
				const v_fila = [
     fila.cuenta, 
     fila.descripcion, 
     (fila.saldo_actual === null) ? fila.saldo_actual : parseFloat(fila.saldo_actual), 
     (fila.funcional1 === null) ? fila.funcional1 : parseFloat(fila.funcional1), 
     (fila.promedio1 === null) ? fila.promedio1 : parseFloat(fila.promedio1), 
     (fila.funcional2 === null) ? fila.funcional2 : parseFloat(fila.funcional2), 
     (fila.promedio2 === null) ? fila.promedio2 : parseFloat(fila.promedio2), 
				]
    worksheet.addRow(v_fila) 
				for (let columna = 0; columna < 7; columna++) {
     const v_columna = String.fromCharCode(columna + 65) + n_fila.toString() 
					if (columna < 2) {
      worksheet.getCell(v_columna).font = { 
							name: "Arial Black",
							family: 2,
							size: 13,
							bold: true,
							italic: true,
						}
      worksheet.getCell(v_columna).alignment = { 
							horizontal: "left",
						}
					} else {
      worksheet.getCell(v_columna).font = { 
							size: 13,
						}
      worksheet.getCell(v_columna).numFmt = "#,0" 
					}
				}
				n_fila++
			})
   const file = await workbook.xlsx.writeBuffer() 
   const downloadLink = document.createElement("a") 
   downloadLink.download = "Cuentas" + vigencia + ".xlsx" 
   downloadLink.href = window.URL.createObjectURL( 
				new Blob([file], {
     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 
				})
			)
   downloadLink.style.display = "none"; 
   document.body.appendChild(downloadLink); 
   downloadLink.click(); 
   downloadLink.remove(); 
		},
		formato(valor) {
			if (valor === null || valor === undefined || valor === '') {
				return ''
			}
   const valorStr = valor.toString().trim() 
			const numero = parseFloat(valorStr)
			if (isNaN(numero)) {
				return valorStr
			}
   return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 })?.format(numero) 
		},
		formato_consol(valor) {
			if (valor === null || valor === undefined || valor === '') {
				return ''
			}
   const valorStr = valor.toString().trim() 
			let numero = parseFloat(valorStr)
			if (isNaN(numero)) {
				return valorStr
			}
			const funcional = this.currency.find((funcional) => funcional.isFuncional == 1);
			if (funcional && funcional.id != this.cmoneda) {
				this.tasa_cambio = 1;
				const cmoneda = this.tasasCambio.find((tasas) => tasas.id_moneda == this.cmoneda);
				if (cmoneda) {
					this.tasa_cambio = this.tasa_cambio * cmoneda.tasa_cierre;
				}
				this.amoneda = this.cmoneda;
			}
			numero = numero * this.tasa_cambio;
			// Aplicar formato con separadores de miles
   return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 })?.format(numero); 
		},
		f_muestra(r_origen) {
   if (r_origen.informacion != "I") { 
				return
			}
			this.formCuentas = r_origen
			Balance.getCuentasNiif(this.codReporte, this.idCompania, this.vigencia, r_origen.niif)
    .then((result) => { 
					this.cuentas = result.data.cuentas
					this.showDialogCuenta = true
				})
    .catch(() => { 
					this.error = true
				});
			setTimeout(() => {
				this.t_saldo = 0;
				this.t_funcional = 0;
				this.t_promedio = 0;
				this.t_interna1 = 0;
				this.t_alterna = 0;
				this.t_prom_alterna = 0;
				this.t_interna2 = 0;
				this.cuentas.forEach((cuenta) => {
					this.t_saldo = this.t_saldo + parseFloat(cuenta.saldo_actual || 0)
					this.t_funcional = this.t_funcional + parseFloat(cuenta.funcional1 || 0)
					this.t_promedio = this.t_promedio + parseFloat(cuenta.promedio1 || 0)
					this.t_interna1 = this.t_interna1 + parseFloat(cuenta.interna1 || 0)
					this.t_alterna = this.t_alterna + parseFloat(cuenta.funcional2 || 0)
					this.t_prom_alterna = this.t_prom_alterna + parseFloat(cuenta.promedio2 || 0)
					this.t_interna2 = this.t_interna2 + parseFloat(cuenta.interna2 || 0)
				})
				let r_cuenta = {}
    r_cuenta.cuenta = '' 
    r_cuenta.descripcion = 'TOTAL CONSULTA' 
				r_cuenta.saldo_actual = this.t_saldo
				r_cuenta.funcional1 = this.t_funcional
				r_cuenta.promedio1 = this.t_promedio
				r_cuenta.interna1 = this.t_interna1
				r_cuenta.funcional2 = this.t_alterna
				r_cuenta.promedio2 = this.t_prom_alterna
				r_cuenta.interna2 = this.t_interna2
				this.cuentas.push(r_cuenta)
			}, 1000)
		},
		async f_todas_notas() {
			this.showGeneratingWordModal = true;
			this.generatingWordMessage = 'Generando todas las notas...';
			this.generatingWordSubMessage = 'Recopilando información de las notas financieras';
			this.generatingWordProgress = 20;
			this.codReporte = this.dialogReportes
			try {
				this.a_Paragraph = [];
				this.a_titulos = [];
				this.a_informacion = [];
				this.generatingWordProgress = 40;
				this.generatingWordMessage = 'Obteniendo datos de las notas...';
				await Balance.getTodasNotas(this.codReporte, this.idCompania, this.vigencia)
     .then((result) => { 
						this.generatingWordProgress = 60;
						this.generatingWordMessage = 'Procesando información...';
						this.a_detalle = result.data.a_detalle;
						this.a_detalle_columnas = result.data.a_detalle_columnas;
						this.a_detalle_cuentas = result.data.a_detalle_cuentas;
						this.a_detalle_niif = result.data.a_detalle_niif;
						this.a_detalle_filas = result.data.a_detalle_filas;
						this.a_detalle_tabla = result.data.a_detalle_tabla;
						this.a_detalle_texto = result.data.a_detalle_texto;
						this.a_informacion_tblm = result.data.a_informacion_tblm;
						this.a_informacion_txfc = result.data.a_informacion_txfc;
						this.a_informacion_txfg = result.data.a_informacion_txfg;
						this.a_informacion_txvc = result.data.a_informacion_txvc;
						this.a_informacion_txvg = result.data.a_informacion_txvg;
						this.generatingWordProgress = 80;
						this.generatingWordMessage = 'Preparando documento...';
						this.$toast.info('Procesando todas las notas...');
					})
     .catch(() => { 
						this.error = true;
						this.$toast.error('Error al obtener las notas');
					});
				this.generatingWordProgress = 90;
				this.generatingWordMessage = 'Generando Word...';
				this.generatingWordSubMessage = 'Espere un momento por favor';
				setTimeout(() => {
					this.crea_word_todas();
				}, 500);
			} catch (error) {
    console.error('Error generando todas las notas:', error); 
				this.$toast.error('Error al generar las notas');
				this.showGeneratingWordModal = false;
			}
		},
		async f_muestra_nota(r_nota) {
			this.showGeneratingWordModal = true;
			this.generatingWordMessage = 'Generando nota...';
			this.generatingWordSubMessage = `Nota ${r_nota.numero}: ${r_nota.descripcion}`;
			this.generatingWordProgress = 20;
			try {
				this.a_Paragraph = [];
				this.a_titulos = [];
				this.a_informacion = [];
				this.formNotas = r_nota;
				this.formCuentas = r_nota;
    if (r_nota.numero) { 
					this.generatingWordProgress = 40;
					this.generatingWordMessage = 'Obteniendo datos de la nota...';
					this.codReporte = this.dialogReportes
					await Balance.getNotas(this.codReporte, this.idCompania, this.vigencia, r_nota.numero)
      .then((result) => { 
							this.generatingWordProgress = 60;
							this.generatingWordMessage = 'Procesando información...';
							this.a_detalle = result.data.a_detalle;
							this.a_detalle_columnas = result.data.a_detalle_columnas;
							this.a_detalle_cuentas = result.data.a_detalle_cuentas;
							this.a_detalle_niif = result.data.a_detalle_niif;
							this.a_detalle_filas = result.data.a_detalle_filas;
							this.a_detalle_tabla = result.data.a_detalle_tabla;
							this.a_detalle_texto = result.data.a_detalle_texto;
							this.a_informacion_tblm = result.data.a_informacion_tblm;
							this.a_informacion_txfc = result.data.a_informacion_txfc;
							this.a_informacion_txfg = result.data.a_informacion_txfg;
							this.a_informacion_txvc = result.data.a_informacion_txvc;
							this.a_informacion_txvg = result.data.a_informacion_txvg;
							this.generatingWordProgress = 80;
							this.generatingWordMessage = 'Preparando documento...';
							this.$toast.info(`Procesando nota ${r_nota.numero}...`);
						})
      .catch(() => { 
							this.error = true;
							this.$toast.error('Error al obtener la nota');
						});
					this.generatingWordProgress = 90;
					this.generatingWordMessage = 'Generando Word...';
					setTimeout(() => {
						this.crea_word();
					}, 500);
				}
			} catch (error) {
    console.error('Error generando nota:', error); 
				this.$toast.error('Error al generar la nota');
				this.showGeneratingWordModal = false;
			}
		},
		async crea_word() {
			try {
				this.generatingWordProgress = 95;
				this.generatingWordMessage = 'Finalizando documento...';
				this.a_Paragraph = []
				this.a_titulos = []
				this.a_informacion = []
				for (const detalle of this.a_detalle) {
					this.a_titulos.push({
      titulo: detalle.titulo, 
      id: detalle.id 
					})
					let variable = null
     if (detalle.tipo === "TFG") { 
						const txfg = this.a_informacion_txfg.find(tx => tx.parrafo === detalle.parrafo)
						if (txfg) {
							variable = {
        texto: txfg.texto, 
        texto_html: txfg.texto_html, 
        id: detalle.id, 
        numero: detalle.numero, 
        parrafo: detalle.parrafo, 
								tablatype: "TTT"
							}
						}
					}
     if (detalle.tipo === "TFC") { 
						const txfc = this.a_informacion_txfc.find(tx => tx.parrafo === detalle.parrafo)
						if (txfc) {
							variable = {
        texto: txfc.texto, 
        texto_html: txfc.texto_html, 
        id: detalle.id, 
        numero: detalle.numero, 
        parrafo: detalle.parrafo, 
								tablatype: "TTT"
							}
						}
					}
						if (detalle.tipo === "TVG" || detalle.tipo === "TVC") {
							let origen = detalle.tipo === "TVG"
								? this.a_informacion_txvg
								: this.a_informacion_txvc
							let tx = origen.find(tx =>
								tx.parrafo === detalle.parrafo &&
								tx.numero === detalle.numero
						)
						if (tx) {
       if (tx.valor_campo0 && tx.valor_campo0.trim() !== '') { 
								variable = {
         texto: tx.valor_campo0, 
         texto_html: tx.valor_campo0, 
         id: detalle.id, 
         numero: detalle.numero, 
         parrafo: detalle.parrafo, 
									tablatype: "TTT"
								}
							} else {
								let textoBase = this.a_detalle_texto.find(t =>
         t.parrafo === detalle.parrafo && 
         t.numero === detalle.numero 
								)
								if (textoBase) {
         let texto = textoBase.texto 
         let texto_html = textoBase.texto_html || textoBase.texto || "" 
									for (let i = 0; i <= 9; i++) {
										if (tx[`valor_campo${i}`]) {
											texto = texto.replace(`%valor_campo${i}%`, tx[`valor_campo${i}`])
											texto_html = texto_html.replace(`%valor_campo${i}%`, tx[`valor_campo${i}`])
										}
									}
									variable = {
										texto: texto,
										texto_html: texto_html,
          id: detalle.id, 
          numero: detalle.numero, 
          parrafo: detalle.parrafo, 
										tablatype: "TTT"
									}
								}
							}
						} else {
							let textoBase = this.a_detalle_texto.find(t =>
        t.parrafo === detalle.parrafo && 
        t.numero === detalle.numero 
							)
							if (textoBase) {
								variable = {
         texto: textoBase.texto, 
         texto_html: textoBase.texto_html || textoBase.texto || "", 
         id: detalle.id, 
         numero: detalle.numero, 
         parrafo: detalle.parrafo, 
									tablatype: "TTT"
								}
							}
						}
					}
     if (["TBA", "TBT", "TBC", "TBM", "TNA", "TNT", "TNC"].includes(detalle.tipo)) { 
						variable = {
       texto: detalle.tipo, 
       id: detalle.id, 
       numero: detalle.numero, 
       parrafo: detalle.parrafo, 
       tablatype: detalle.tipo 
						}
					}
					if (variable) {
						this.a_informacion.push(variable)
					}
				}
				this.agregarTexto("Notas a los Estados Financieros", true)
				this.agregarSalto()
				this.agregarTexto(`${this.formNotas.numero}-\t${this.formNotas.descripcion}`, true)
				this.agregarSalto()
				for (const info of this.a_informacion) {
					const titulo = this.a_titulos.find(t => t.id === info.id)
     if (titulo && info.tablatype === "TTT") { 
						this.agregarTexto(titulo.titulo, true)
						this.agregarSalto()
      if (info.texto_html) { 
							this.agregarTexto(info.texto_html, false, true)
						} else {
							this.agregarTexto(info.texto)
						}
						this.agregarSalto()
						continue
					}
					// VERIFICAR SI HAY DATOS PARA LAS TABLAS TBM
     if (info.tablatype === "TBM") { 
						// Buscar si existen datos en a_informacion_tblm para este párrafo y nota
						const tieneDatosTBM = this.tieneDatosTablaTBM(info.numero, info.parrafo);
						if (!tieneDatosTBM) {
       console.log(`Tabla TBM ${info.numero}-${info.parrafo} sin datos, omitiendo...`); 
							continue;
						}
					}
					// VERIFICAR SI HAY DATOS PARA OTRAS TABLAS
     if (["TBA", "TBT", "TBC", "TNA", "TNT", "TNC"].includes(info.tablatype)) { 
						const tieneDatos = await this.verificarDatosTabla(info.tablatype, info.numero, info.parrafo);
						if (!tieneDatos) {
       console.log(`Tabla ${info.tablatype} ${info.numero}-${info.parrafo} sin datos, omitiendo...`); 
							continue;
						}
					}
     switch (info.tablatype) { 
						case "TBA": {
							await this.procesarTBA(info);
							break;
						}
						case "TBT": {
							await this.procesarTBT(info);
							break;
						}
						case "TBC": {
							await this.procesarTBC(info);
							break;
						}
						case "TBM": {
							await this.procesarTBM(info);
							break;
						}
						case "TNA": {
							await this.procesarTNA(info);
							break;
						}
						case "TNT": {
							await this.procesarTNT(info);
							break;
						}
						case "TNC": {
							await this.procesarTNC(info);
							break;
						}
					}
				}
				this.generatingWordProgress = 100;
				this.generatingWordMessage = '¡Completado!';
				setTimeout(() => {
					this.showGeneratingWordModal = false;
					this.generarWord();
				}, 500);
			} catch (error) {
    console.error('Error en crea_word:', error); 
				this.showGeneratingWordModal = false;
				this.$toast.error('Error al crear el documento');
			}
		},
		// Nuevo método para verificar si hay datos en tabla TBM
		tieneDatosTablaTBM(numero, parrafo) {
			if (!this.a_informacion_tblm || !Array.isArray(this.a_informacion_tblm)) {
				return false;
			}
			// Filtrar datos por número y párrafo - USANDO LOS PARÁMETROS
			const datosFiltrados = this.a_informacion_tblm.filter(item => {
				// Convertir a números para comparación estricta
    const itemNumero = parseInt(item.numero); 
    const itemParrafo = parseInt(item.parrafo); 
				const paramNumero = parseInt(numero);
				const paramParrafo = parseInt(parrafo);
				return itemNumero === paramNumero && itemParrafo === paramParrafo;
			});
			// Verificar si hay al menos un dato con valor no vacío
   return datosFiltrados?.some(item =>     item.valor && item.valor.toString().trim() !== '' 
			);
		},
		async verificarDatosTabla(tipo, numero, parrafo) {
			try {
				// Si ya tenemos datos en memoria, verificar
				switch (tipo) {
					case "TBA":
						return this.saldosTBA && this.saldosTBA.length > 0 &&
							this.saldosTBA.some(item => item.saldo_actual !== null && Math.abs(item.saldo_actual) > 0.01);
					case "TBT":
						return this.saldosTBT && this.saldosTBT.length > 0 &&
							this.saldosTBT.some(item => item.saldo_actual !== null && Math.abs(item.saldo_actual) > 0.01);
					case "TBC":
						return this.saldosTBC && this.saldosTBC.length > 0 &&
							this.saldosTBC.some(item =>
        (item.saldo_anterior !== null && Math.abs(item.saldo_anterior) > 0.01) || 
        (item.saldo_actual !== null && Math.abs(item.saldo_actual) > 0.01) 
							);
					case "TNA":
						if (this.saldosNiifTNA && this.saldosNiifTNA.length > 0) {
							const tieneDatos = this.saldosNiifTNA.some(item =>
        item.saldo_actual !== null && Math.abs(item.saldo_actual) > 0.01 
							);
							if (tieneDatos) return true;
						}
      console.log(`Consultando datos TNA para nota ${numero}, párrafo ${parrafo}`); 
						try {
       const result = await Balance.getTNA( 
								this.codReporte,
								this.idCompania,
								this.vigencia,
								numero,
								parrafo
							);
							this.saldosNiifTNA = result.data.saldosNiifTNA || [];
							const tieneDatos = this.saldosNiifTNA.some(item =>
        item.saldo_actual !== null && Math.abs(item.saldo_actual) > 0.01 
							);
							console.log(`Resultado consulta TNA: ${this.saldosNiifTNA.length} registros, tiene datos: ${tieneDatos}`);
							return tieneDatos;
						} catch (error) {
       console.error(`Error consultando TNA:`, error); 
							return false;
						}
					case "TNT":
						// PRIMERO: Verificar si ya tenemos datos en memoria
						if (this.saldosNiifTNT && this.saldosNiifTNT.length > 0) {
							const tieneDatos = this.saldosNiifTNT.some(item =>
        item.saldo_actual !== null && Math.abs(item.saldo_actual) > 0.01 
							);
							if (tieneDatos) return true;
						}
						// SEGUNDO: Si no hay datos en memoria, consultar al servidor
      console.log(`Consultando datos TNT para nota ${numero}, párrafo ${parrafo}`); 
						try {
       const result = await Balance.getTNT( 
								this.codReporte,
								this.idCompania,
								this.vigencia,
								numero,
								parrafo
							);
							this.saldosNiifTNT = result.data.saldosNiifTNT || [];
							// Verificar si hay datos válidos
							const tieneDatos = this.saldosNiifTNT.some(item =>
        item.saldo_actual !== null && Math.abs(item.saldo_actual) > 0.01 
							);
							console.log(`Resultado consulta TNT: ${this.saldosNiifTNT.length} registros, tiene datos: ${tieneDatos}`);
							return tieneDatos;
						} catch (error) {
       console.error(`Error consultando TNT:`, error); 
							return false;
						}
					case "TNC":
						// PRIMERO: Verificar si ya tenemos datos en memoria
						if (this.saldosNiifTNC && this.saldosNiifTNC.length > 0) {
							const tieneDatos = this.saldosNiifTNC.some(item =>
        (item.saldo_anterior !== null && Math.abs(item.saldo_anterior) > 0.01) || 
        (item.saldo_actual !== null && Math.abs(item.saldo_actual) > 0.01) 
							);
							if (tieneDatos) return true;
						}
						// SEGUNDO: Si no hay datos en memoria, consultar al servidor
      console.log(`Consultando datos TNC para nota ${numero}, párrafo ${parrafo}`); 
						try {
       const result = await Balance.getTNC( 
								this.codReporte,
								this.idCompania,
								this.vigencia,
								numero,
								parrafo
							);
							this.saldosNiifTNC = result.data.saldosNiifTNC || [];
							// Verificar si hay datos válidos
							const tieneDatos = this.saldosNiifTNC.some(item =>
        (item.saldo_anterior !== null && Math.abs(item.saldo_anterior) > 0.01) || 
        (item.saldo_actual !== null && Math.abs(item.saldo_actual) > 0.01) 
							);
							console.log(`Resultado consulta TNC: ${this.saldosNiifTNC.length} registros, tiene datos: ${tieneDatos}`);
							return tieneDatos;
						} catch (error) {
       console.error(`Error consultando TNC:`, error); 
							return false;
						}
					default:
						return false;
				}
			} catch (error) {
    console.error(`Error verificando datos tabla ${tipo}:`, error); 
				return false;
			}
		},
		convertirHtmlADocx(html) {
			try {
    if (!html || html.trim() === '' || html.trim() === '<p></p>') { 
					return [new Paragraph({ children: [new TextRun("")] })];
				}
				const decodeHtmlEntities = (text) => {
     const txt = document.createElement("textarea"); 
     txt.innerHTML = text; 
     return txt?.value; 				};
				html = decodeHtmlEntities(html);
				const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html'); 
				const paragraphs = [];
				const extraerTextoConEstilos = (node, estiloAcumulado = {}) => {
					const runs = [];
     if (node.nodeType === Node.TEXT_NODE) { 
      let text = node.textContent.replace(/\u00A0/g, ' '); 
						if (text !== '') {
       runs.push(new TextRun({ 
								text,
        size: estiloAcumulado.size || 28, 
        ...estiloAcumulado 
							}));
						}
					}
     if (node.nodeType === Node.ELEMENT_NODE) { 
      const estilo = { ...estiloAcumulado }; 
      const tag = node.tagName.toUpperCase(); 
      if (['B', 'STRONG'].includes(tag)) estilo.bold = true; 
      if (['I', 'EM'].includes(tag)) estilo.italic = true; 
      if (tag === 'U') estilo.underline = {}; 
      if (['S', 'STRIKE'].includes(tag)) estilo.strike = true; 
      if (tag.match(/^H[1-6]$/)) { 
       estilo.bold = true; 
       estilo.size = 32; 
						}
      const styleAttr = node.getAttribute('style'); 
						if (styleAttr) {
       styleAttr.split(';').forEach(s => { 
        const [k, v] = s.split(':').map(x => x && x.trim()); 
								if (!k || !v) return;
								if (k === 'font-size') {
									const n = parseFloat(v);
         if (!isNaN(n)) estilo.size = Math.round(n * 2); 
								}
        if (k === 'font-weight' && v === 'bold') estilo.bold = true; 
								if (k === 'color') estilo.color = this.convertirColorWord(v);
							});
						}
      node.childNodes.forEach(child => { 
       runs.push(...extraerTextoConEstilos(child, estilo)); 
						});
					}
					return runs;
				};
				const procesarNodo = (node) => {
     if (node?.nodeType !== Node?.ELEMENT_NODE) return;      const tag = node.tagName.toUpperCase(); 
					// SALTO DE LÍNEA
					if (tag === 'BR') {
      paragraphs.push(new Paragraph({})); 
						return;
					}
					// LISTAS CON VIÑETAS
					if (tag === 'UL') {
      Array.from(node.children).forEach(li => { 
       if (li.tagName === 'LI') { 
								const runs = extraerTextoConEstilos(li);
        paragraphs.push(new Paragraph({ 
									children: runs,
									bullet: { level: 0 },
									style: "ListParagraph"
								}));
							}
						});
						return;
					}
					// PÁRRAFOS, TÍTULOS, DIV
     if (['P', 'DIV', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6'].includes(tag)) { 
						const runs = extraerTextoConEstilos(node);
      paragraphs.push(new Paragraph({ children: runs })); 
						return;
					}
					// RECURSIVO
     node.childNodes.forEach(procesarNodo); 
				};
    Array.from(doc.body.childNodes).forEach(procesarNodo); 
    if (paragraphs.length === 0) { 
     paragraphs.push(new Paragraph({ 
      children: [new TextRun(doc.body.textContent || '')] 
					}));
				}
				return paragraphs;
			} catch (error) {
    console.error(error); 
				return [
					new Paragraph({
      children: [new TextRun(html.replace(/<[^>]+>/g, ' '))] 
					})
				];
			}
		}
		,
		// Método auxiliar para convertir colores
		convertirColorWord(colorHtml) {
			// Colores básicos
			const coloresBasicos = {
				'black': '000000',
				'white': 'FFFFFF',
				'red': 'FF0000',
				'green': '00FF00',
				'blue': '0000FF',
				'yellow': 'FFFF00',
				'cyan': '00FFFF',
				'magenta': 'FF00FF',
				'gray': '808080',
				'grey': '808080'
			};
   let colorHex = colorHtml.toLowerCase().trim(); 
			// Si es un nombre de color básico
			if (coloresBasicos[colorHex]) {
				return coloresBasicos[colorHex];
			}
			// Si ya es hexadecimal
   if (colorHex.startsWith('#')) { 
    colorHex = colorHex.substring(1); 
				// Expandir formato corto (#FFF -> #FFFFFF)
    if (colorHex.length === 3) { 
     colorHex = colorHex.split('').map(c => c + c).join(''); 
				}
    return colorHex?.toUpperCase(); 			}
			// Si es rgb() o rgba()
   const rgbMatch = colorHtml.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/i); 
			if (rgbMatch) {
    const r = parseInt(rgbMatch[1]).toString(16).padStart(2, '0'); 
    const g = parseInt(rgbMatch[2]).toString(16).padStart(2, '0'); 
    const b = parseInt(rgbMatch[3]).toString(16).padStart(2, '0'); 
    return (r + g + b)?.toUpperCase(); 			}
			// Por defecto, negro
			return '000000';
		},
		// Método auxiliar para procesar nodos HTML
		procesarNodoHtml(node, textRuns) {
   console.log('Procesando nodo:', node.nodeType === Node.TEXT_NODE ? 'TEXTO' : node.tagName); 
   if (node.nodeType === Node.TEXT_NODE) { 
				// Texto plano
    const text = node.textContent.trim(); 
				if (text) {
     console.log('Texto encontrado:', text.substring(0, 50) + '...'); 
     textRuns.push(new TextRun({ text })); 
				}
   } else if (node.nodeType === Node.ELEMENT_NODE) { 
				// Elementos HTML
    const children = Array.from(node.childNodes); 
    console.log(`Nodo ${node.tagName} tiene ${children.length} hijos`); 
				// Procesar cada hijo
    children.forEach((child, index) => { 
     console.log(` Hijo ${index}:`, child.nodeType === Node.TEXT_NODE ? 'TEXTO' : child.tagName); 
     if (child.nodeType === Node.TEXT_NODE) { 
      const text = child.textContent.trim(); 
						if (text) {
       console.log(` Texto del hijo ${index}:`, text.substring(0, 50) + '...'); 
       textRuns.push(new TextRun({ 
								text,
        bold: node.tagName === 'STRONG' || node.tagName === 'B', 
        italic: node.tagName === 'EM' || node.tagName === 'I', 
        underline: node.tagName === 'U' 
							}));
						}
     } else if (child.nodeType === Node.ELEMENT_NODE) { 
						// Llamada recursiva para elementos anidados
						this.procesarNodoHtml(child, textRuns);
					}
				});
			}
		},
		async crea_word_todas() {
			try {
				this.generatingWordProgress = 95;
				this.generatingWordMessage = 'Finalizando documento...';
				this.a_Paragraph = [];
				this.agregarTexto("NOTAS A LOS ESTADOS FINANCIEROS", true);
				this.agregarSalto();
				// Ordenar notas por número
				const notasOrdenadas = [...this.notasEF].sort((a, b) => a.numero - b.numero);
				for (const nota of notasOrdenadas) {
					this.agregarTexto(
      `${nota.numero}-\t${nota.descripcion}`, 
						true
					);
					this.agregarSalto();
					// Filtrar detalles por número de nota y ordenar por párrafo
					const detallesNota = this.a_detalle
      .filter(d => d.numero === nota.numero) 
      .sort((a, b) => { 
							// Primero por párrafo
       if (a.parrafo !== b.parrafo) { 
        return a?.parrafo - b?.parrafo; 							}
							// Si mismo párrafo, por orden
       return (a?.orden || 1) - (b?.orden || 1); 						});
					for (const detalle of detallesNota) {
						let texto = null;
						let texto_html = null;
      // 1. TITULO (si existe) 
      if (detalle.titulo && detalle.titulo.trim() !== '') { 
							this.agregarTexto(detalle.titulo.trim(), true);
							this.agregarSalto();
						}
      // 2. CONTENIDO según tipo 
      if (detalle.tipo === "TFG") { 
							const txfg = this.a_informacion_txfg.find(t =>
        t.parrafo === detalle.parrafo && 
        t.numero === detalle.numero 
							);
							if (txfg) {
        texto = txfg.texto; 
        texto_html = txfg.texto_html; 
							}
						}
      else if (detalle.tipo === "TFC") { 
							const txfc = this.a_informacion_txfc.find(t =>
        t.parrafo === detalle.parrafo && 
        t.numero === detalle.numero 
							);
							if (txfc) {
        texto = txfc.texto; 
        texto_html = txfc.texto_html; 
							}
						}
      else if (detalle.tipo === "TVG") { 
							const txvg = this.a_informacion_txvg.find(t =>
        t.parrafo === detalle.parrafo && 
        t.numero === detalle.numero 
							);
							if (txvg) {
								// Usar valor_campo0 si existe y no está vacío
        if (txvg.valor_campo0 && txvg.valor_campo0.trim() !== '') { 
         texto = txvg.valor_campo0; 
         texto_html = txvg.valor_campo0; 
								} else {
									// Solo si valor_campo0 está vacío, usar texto base con reemplazos
									const textoBase = this.a_detalle_texto.find(t =>
          t.parrafo === detalle.parrafo && 
          t.numero === detalle.numero 
									);
									if (textoBase) {
          texto = textoBase.texto; 
          texto_html = textoBase.texto_html || textoBase.texto || ""; 
										// Aplicar reemplazos
										for (let i = 0; i <= 9; i++) {
											if (txvg[`valor_campo${i}`]) {
            texto = texto.replace( 
													`%valor_campo${i}%`,
													txvg[`valor_campo${i}`]
												);
												if (texto_html) {
             texto_html = texto_html.replace( 
														`%valor_campo${i}%`,
														txvg[`valor_campo${i}`]
													);
												}
											}
										}
									}
								}
							} else {
								// Si no existe txvg, usar solo texto base
								const textoBase = this.a_detalle_texto.find(t =>
         t.parrafo === detalle.parrafo && 
         t.numero === detalle.numero 
								);
								if (textoBase) {
         texto = textoBase.texto; 
         texto_html = textoBase.texto_html || textoBase.texto || ""; 
								}
							}
						}
      else if (detalle.tipo === "TVC") { 
							const txvc = this.a_informacion_txvc.find(t =>
        t.parrafo === detalle.parrafo && 
        t.numero === detalle.numero 
							);
							if (txvc) {
								// Usar valor_campo0 directamente si existe y no está vacío
        if (txvc.valor_campo0 && txvc.valor_campo0.trim() !== '') { 
         texto = txvc.valor_campo0; 
         texto_html = txvc.valor_campo0; 
								} else {
									// Solo si valor_campo0 está vacío, usar plantilla con reemplazos
									const textoBase = this.a_detalle_texto.find(t =>
          t.parrafo === detalle.parrafo && 
          t.numero === detalle.numero 
									);
									if (textoBase) {
          texto = textoBase.texto; 
          texto_html = textoBase.texto_html || textoBase.texto || ""; 
										// Aplicar reemplazos a la plantilla
										for (let i = 0; i <= 9; i++) {
											if (txvc[`valor_campo${i}`]) {
            texto = texto.replace( 
													`%valor_campo${i}%`,
													txvc[`valor_campo${i}`]
												);
												if (texto_html) {
             texto_html = texto_html.replace( 
														`%valor_campo${i}%`,
														txvc[`valor_campo${i}`]
													);
												}
											}
										}
									}
								}
							} else {
								// Si no existe txvc, usar solo texto base
								const textoBase = this.a_detalle_texto.find(t =>
         t.parrafo === detalle.parrafo && 
         t.numero === detalle.numero 
								);
								if (textoBase) {
         texto = textoBase.texto; 
         texto_html = textoBase.texto_html || textoBase.texto || ""; 
								}
							}
						}
						else {
							// Para otros tipos, buscar texto base
							const textoBase = this.a_detalle_texto.find(t =>
        t.parrafo === detalle.parrafo && 
        t.numero === detalle.numero 
							);
							if (textoBase) {
        texto = textoBase.texto; 
        texto_html = textoBase.texto_html || ""; 
							}
						}
      // 3. AGREGAR TEXTO AL DOCUMENTO 
      if (texto_html && texto_html.trim() !== '') { 
							// Usar HTML si existe y no está vacío
							this.agregarTexto(texto_html, false, true);
							this.agregarSalto();
      } else if (texto && texto.trim() !== '') { 
							// Usar texto plano si no hay HTML
							this.agregarTexto(texto);
							this.agregarSalto();
						}
      // 4. PROCESAR TABLAS 
      switch (detalle.tipo) { 
							case "TBA": {
								const tieneDatosTBA = await this.verificarDatosTabla("TBA", detalle.numero, detalle.parrafo);
								if (tieneDatosTBA) await this.procesarTBA(detalle);
								break;
							}
							case "TBT": {
								const tieneDatosTBT = await this.verificarDatosTabla("TBT", detalle.numero, detalle.parrafo);
								if (tieneDatosTBT) await this.procesarTBT(detalle);
								break;
							}
							case "TBC": {
								const tieneDatosTBC = await this.verificarDatosTabla("TBC", detalle.numero, detalle.parrafo);
								if (tieneDatosTBC) await this.procesarTBC(detalle);
								break;
							}
							case "TBM": {
								const tieneDatosTBM = this.tieneDatosTablaTBM(detalle.numero, detalle.parrafo);
								if (tieneDatosTBM) await this.procesarTBM(detalle);
								break;
							}
							case "TNA": {
								const tieneDatosTNA = await this.verificarDatosTabla("TNA", detalle.numero, detalle.parrafo);
								if (tieneDatosTNA) await this.procesarTNA(detalle);
								break;
							}
							case "TNT": {
								const tieneDatosTNT = await this.verificarDatosTabla("TNT", detalle.numero, detalle.parrafo);
								if (tieneDatosTNT) await this.procesarTNT(detalle);
								break;
							}
							case "TNC": {
								const tieneDatosTNC = await this.verificarDatosTabla("TNC", detalle.numero, detalle.parrafo);
								if (tieneDatosTNC) await this.procesarTNC(detalle);
								break;
							}
						}
					}
					// Espacio entre notas
					this.agregarSalto();
					this.agregarSalto();
				}
				this.generatingWordProgress = 100;
				this.generatingWordMessage = '¡Completado!';
				setTimeout(() => {
					this.showGeneratingWordModal = false;
					this.generarWord();
				}, 500);
			} catch (error) {
    console.error('Error en crea_word_todas:', error); 
				this.showGeneratingWordModal = false;
				this.$toast.error('Error al crear el documento');
			}
		},
		// Método para asegurar que el Word guarde con codificación correcta
		generarWord() {
			try {
				const doc = new Document({
					sections: [{
						properties: {
							// IMPORTANTE: Especificar codificación UTF-8
						},
						children: this.a_Paragraph
					}]
				});
    Packer.toBuffer(doc).then(buffer => { 
					// Crear Blob con tipo MIME correcto
					const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=UTF-8' 
					});
					// Crear URL y descargar
     const url = window.URL.createObjectURL(blob); 
     const link = document.createElement('a'); 
     link.href = url; 
					// Nombre del archivo con fecha
     const fecha = new Date().toISOString().split('T')[0]; 
     link.download = `Notas_Financieras_${fecha}.docx`; 
     document.body.appendChild(link); 
     link.click(); 
     document.body.removeChild(link); 
					// Liberar memoria
     window.URL.revokeObjectURL(url); 
					this.$toast.success('Documento Word generado exitosamente');
				});
			} catch (error) {
    console.error('Error generando Word:', error); 
				this.$toast.error('Error al generar el documento');
			}
		},
		obtenerTextoDetalle(detalle) {
			let origen = null
			if (detalle.tipo === "TFG") origen = this.a_informacion_txfg
			if (detalle.tipo === "TFC") origen = this.a_informacion_txfc
			if (detalle.tipo === "TVG") origen = this.a_informacion_txvg
			if (detalle.tipo === "TVC") origen = this.a_informacion_txvc
   const tx = origen.find(t => t.parrafo === detalle.parrafo) 
			const base = this.a_detalle_texto.find(t => t.parrafo === detalle.parrafo)
			if (!tx || !base) return null
   let texto = base.texto 
			for (let i = 0; i <= 9; i++) {
				if (tx[`valor_campo${i}`]) {
     texto = texto.replace( 
						`%valor_campo${i}%`,
						tx[`valor_campo${i}`]
					)
				}
			}
			return texto
		},
		async procesarTBA(r) {
   const result = await Balance.getTBA( 
				this.codReporte, this.idCompania, this.vigencia, r.numero, r.parrafo
			)
			this.saldosTBA = result.data.saldosTBA
			this.a_Paragraph.push(new Table({
				columnWidths: [1, 3],
				rows: this.f_crea_arreglo("TBA"),
			}))
			this.agregarSalto()
		},
		async procesarTBT(r) {
   const result = await Balance.getTBT( 
				this.codReporte, this.idCompania, this.vigencia, r.numero, r.parrafo
			)
			this.saldosTBT = result.data.saldosTBT
			this.a_Paragraph.push(new Table({
				columnWidths: [1, 3],
				rows: this.f_crea_arreglo("TBT"),
			}))
			this.agregarSalto()
		},
		async procesarTBC(r) {
   const result = await Balance.getTBC( 
				this.codReporte, this.idCompania, this.vigencia, r.numero, r.parrafo
			)
			this.saldosTBC = result.data.saldosTBC
			this.a_Paragraph.push(new Table({
				columnWidths: [1, 3],
				rows: this.f_crea_arreglo_tbc(),
			}))
			this.agregarSalto()
		},
		async procesarTBM(info) {
   const numero = info.numero; 
   const parrafo = info.parrafo; 
			// Verificar si hay datos antes de procesar
			const tieneDatos = this.tieneDatosTablaTBM(numero, parrafo);
			if (!tieneDatos) {
    console.log(`Tabla TBM ${numero}-${parrafo} sin datos, omitiendo...`); 
				return;
			}
			// Solo procesar si hay datos
			this.a_Paragraph.push(new Table({
				columnWidths: [5200, 4300],
				rows: this.f_crea_arreglo_tbm(numero, parrafo),
			}))
			this.agregarSalto()
		},
		async procesarTNA(r) {
   const result = await Balance.getTNA( 
				this.codReporte, this.idCompania, this.vigencia, r.numero, r.parrafo
			)
			this.saldosNiifTNA = result.data.saldosNiifTNA
			this.a_Paragraph.push(new Table({
				columnWidths: [5200, 4300],
				rows: this.f_crea_arreglo_niif("TNA"),
			}))
			this.agregarSalto()
		},
		async procesarTNT(r) {
   const result = await Balance.getTNT( 
				this.codReporte, this.idCompania, this.vigencia, r.numero, r.parrafo
			)
			this.saldosNiifTNT = result.data.saldosNiifTNT
			this.a_Paragraph.push(new Table({
				columnWidths: [5200, 4300],
				rows: this.f_crea_arreglo_niif("TNT"),
			}))
			this.agregarSalto()
		},
		async procesarTNC(r) {
   const result = await Balance.getTNC( 
				this.codReporte, this.idCompania, this.vigencia, r.numero, r.parrafo
			)
			this.saldosNiifTNC = result.data.saldosNiifTNC
			this.a_Paragraph.push(new Table({
				columnWidths: [5200, 4300, 4300, 4300],
				rows: this.f_crea_arreglo_niifc(),
			}))
			this.agregarSalto()
		},
		async obtenerReporteNota() {
			try {
				const response = await Balance.getReporteNota(this.codReporte);
				return response.data.reporte_nota || this.codReporte;
			} catch (error) {
    console.error('Error obteniendo reporte_nota:', error); 
				return this.codReporte;
			}
		},
		agregarTexto(texto, esTitulo = false, esHtml = false) {
   if (!texto || texto.toString()?.trim() === '') return; 			try {
				if (esHtml) {
					const paragraphs = this.convertirHtmlADocx(texto.toString());
     if (paragraphs && paragraphs.length > 0) { 
						this.a_Paragraph.push(...paragraphs);
					} else {
						// Fallback: texto plano
						const paragraph = new Paragraph({
							children: [new TextRun({
        text: texto.toString(), 
								bold: esTitulo,
        size: esTitulo ? 28 : 24 
							})]
						});
						this.a_Paragraph.push(paragraph);
					}
				} else {
					// Texto plano normal
					const paragraph = new Paragraph({
						children: [new TextRun({
       text: texto.toString(), 
							bold: esTitulo,
       size: esTitulo ? 28 : 24 
						})]
					});
					this.a_Paragraph.push(paragraph);
				}
			} catch (error) {
    console.error('Error en agregarTexto:', error); 
				// Fallback a texto simple
				const paragraph = new Paragraph({
					children: [new TextRun({
      text: texto.toString().substring(0, 200), 
						bold: esTitulo
					})]
				});
				this.a_Paragraph.push(paragraph);
			}
		},
		agregarSalto() {
			this.a_Paragraph.push(new Paragraph({ children: [new TextRun("")] }))
		},
		f_crea_arreglo(opcion) {
			let a_tableRow = []
			let v_tableRow = ""
			let a_tableCell = []
			let v_tableCell = ""
			let a_children = []
			a_children = [
				new Paragraph({
					text: "Cuenta",
				}),
			]
			v_tableCell = new TableCell({
				children: a_children,
			})
   a_tableCell.push(v_tableCell) 
			a_children = [
				new Paragraph({
					text: "Descripcion",
				}),
			]
			v_tableCell = new TableCell({
				children: a_children,
			})
   a_tableCell.push(v_tableCell) 
			if (opcion == "TBA") {
				a_children = [
					new Paragraph({
						text: "Saldo A " + this.vigencia,
					}),
				]
			}
			if (opcion == "TBT") {
				let yy = parseInt(this.vigencia.substring(0, 4)) - 1
				let fecha_vigencia = String(yy) + "12"
				a_children = [
					new Paragraph({
						text: "Saldo A " + fecha_vigencia,
					}),
				]
			}
			v_tableCell = new TableCell({
				children: a_children,
			})
   a_tableCell.push(v_tableCell) 
			v_tableRow = new TableRow({ children: a_tableCell })
   a_tableRow.push(v_tableRow) 
			a_tableCell = []
			if (opcion == "TBA") {
				this.saldosTBA.forEach((cuenta) => {
					a_children = [
						new Paragraph({
       text: cuenta.cuenta, 
						}),
					]
					v_tableCell = new TableCell({
						children: a_children,
					})
     a_tableCell.push(v_tableCell) 
					a_children = [
						new Paragraph({
       text: cuenta.descripcion, 
						}),
					]
					v_tableCell = new TableCell({
						children: a_children,
					})
     a_tableCell.push(v_tableCell) 
					a_children = [
						new Paragraph({
							text: this.formato(cuenta.saldo_actual),
       alignment: AlignmentType.RIGTH, 
						}),
					]
					v_tableCell = new TableCell({
						children: a_children,
					})
     a_tableCell.push(v_tableCell) 
					v_tableRow = new TableRow({ children: a_tableCell })
     a_tableRow.push(v_tableRow) 
					a_tableCell = []
				})
				return a_tableRow
			}
			if (opcion == "TBT") {
				this.saldosTBT.forEach((cuenta) => {
					a_children = [
						new Paragraph({
       text: cuenta.cuenta, 
						}),
					]
					v_tableCell = new TableCell({
						children: a_children,
					})
     a_tableCell.push(v_tableCell) 
					a_children = [
						new Paragraph({
       text: cuenta.descripcion, 
						}),
					]
					v_tableCell = new TableCell({
						children: a_children,
					})
     a_tableCell.push(v_tableCell) 
					a_children = [
						new Paragraph({
							text: this.formato(cuenta.saldo_actual),
       alignment: AlignmentType.RIGTH, 
						}),
					]
					v_tableCell = new TableCell({
						children: a_children,
					})
     a_tableCell.push(v_tableCell) 
					v_tableRow = new TableRow({ children: a_tableCell })
     a_tableRow.push(v_tableRow) 
					a_tableCell = []
				})
				return a_tableRow
			}
		},
		f_crea_arreglo_niif(opcion) {
			let a_tableRow = []
			let v_tableRow = ""
			let a_tableCell = []
			let v_tableCell = ""
			let a_children = []
			// Variable para acumular total
			let total = 0
			let saldosFiltrados = []
			// FILTRAR DATOS SEGÚN LA OPCIÓN
			if (opcion === "TNA") {
				saldosFiltrados = this.saldosNiifTNA.filter(niif => {
     const saldo = parseFloat(niif.saldo_actual) || 0 
					return Math.abs(saldo) >= 0.01
				})
			} else if (opcion === "TNT") {
				saldosFiltrados = this.saldosNiifTNT.filter(niif => {
     const saldo = parseFloat(niif.saldo_actual) || 0 
					return Math.abs(saldo) >= 0.01
				})
			}
			a_children = [
				new Paragraph({
					text: "Concepto",
				}),
			]
			v_tableCell = new TableCell({
				children: a_children,
			})
   a_tableCell.push(v_tableCell) 
			if (opcion === "TNA") {
				a_children = [
					new Paragraph({
						text: "Saldo A " + this.vigencia,
					}),
				]
			} else if (opcion === "TNT") {
				let yy = parseInt(this.vigencia.substring(0, 4)) - 1
				let fecha_vigencia = String(yy) + "12"
				a_children = [
					new Paragraph({
						text: "Saldo A " + fecha_vigencia,
					}),
				]
			}
			v_tableCell = new TableCell({
				children: a_children,
			})
   a_tableCell.push(v_tableCell) 
			v_tableRow = new TableRow({ children: a_tableCell })
   a_tableRow.push(v_tableRow) 
			a_tableCell = []
   saldosFiltrados.forEach((niif) => { 
    const saldo = parseFloat(niif.saldo_actual) || 0 
				total += saldo
				a_children = [
					new Paragraph({
      text: niif.descripcion, 
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
    a_tableCell.push(v_tableCell) 
				a_children = [
					new Paragraph({
						text: this.formato(niif.saldo_actual),
      alignment: AlignmentType.RIGHT, 
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
    a_tableCell.push(v_tableCell) 
				v_tableRow = new TableRow({ children: a_tableCell })
    a_tableRow.push(v_tableRow) 
				a_tableCell = []
			})
   if (saldosFiltrados.length > 0) { 
				a_children = [
					new Paragraph({
						text: "Total",
						bold: true,
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
    a_tableCell.push(v_tableCell) 
				a_children = [
					new Paragraph({
						text: this.formato(total),
      alignment: AlignmentType.RIGHT, 
						bold: true,
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
    a_tableCell.push(v_tableCell) 
				v_tableRow = new TableRow({ children: a_tableCell })
    a_tableRow.push(v_tableRow) 
			}
			return a_tableRow
		},
		f_crea_arreglo_tbc() {
			let a_tableRow = []
			let v_tableRow = ""
			let a_tableCell = []
			let v_tableCell = ""
			let a_children = []
			a_children = [
				new Paragraph({
					text: "Cuenta",
				}),
			]
			v_tableCell = new TableCell({
				children: a_children,
			})
   a_tableCell.push(v_tableCell) 
			a_children = [
				new Paragraph({
					text: "Descripcion",
				}),
			]
			v_tableCell = new TableCell({
				children: a_children,
			})
   a_tableCell.push(v_tableCell) 
			let yy = parseInt(this.vigencia.substring(0, 4)) - 1
			let fecha_vigencia = String(yy) + "12"
			a_children = [
				new Paragraph({
					text: "Saldo A " + fecha_vigencia,
				}),
			]
			v_tableCell = new TableCell({
				children: a_children,
			})
   a_tableCell.push(v_tableCell) 
			a_children = [
				new Paragraph({
					text: "Saldo A " + this.vigencia,
				}),
			]
			v_tableCell = new TableCell({
				children: a_children,
			})
   a_tableCell.push(v_tableCell) 
			a_children = [
				new Paragraph({
					text: "Diferencia",
				}),
			]
			v_tableCell = new TableCell({
				children: a_children,
			})
   a_tableCell.push(v_tableCell) 
			v_tableRow = new TableRow({ children: a_tableCell })
   a_tableRow.push(v_tableRow) 
			a_tableCell = []
			this.saldosTBC.forEach((cuenta) => {
				a_children = [
					new Paragraph({
      text: cuenta.cuenta, 
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
    a_tableCell.push(v_tableCell) 
				a_children = [
					new Paragraph({
      text: cuenta.descripcion, 
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
    a_tableCell.push(v_tableCell) 
				a_children = [
					new Paragraph({
						text: this.formato(cuenta.saldo_anterior),
      alignment: AlignmentType.RIGTH, 
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
    a_tableCell.push(v_tableCell) 
				a_children = [
					new Paragraph({
						text: this.formato(cuenta.saldo_actual),
      alignment: AlignmentType.RIGTH, 
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
    a_tableCell.push(v_tableCell) 
				a_children = [
					new Paragraph({
						text: this.formato(cuenta.diferencia),
      alignment: AlignmentType.RIGTH, 
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
    a_tableCell.push(v_tableCell) 
				v_tableRow = new TableRow({ children: a_tableCell })
    a_tableRow.push(v_tableRow) 
				a_tableCell = []
			})
			return a_tableRow
		},
		f_crea_arreglo_niifc() {
			let a_tableRow = []
			let v_tableRow = ""
			let a_tableCell = []
			let v_tableCell = ""
			let a_children = []
			// Variables para acumular totales
			let totalAnterior = 0
			let totalActual = 0
			let totalDiferencia = 0
			// ENCABEZADOS
			a_children = [
				new Paragraph({
					text: "Concepto",
				}),
			]
			v_tableCell = new TableCell({
				children: a_children,
			})
   a_tableCell.push(v_tableCell) 
			let yy = parseInt(this.vigencia.substring(0, 4)) - 1
			let fecha_vigencia = String(yy) + "12"
			a_children = [
				new Paragraph({
					text: "Saldo A " + fecha_vigencia,
				}),
			]
			v_tableCell = new TableCell({
				children: a_children,
			})
   a_tableCell.push(v_tableCell) 
			a_children = [
				new Paragraph({
					text: "Saldo A " + this.vigencia,
				}),
			]
			v_tableCell = new TableCell({
				children: a_children,
			})
   a_tableCell.push(v_tableCell) 
			a_children = [
				new Paragraph({
					text: "Diferencia",
				}),
			]
			v_tableCell = new TableCell({
				children: a_children,
			})
   a_tableCell.push(v_tableCell) 
			v_tableRow = new TableRow({ children: a_tableCell })
   a_tableRow.push(v_tableRow) 
			a_tableCell = []
			// DATOS - FILTRANDO Y ACUMULANDO
			this.saldosNiifTNC.forEach((niif) => {
				// Verificar si la diferencia es 0 (o muy cercana a 0)
    const diferencia = parseFloat(niif.diferencia) || 0 
    if (Math.abs(diferencia) < 0.01) { 
					return // Saltar esta fila
				}
				// Acumular totales
    const anterior = parseFloat(niif.saldo_anterior) || 0 
    const actual = parseFloat(niif.saldo_actual) || 0 
				totalAnterior += anterior
				totalActual += actual
				totalDiferencia += diferencia
				// Crear fila
				a_children = [
					new Paragraph({
      text: niif.descripcion, 
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
    a_tableCell.push(v_tableCell) 
				a_children = [
					new Paragraph({
						text: this.formato(niif.saldo_anterior),
      alignment: AlignmentType.RIGHT, 
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
    a_tableCell.push(v_tableCell) 
				a_children = [
					new Paragraph({
						text: this.formato(niif.saldo_actual),
      alignment: AlignmentType.RIGHT, 
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
    a_tableCell.push(v_tableCell) 
				a_children = [
					new Paragraph({
						text: this.formato(niif.diferencia),
      alignment: AlignmentType.RIGHT, 
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
    a_tableCell.push(v_tableCell) 
				v_tableRow = new TableRow({ children: a_tableCell })
    a_tableRow.push(v_tableRow) 
				a_tableCell = []
			})
			// FILA DE TOTAL SOLO SI HAY DATOS
			if (this.saldosNiifTNC.length > 0) {
				a_children = [
					new Paragraph({
						text: "Total",
						bold: true,
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
    a_tableCell.push(v_tableCell) 
				a_children = [
					new Paragraph({
						text: this.formato(totalAnterior),
      alignment: AlignmentType.RIGHT, 
						bold: true,
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
    a_tableCell.push(v_tableCell) 
				a_children = [
					new Paragraph({
						text: this.formato(totalActual),
      alignment: AlignmentType.RIGHT, 
						bold: true,
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
    a_tableCell.push(v_tableCell) 
				a_children = [
					new Paragraph({
						text: this.formato(totalDiferencia),
      alignment: AlignmentType.RIGHT, 
						bold: true,
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
    a_tableCell.push(v_tableCell) 
				v_tableRow = new TableRow({ children: a_tableCell })
    a_tableRow.push(v_tableRow) 
			}
			return a_tableRow
		},
		f_crea_arreglo_tbm(numero, parrafo) {
			// Primero: Filtrar columnas por el numero y parrafo específicos
			const columnasFiltradas = this.a_detalle_columnas.filter(columna =>
    columna.numero === numero && columna.parrafo === parrafo 
   ).sort((a, b) => a.columna - b.columna); // Ordenar por columna 
			// Segundo: Filtrar filas por el numero y parrafo específicos
			const filasFiltradas = this.a_detalle_filas.filter(fila =>
    fila.numero === numero && fila.parrafo === parrafo 
   ).sort((a, b) => a.fila - b.fila); // Ordenar por fila 
			let a_tableRow = []
			let v_tableRow = ""
			let a_tableCell = []
			let v_tableCell = ""
			let a_children = []
			// ENCABEZADO: Primera celda vacía para la esquina
			a_children = [
				new Paragraph({
					text: "Descripcion",
				}),
			]
			v_tableCell = new TableCell({
				children: a_children,
			})
   a_tableCell.push(v_tableCell) 
			// AGREGAR NOMBRES DE COLUMNAS FILTRADAS
   columnasFiltradas.forEach((columna) => { 
				a_children = [
					new Paragraph({
      text: columna.descripcion, 
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
    a_tableCell.push(v_tableCell) 
			})
			v_tableRow = new TableRow({ children: a_tableCell })
   a_tableRow.push(v_tableRow) 
			a_tableCell = []
			// DATOS DE FILAS FILTRADAS
   filasFiltradas.forEach((fila) => { 
				a_children = [
					new Paragraph({
      text: fila.descripcion, 
					}),
				]
				v_tableCell = new TableCell({
					children: a_children,
				})
    a_tableCell.push(v_tableCell) 
				// PARA CADA COLUMNA, BUSCAR EL VALOR CORRESPONDIENTE
    columnasFiltradas.forEach((columna) => { 
					// FILTRAR TBLM por numero, parrafo, columna y fila específicos
					const c_valor = this.a_informacion_tblm.find((r_valor) =>
      r_valor.numero === numero && 
      r_valor.parrafo === parrafo && 
      r_valor.columna == columna.columna && 
      r_valor.fila == fila.fila 
					)
					let v_valor = 0
					if (c_valor) {
      v_valor = c_valor.valor 
					}
					a_children = [
						new Paragraph({
							text: this.formato(v_valor),
       alignment: AlignmentType.RIGHT, // CORREGIDO: "RIGTH" → "RIGHT" 
						}),
					]
					v_tableCell = new TableCell({
						children: a_children,
					})
     a_tableCell.push(v_tableCell) 
				})
				v_tableRow = new TableRow({ children: a_tableCell })
    a_tableRow.push(v_tableRow) 
				a_tableCell = []
			})
			return a_tableRow
		},
		async saveFile(buffer) {
			try {
				// Convertir buffer a Blob con codificación correcta
				const blob = new Blob([buffer], {
     type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' 
				});
				// Crear URL
    const url = window.URL.createObjectURL(blob); 
    const link = document.createElement('a'); 
    link.href = url; 
				// Nombre del archivo
    const fecha = new Date().toISOString().split('T')[0]; 
				const nombreArchivo = `Notas_Financieras_${fecha}_${this.selVigencia}.docx`;
    link.download = nombreArchivo; 
				// Descargar
    document.body.appendChild(link); 
    link.click(); 
				// Limpiar
				setTimeout(() => {
     document.body.removeChild(link); 
     window.URL.revokeObjectURL(url); 
				}, 100);
			} catch (error) {
    console.error('Error guardando archivo:', error); 
				this.$toast.error('Error al guardar el archivo');
			}
		},
		f_modifica_nota(r_nota) {
			this.formNotas = r_nota
			this.formCuentas = r_nota
			this.codReporte = this.dialogReportes
			Balance.getNotas(this.codReporte, this.idCompania, this.vigencia, r_nota.numero)
    .then((result) => { 
					this.a_detalle = result.data.a_detalle
					this.a_detalle_columnas = result.data.a_detalle_columnas
					this.a_detalle_cuentas = result.data.a_detalle_cuentas
					this.a_detalle_niif = result.data.a_detalle_niif
					this.a_detalle_filas = result.data.a_detalle_filas
					this.a_detalle_tabla = result.data.a_detalle_tabla
					this.a_detalle_texto = result.data.a_detalle_texto
					this.a_informacion_tblm = result.data.a_informacion_tblm
					this.a_informacion_txfc = result.data.a_informacion_txfc
					this.a_informacion_txfg = result.data.a_informacion_txfg
					this.a_informacion_txvc = result.data.a_informacion_txvc
					this.a_informacion_txvg = result.data.a_informacion_txvg
				})
    .catch(() => { 
					this.error = true
				});
			setTimeout(() => {
				this.Modifica = true
			}, 1000)
		},
		f_cambia_texto_html(html) {
			this.formParrafo.texto_html = html;
			this.formParrafo.texto = this.htmlToPlainText(html);
		},
		htmlToPlainText(html) {
			if (!html) return '';
   const tempDiv = document.createElement('div'); 
   tempDiv.innerHTML = html; 
   let text = tempDiv.textContent || tempDiv.innerText || ''; 
   text = text.replace(/\s+/g, ' ') 
    .replace(/\n\s*\n/g, '\n') 
    .trim(); 
			return text;
		},
		f_actualiza_nota(r_parrafo) {
			this.showDialog = true
			this.Informacion = false
			this.formParrafo = r_parrafo
			// Limpiar datos anteriores de tabla
			this.tbmTableData = {
				columns: [],
				rows: [],
				values: {} // { "fila-columna": valor }
			}
			// Si es TBM, preparar datos de tabla
   if (r_parrafo.tipo === "TBM") { 
    // 1. Filtrar columnas para este número y párrafo 
				this.tbmTableData.columns = this.a_detalle_columnas
     .filter(col => col.numero === r_parrafo.numero && col.parrafo === r_parrafo.parrafo) 
     .sort((a, b) => a.columna - b.columna) 
    // 2. Filtrar filas para este número y párrafo 
				this.tbmTableData.rows = this.a_detalle_filas
     .filter(fila => fila.numero === r_parrafo.numero && fila.parrafo === r_parrafo.parrafo) 
     .sort((a, b) => a.fila - b.fila) 
    // 3. Cargar valores existentes 
				this.tbmTableData.values = {}
				// Primero, inicializar todas las celdas como vacías
				this.tbmTableData.rows.forEach(fila => {
					this.tbmTableData.columns.forEach(col => {
      const key = `${fila.fila}-${col.columna}` 
						this.tbmTableData.values[key] = ''
					})
				})
				// Luego, cargar valores existentes de a_informacion_tblm
				this.a_informacion_tblm.forEach(item => {
     if (item.numero === r_parrafo.numero && item.parrafo === r_parrafo.parrafo) { 
      const key = `${item.fila}-${item.columna}` 
						this.tbmTableData.values[key] = item.valor
					}
				})
				// No cargar el editor de texto para TBM
				return
			}
			let texto_html = '';
			let texto_plano = '';
			// TEXTO FIJO GENERAL
			if (this.formParrafo.tipo == "TFG") {
				const txfg = this.a_informacion_txfg.find((parrafo) =>
     parrafo.parrafo == r_parrafo.parrafo) 
				if (txfg) {
     texto_html = txfg.texto_html || txfg.texto || ''; 
     texto_plano = txfg.texto || ''; 
				}
			}
			// TEXTO FIJO COMPAÑÍA
			if (this.formParrafo.tipo == "TFC") {
				const txfc = this.a_informacion_txfc.find((parrafo) =>
     parrafo.parrafo == r_parrafo.parrafo) 
				if (txfc) {
     texto_html = txfc.texto_html || txfc.texto || ''; 
     texto_plano = txfc.texto || ''; 
				}
			}
			// TEXTO VARIABLE GENERAL
			if (this.formParrafo.tipo == "TVG") {
				const txvg = this.a_informacion_txvg.find((parrafo) =>
     parrafo.parrafo == r_parrafo.parrafo) 
				if (txvg) {
					// Primero intentamos obtener de valor_campo0
     texto_html = txvg.valor_campo0 || ''; 
     texto_plano = txvg.valor_campo0 || ''; 
					// Si está vacío, usamos la plantilla de tbl_notas_detalle_texto
     if (!texto_html || texto_html.trim() === '') { 
						const dt = this.a_detalle_texto.find((variable) =>
       variable.parrafo == r_parrafo.parrafo) 
						if (dt) {
       texto_html = dt.texto_html || dt.texto || ''; 
       texto_plano = dt.texto || ''; 
						}
					}
					// Cargamos los otros campos de valor
					this.formParrafo.valor_campo0 = txvg.valor_campo0
					this.formParrafo.valor_campo1 = txvg.valor_campo1
					this.formParrafo.valor_campo2 = txvg.valor_campo2
					this.formParrafo.valor_campo3 = txvg.valor_campo3
					this.formParrafo.valor_campo4 = txvg.valor_campo4
					this.formParrafo.valor_campo5 = txvg.valor_campo5
					this.formParrafo.valor_campo6 = txvg.valor_campo6
					this.formParrafo.valor_campo7 = txvg.valor_campo7
					this.formParrafo.valor_campo8 = txvg.valor_campo8
					this.formParrafo.valor_campo9 = txvg.valor_campo9
				} else {
					// Si no existe registro en txvg, usamos solo la plantilla
					const dt = this.a_detalle_texto.find((variable) =>
      variable.parrafo == r_parrafo.parrafo) 
					if (dt) {
      texto_html = dt.texto_html || dt.texto || ''; 
      texto_plano = dt.texto || ''; 
					}
				}
				// Buscamos los nombres de campos en detalle_texto
				const dt = this.a_detalle_texto.find((variable) =>
     variable.parrafo == r_parrafo.parrafo) 
				if (dt) {
					this.formParrafo.texto = dt.texto
					this.formParrafo.campo0 = dt.campo0
					this.formParrafo.campo1 = dt.campo1
					this.formParrafo.campo2 = dt.campo2
					this.formParrafo.campo3 = dt.campo3
					this.formParrafo.campo4 = dt.campo4
					this.formParrafo.campo5 = dt.campo5
					this.formParrafo.campo6 = dt.campo6
					this.formParrafo.campo7 = dt.campo7
					this.formParrafo.campo8 = dt.campo8
					this.formParrafo.campo9 = dt.campo9
				}
			}
			if (this.formParrafo.tipo == "TVC") {
				const txvcArray = this.a_informacion_txvc
     .filter((parrafo) => parrafo.parrafo == r_parrafo.parrafo) 
     .sort((a, b) => a.orden - b.orden); 
    if (txvcArray.length > 0) { 
					texto_html = '';
					for (const txvc of txvcArray) {
      texto_html += txvc.valor_campo0 || ''; 
					}
					texto_plano = texto_html;
     if (!texto_html || texto_html.trim() === '') { 
						const dt = this.a_detalle_texto.find((variable) =>
       variable.parrafo == r_parrafo.parrafo && variable.numero == r_parrafo.numero) 
						if (dt) {
       texto_html = dt.texto_html || dt.texto || ''; 
       texto_plano = dt.texto || ''; 
							const primerRegistro = txvcArray[0];
							if (texto_html && primerRegistro) {
								let htmlConValores = texto_html;
								let textoConValores = texto_plano;
								for (let i = 0; i <= 9; i++) {
									const token = `%valor_campo${i}%`;
									const valor = primerRegistro[`valor_campo${i}`] || '';
         if (htmlConValores.includes(token)) { 
          htmlConValores = htmlConValores.replace(new RegExp(token, 'g'), valor); 
									}
         if (textoConValores.includes(token)) { 
          textoConValores = textoConValores.replace(new RegExp(token, 'g'), valor); 
									}
								}
								texto_html = htmlConValores;
								texto_plano = textoConValores;
							}
						}
					}
					const primerRegistro = txvcArray[0];
					this.formParrafo.valor_campo0 = primerRegistro.valor_campo0 || ''
					this.formParrafo.valor_campo1 = primerRegistro.valor_campo1 || ''
					this.formParrafo.valor_campo2 = primerRegistro.valor_campo2 || ''
					this.formParrafo.valor_campo3 = primerRegistro.valor_campo3 || ''
					this.formParrafo.valor_campo4 = primerRegistro.valor_campo4 || ''
					this.formParrafo.valor_campo5 = primerRegistro.valor_campo5 || ''
					this.formParrafo.valor_campo6 = primerRegistro.valor_campo6 || ''
					this.formParrafo.valor_campo7 = primerRegistro.valor_campo7 || ''
					this.formParrafo.valor_campo8 = primerRegistro.valor_campo8 || ''
					this.formParrafo.valor_campo9 = primerRegistro.valor_campo9 || ''
				} else {
					const dt = this.a_detalle_texto.find((variable) =>
      variable.parrafo == r_parrafo.parrafo && variable.numero == r_parrafo.numero) 
					if (dt) {
      texto_html = dt.texto_html || dt.texto || ''; 
      texto_plano = dt.texto || ''; 
					}
				}
				const dt = this.a_detalle_texto.find((variable) =>
     variable.parrafo == r_parrafo.parrafo && variable.numero == r_parrafo.numero) 
				if (dt) {
					this.formParrafo.texto = dt.texto
					this.formParrafo.campo0 = dt.campo0
					this.formParrafo.campo1 = dt.campo1
					this.formParrafo.campo2 = dt.campo2
					this.formParrafo.campo3 = dt.campo3
					this.formParrafo.campo4 = dt.campo4
					this.formParrafo.campo5 = dt.campo5
					this.formParrafo.campo6 = dt.campo6
					this.formParrafo.campo7 = dt.campo7
					this.formParrafo.campo8 = dt.campo8
					this.formParrafo.campo9 = dt.campo9
				}
			}
			this.formParrafo.texto = texto_plano;
			this.formParrafo.texto_html = texto_html || texto_plano;
			this.$nextTick(() => {
				if (this.$refs.textEditor && this.$refs.textEditor.setHTML) {
					this.$refs.textEditor.setHTML(this.formParrafo.texto_html);
				}
			});
		},
		goBack() {
			this.$router.back()
		},
	},
	mounted() {
		this.isLoading = true;
		this.loadButtonControlsFromDb();
  Grupo.getAllGrupos() 
   .then((result) => { 
				this.grupos = result.data.grupos;
				this.gruposFiltrados = result.data.grupos;
				console.log('Grupos cargados:', this.grupos);
				console.log('Grupos filtrados:', this.gruposFiltrados);
			})
   .catch((error) => { 
    console.log("Error cargando grupos:", error); 
			});
  Balance.leaCompaniaUsuario() 
   .then((result) => { 
				this.companiaUsuario = result.data.companiaUsuario
    Balance.getCompanias(true) 
     .then((result) => { 
						this.companias = result.data.companias;
						console.log('Estructura de compañías:', this.companias[0]);
						console.log('¿Tienen id_grupos.', this.companias[0].id_grupos);
						let v_companias = [];
      result.data.companias.forEach((element) => { 
							const v_usuario = this.companiaUsuario.find((r_usuario) =>
								r_usuario.id_usuario == this.$store.state.userId &&
        r_usuario.id_compania == element.id) 
							if (this.$store.state.userRole == 1 || v_usuario) {
        v_companias.push(element) 
							}
						})
						this.companias = v_companias;
						this.companiasFiltradas = v_companias;
						this.dialogCompanias = "";
						this.codigoCompanias = "{";
						let primero = true;
      result.data.companias.forEach(element => { 
							this.dialogCompanias.push(element.id);
							if (!primero) {
								this.codigoCompanias = this.codigoCompanias + ",";
							}
							primero = false;
							this.codigoCompanias = this.codigoCompanias + "\"id" + element.id + "\":" +
        "\"" + element.codigo + "\""; 
						});
						this.codigoCompanias = this.codigoCompanias + "}";
						this.codigoCompanias = JSON.parse(this.codigoCompanias);
					})
     .catch((error) => { 
      console.log(error) 
						this.error = true
					});
			})
		// Cargar fechas
  Balance.getFechas() 
   .then((result) => { 
				this.fechas = ordenefechas(result.data.fechas)
				this.dialogFechas = ""
    result.data.fechas.forEach(element => { 
					this.dialogFechas.push(element.fecha);
				})
			})
   .catch(() => { 
				this.error = true
			});
		// Cargar reportes
  Balance.getReportes() 
   .then((result) => { 
				this.reportes = result.data.reportes
			})
   .catch(() => { 
				this.error = true
			});
		// Cargar currency
  Currency.getAllCurrency() 
   .then((result) => { 
				this.currency = result.data.currency;
			})
   .catch(() => { 
				this.error = true;
			});
		this.isLoading = false;
	},
};
</script>
<style src="../main.css"></style>

<style scoped>
/* ========== ESTILOS DE FILTROS PRINCIPALES ========== */
.niif-header .filters-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    margin-left: 0 !important;
}

.niif-header .filter-select {
    min-width: 200px;
    max-width: 280px;
    width: auto;
    height: 38px;
    font-size: 14px;
    border-radius: 7px;
}

.niif-header .filter-select option {
    white-space: normal;
    word-break: break-word;
    padding: 4px 8px;
}

/* ========== DROPDOWN DE SELECCIÓN ÚNICA ========== */
.filter-dropdown {
    display: inline-block;
}

.filter-dropdown .filter-dropdown-btn {
    height: 38px;
    min-height: 38px;
    padding: 0 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 14px;
    background-color: transparent !important;
    color: #6c757d !important;
    border: 1px solid #6c757d !important;
    cursor: pointer;
    flex-shrink: 0;
}

.filter-dropdown .filter-dropdown-btn:hover:not(:disabled) {
    background-color: #6c757d !important;
    color: white !important;
}

.filter-dropdown .filter-dropdown-btn:focus {
    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5) !important;
}

.filter-dropdown .filter-dropdown-btn::after {
    margin-left: 8px;
}

.filter-dropdown .dropdown-item.active {
    background-color: #1f4f83 !important;
    color: white !important;
}

.filter-dropdown .dropdown-item:hover:not(.active) {
    background-color: #e9ecef !important;
}

/* ========== BOTÓN GENERAR ========== */
.niif-header .consult-btn {
    height: 38px;
    min-height: 38px;
    padding: 0 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 14px;
    background-color: #6c757d !important;
    color: white !important;
    border: 1px solid #6c757d !important;
    cursor: pointer;
    flex-shrink: 0;
}

.niif-header .consult-btn:hover:not(:disabled) {
    background-color: #5a6268 !important;
    border-color: #545b62 !important;
}

.niif-header .consult-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

/* ========== TOOLBAR ========== */
.niif-toolbar-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex: 0 0 auto;
}

.niif-toolbar-right .table-toolbar-export-btn {
    height: 31px;
    min-height: 31px;
    padding: 0 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 13px;
    background-color: #1f4f83 !important;
    color: white !important;
    border: 1px solid #1f4f83 !important;
}

.niif-toolbar-right .table-toolbar-export-btn:hover:not(:disabled) {
    background-color: #1a446f !important;
    border-color: #1a446f !important;
}

.niif-toolbar-right .table-toolbar-export-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

/* ========== MODALES ========== */
.modal-header-custom {
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
    padding: 12px 20px;
}

.modal-footer-custom {
    background-color: #f8f9fa;
    border-top: 1px solid #dee2e6;
    padding: 12px 20px;
}

/* ========== ESTILOS DEL MODAL DE EMPRESAS ========== */
.table-active-blue {
    background-color: #e3f0ff !important;
    border-radius: 8px !important;
}

.table-active-blue td {
    background-color: #e3f0ff !important;
}

.custom-scroll-table {
    height: 250px;
    min-height: 250px;
    max-height: 300px;
    overflow-y: auto;
    position: relative;
}

.custom-scroll-table::-webkit-scrollbar {
    width: 8px;
}

.custom-scroll-table::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.custom-scroll-table::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
}

.custom-scroll-table::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.uniform-modal-body {
    padding: 8px 4px 4px 4px;
}

.uniform-actions-wrap {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #e9ecef;
}

.reset-btn-secondary {
    background-color: #f8f9fa !important;
    border: 1px solid #ced4da !important;
    color: #495057 !important;
}

.reset-btn-secondary:hover:not(:disabled) {
    background-color: #e9ecef !important;
    border-color: #adb5bd !important;
}

.reset-btn-primary {
    background-color: #2e507a !important;
    border: 1px solid #2e507a !important;
    color: white !important;
}

.reset-btn-primary:hover:not(:disabled) {
    background-color: #1f3f62 !important;
    border-color: #1f3f62 !important;
}

.reset-btn-primary:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

/* ========== ESTILOS DE FLECHA Y TÍTULO ========== */
.page-back-btn {
    padding: 0;
    font-size: 1.5rem;
    line-height: 1;
}

.back-icon {
    font-size: 1.75rem !important;
    width: 1.75rem !important;
    height: 1.75rem !important;
}

.param-title {
    font-size: 2rem !important;
    font-weight: 500;
}

/* ========== SWITCH TOGGLE ========== */
.compact-toggle-container {
    display: flex;
    align-items: center;
    gap: 8px;
}

.compact-switch {
    position: relative;
    display: inline-block;
    width: 44px;
    height: 24px;
    flex-shrink: 0;
}

.compact-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.compact-switch .compact-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .3s;
    border-radius: 24px;
}

.compact-switch .compact-slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: .3s;
    border-radius: 50%;
}

.compact-switch input:checked + .compact-slider {
    background-color: #1f4f83;
}

.compact-switch input:checked + .compact-slider:before {
    transform: translateX(20px);
}

/* ========== TABLA TBM ========== */
.tbm-table-container {
    background: #f8f9fa;
}

.tbm-table-row:hover {
    background-color: #e3f0ff !important;
}

.tbm-table-cell .cell-input {
    background-color: white !important;
    border: 1px solid #ced4da !important;
    transition: all 0.2s;
}

.tbm-table-cell .cell-input:focus {
    border-color: #2e507a !important;
    box-shadow: 0 0 0 0.2rem rgba(46, 80, 122, 0.25) !important;
}

/* ========== RESPONSIVE ========== */
@media (max-width: 1200px) {
    .niif-header .filter-select {
        min-width: 160px;
        max-width: 220px;
        height: 36px;
        font-size: 13px;
    }

    .niif-header .consult-btn,
    .filter-dropdown .filter-dropdown-btn {
        height: 36px;
        min-height: 36px;
        font-size: 13px;
        padding: 0 16px;
    }
}

@media (max-width: 992px) {
    .niif-header .filters-container {
        flex-wrap: wrap;
        width: 100%;
        margin-top: 8px;
        margin-left: 0 !important;
        justify-content: flex-start;
        gap: 6px;
    }

    .niif-header .filter-select {
        min-width: 150px;
        max-width: 200px;
        height: 36px;
        font-size: 13px;
        flex: 1 1 auto;
    }

    .niif-header .consult-btn,
    .filter-dropdown .filter-dropdown-btn {
        height: 36px;
        min-height: 36px;
        font-size: 13px;
        padding: 0 16px;
    }
}

@media (max-width: 768px) {
    .niif-toolbar-right {
        flex-wrap: wrap;
        justify-content: flex-start;
    }

    .compact-toggle-container {
        width: 100%;
        justify-content: center;
    }
}

@media (max-width: 576px) {
    .param-title {
        font-size: 1.5rem !important;
    }

    .niif-header .filter-select {
        min-width: 100%;
        max-width: 100%;
        height: 36px;
        font-size: 13px;
        flex: 0 0 100%;
    }

    .niif-header .filters-container {
        gap: 4px;
    }

    .niif-header .consult-btn,
    .filter-dropdown .filter-dropdown-btn {
        width: 100%;
        flex: 0 0 100%;
        height: 36px;
        margin-left: 0 !important;
        margin-top: 4px;
        font-size: 13px;
        padding: 0 16px;
    }

    .tbm-table-container {
        padding: 10px !important;
    }

    .tbm-table-container .table-responsive {
        font-size: 12px;
    }
}
</style>
